function $9481eb156b453e62$var$e(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $9481eb156b453e62$var$t(t) {
    for(var n = 1; n < arguments.length; n++){
        var r = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $9481eb156b453e62$var$e(Object(r), !0).forEach(function(e) {
            $9481eb156b453e62$var$s(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $9481eb156b453e62$var$e(Object(r)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
    }
    return t;
}
function $9481eb156b453e62$var$n(e) {
    return $9481eb156b453e62$var$n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, $9481eb156b453e62$var$n(e);
}
function $9481eb156b453e62$var$r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $9481eb156b453e62$var$i(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
}
function $9481eb156b453e62$var$o(e, t, n) {
    return t && $9481eb156b453e62$var$i(e.prototype, t), n && $9481eb156b453e62$var$i(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $9481eb156b453e62$var$s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $9481eb156b453e62$var$a(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t && $9481eb156b453e62$var$l(e, t);
}
function $9481eb156b453e62$var$u(e) {
    return $9481eb156b453e62$var$u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    }, $9481eb156b453e62$var$u(e);
}
function $9481eb156b453e62$var$l(e, t) {
    return $9481eb156b453e62$var$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e;
    }, $9481eb156b453e62$var$l(e, t);
}
function $9481eb156b453e62$var$c(e, t) {
    if (null == e) return {};
    var n, r, i = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, o = Object.keys(e);
        for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
    return i;
}
function $9481eb156b453e62$var$d(e, t) {
    if (t && ("object" == typeof t || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return function(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }(e);
}
function $9481eb156b453e62$var$f(e) {
    var t = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (e) {
            return !1;
        }
    }();
    return function() {
        var n, r = $9481eb156b453e62$var$u(e);
        if (t) {
            var i = $9481eb156b453e62$var$u(this).constructor;
            n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);
        return $9481eb156b453e62$var$d(this, n);
    };
}
function $9481eb156b453e62$var$h(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == n) return;
        var r, i, o = [], s = !0, a = !1;
        try {
            for(n = n.call(e); !(s = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); s = !0);
        } catch (e) {
            a = !0, i = e;
        } finally{
            try {
                s || null == n.return || n.return();
            } finally{
                if (a) throw i;
            }
        }
        return o;
    }(e, t) || $9481eb156b453e62$var$_(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $9481eb156b453e62$var$p(e) {
    return function(e) {
        if (Array.isArray(e)) return $9481eb156b453e62$var$g(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || $9481eb156b453e62$var$_(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $9481eb156b453e62$var$_(e, t) {
    if (e) {
        if ("string" == typeof e) return $9481eb156b453e62$var$g(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $9481eb156b453e62$var$g(e, t) : void 0;
    }
}
function $9481eb156b453e62$var$g(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
    return r;
}
function $9481eb156b453e62$var$v(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = $9481eb156b453e62$var$_(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0, i = function() {};
            return {
                s: i,
                n: function() {
                    return r >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[r++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: i
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, s = !0, a = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return s = e.done, e;
        },
        e: function(e) {
            a = !0, o = e;
        },
        f: function() {
            try {
                s || null == n.return || n.return();
            } finally{
                if (a) throw o;
            }
        }
    };
}
var $9481eb156b453e62$var$m = {
    DEBUG: !1,
    LIB_VERSION: "1.110.0"
}, $9481eb156b453e62$var$y = Array.isArray, $9481eb156b453e62$var$b = Object.prototype, $9481eb156b453e62$var$w = $9481eb156b453e62$var$b.hasOwnProperty, $9481eb156b453e62$var$k = $9481eb156b453e62$var$b.toString, $9481eb156b453e62$var$S = $9481eb156b453e62$var$y || function(e) {
    return "[object Array]" === $9481eb156b453e62$var$k.call(e);
}, $9481eb156b453e62$var$F = function(e) {
    return "[object Uint8Array]" === $9481eb156b453e62$var$k.call(e);
}, $9481eb156b453e62$var$R = function(e) {
    return "function" == typeof e;
}, $9481eb156b453e62$var$P = function(e) {
    return e === Object(e) && !$9481eb156b453e62$var$S(e);
}, $9481eb156b453e62$var$E = function(e) {
    return void 0 === e;
}, $9481eb156b453e62$var$x = function(e) {
    return "[object String]" == $9481eb156b453e62$var$k.call(e);
}, $9481eb156b453e62$var$I = function(e) {
    return null === e;
}, $9481eb156b453e62$var$C = function(e) {
    return $9481eb156b453e62$var$E(e) || $9481eb156b453e62$var$I(e);
}, $9481eb156b453e62$var$T = function(e) {
    return "[object Number]" == $9481eb156b453e62$var$k.call(e);
}, $9481eb156b453e62$var$$ = function(e) {
    return "[object Boolean]" === $9481eb156b453e62$var$k.call(e);
}, $9481eb156b453e62$var$O = function(e) {
    return e instanceof FormData;
}, $9481eb156b453e62$var$A = "undefined" != typeof window ? window : void 0, $9481eb156b453e62$var$q = "undefined" != typeof globalThis ? globalThis : $9481eb156b453e62$var$A, $9481eb156b453e62$var$M = Array.prototype, $9481eb156b453e62$var$D = $9481eb156b453e62$var$M.forEach, $9481eb156b453e62$var$N = $9481eb156b453e62$var$M.indexOf, $9481eb156b453e62$var$L = null == $9481eb156b453e62$var$q ? void 0 : $9481eb156b453e62$var$q.navigator, $9481eb156b453e62$var$B = null == $9481eb156b453e62$var$q ? void 0 : $9481eb156b453e62$var$q.document, $9481eb156b453e62$var$j = null == $9481eb156b453e62$var$q ? void 0 : $9481eb156b453e62$var$q.location, $9481eb156b453e62$var$H = null == $9481eb156b453e62$var$q ? void 0 : $9481eb156b453e62$var$q.fetch, $9481eb156b453e62$var$U = null == $9481eb156b453e62$var$q ? void 0 : $9481eb156b453e62$var$q.XMLHttpRequest, $9481eb156b453e62$var$V = null == $9481eb156b453e62$var$L ? void 0 : $9481eb156b453e62$var$L.userAgent, $9481eb156b453e62$var$W = null != $9481eb156b453e62$var$A ? $9481eb156b453e62$var$A : {}, $9481eb156b453e62$var$z = "[PostHog.js]", $9481eb156b453e62$var$G = {
    _log: function(e) {
        if ($9481eb156b453e62$var$A && ($9481eb156b453e62$var$m.DEBUG || $9481eb156b453e62$var$W.POSTHOG_DEBUG) && !$9481eb156b453e62$var$E($9481eb156b453e62$var$A.console) && $9481eb156b453e62$var$A.console) {
            for(var t = ("__rrweb_original__" in $9481eb156b453e62$var$A.console[e]) ? $9481eb156b453e62$var$A.console[e].__rrweb_original__ : $9481eb156b453e62$var$A.console[e], n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)r[i - 1] = arguments[i];
            t.apply(void 0, [
                $9481eb156b453e62$var$z
            ].concat(r));
        }
    },
    info: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$G._log.apply($9481eb156b453e62$var$G, [
            "log"
        ].concat(t));
    },
    warn: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$G._log.apply($9481eb156b453e62$var$G, [
            "warn"
        ].concat(t));
    },
    error: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$G._log.apply($9481eb156b453e62$var$G, [
            "error"
        ].concat(t));
    },
    critical: function() {
        for(var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        (e = console).error.apply(e, [
            $9481eb156b453e62$var$z
        ].concat(n));
    },
    uninitializedWarning: function(e) {
        $9481eb156b453e62$var$G.error("You must initialize PostHog before calling ".concat(e));
    }
}, $9481eb156b453e62$var$Q = {}, $9481eb156b453e62$var$Y = function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
function $9481eb156b453e62$var$J(e, t, n) {
    if ($9481eb156b453e62$var$S(e)) {
        if ($9481eb156b453e62$var$D && e.forEach === $9481eb156b453e62$var$D) e.forEach(t, n);
        else if ("length" in e && e.length === +e.length) {
            for(var r = 0, i = e.length; r < i; r++)if (r in e && t.call(n, e[r], r) === $9481eb156b453e62$var$Q) return;
        }
    }
}
function $9481eb156b453e62$var$K(e, t, n) {
    if (!$9481eb156b453e62$var$C(e)) {
        if ($9481eb156b453e62$var$S(e)) return $9481eb156b453e62$var$J(e, t, n);
        if ($9481eb156b453e62$var$O(e)) {
            var r, i = $9481eb156b453e62$var$v(e.entries());
            try {
                for(i.s(); !(r = i.n()).done;){
                    var o = r.value;
                    if (t.call(n, o[1], o[0]) === $9481eb156b453e62$var$Q) return;
                }
            } catch (e) {
                i.e(e);
            } finally{
                i.f();
            }
        } else for(var s in e)if ($9481eb156b453e62$var$w.call(e, s) && t.call(n, e[s], s) === $9481eb156b453e62$var$Q) return;
    }
}
var $9481eb156b453e62$var$X = function(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $9481eb156b453e62$var$J(n, function(t) {
        for(var n in t)void 0 !== t[n] && (e[n] = t[n]);
    }), e;
};
function $9481eb156b453e62$var$Z(e, t) {
    return -1 !== e.indexOf(t);
}
function $9481eb156b453e62$var$ee(e) {
    for(var t = Object.keys(e), n = t.length, r = new Array(n); n--;)r[n] = [
        t[n],
        e[t[n]]
    ];
    return r;
}
var $9481eb156b453e62$var$te = function() {
    return Date.now = Date.now || function() {
        return +new Date;
    }, Date.now();
}, $9481eb156b453e62$var$ne = function(e) {
    try {
        return e();
    } catch (e) {
        return;
    }
}, $9481eb156b453e62$var$re = function(e) {
    return function() {
        try {
            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
            return e.apply(this, n);
        } catch (e) {
            $9481eb156b453e62$var$G.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $9481eb156b453e62$var$G.critical(e);
        }
    };
}, $9481eb156b453e62$var$ie = function(e) {
    var t = {};
    return $9481eb156b453e62$var$K(e, function(e, n) {
        $9481eb156b453e62$var$x(e) && e.length > 0 && (t[n] = e);
    }), t;
};
function $9481eb156b453e62$var$oe(e, t) {
    var n, r, i;
    return n = e, r = function(e) {
        return $9481eb156b453e62$var$x(e) && !$9481eb156b453e62$var$I(t) ? e.slice(0, t) : e;
    }, i = new Set, function e(t, n) {
        var o;
        return t !== Object(t) ? r ? r(t, n) : t : i.has(t) ? void 0 : (i.add(t), $9481eb156b453e62$var$S(t) ? (o = [], $9481eb156b453e62$var$J(t, function(t) {
            o.push(e(t));
        })) : (o = {}, $9481eb156b453e62$var$K(t, function(t, n) {
            i.has(t) || (o[n] = e(t, n));
        })), o);
    }(n);
}
function $9481eb156b453e62$var$se(e) {
    var t, n, r, i, o, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, u = 0, l = "", c = [];
    if (!e) return e;
    e = $9481eb156b453e62$var$ae(e);
    do t = (o = e.charCodeAt(a++) << 16 | e.charCodeAt(a++) << 8 | e.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, c[u++] = s.charAt(t) + s.charAt(n) + s.charAt(r) + s.charAt(i);
    while (a < e.length);
    switch(l = c.join(""), e.length % 3){
        case 1:
            l = l.slice(0, -2) + "==";
            break;
        case 2:
            l = l.slice(0, -1) + "=";
    }
    return l;
}
var $9481eb156b453e62$var$ae = function(e) {
    var t, n, r, i, o = "";
    for(t = n = 0, r = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, i = 0; i < r; i++){
        var s = e.charCodeAt(i), a = null;
        s < 128 ? n++ : a = s > 127 && s < 2048 ? String.fromCharCode(s >> 6 | 192, 63 & s | 128) : String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, 63 & s | 128), $9481eb156b453e62$var$I(a) || (n > t && (o += e.substring(t, n)), o += a, t = n = i + 1);
    }
    return n > t && (o += e.substring(t, e.length)), o;
}, $9481eb156b453e62$var$ue = function() {
    function e(t) {
        return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation), t;
    }
    return e.preventDefault = function() {
        this.returnValue = !1;
    }, e.stopPropagation = function() {
        this.cancelBubble = !0;
    }, function(t, n, r, i, o) {
        if (t) {
            if (t.addEventListener && !i) t.addEventListener(n, r, !!o);
            else {
                var s = "on" + n, a = t[s];
                t[s] = function(t, n, r) {
                    return function(i) {
                        if (i = i || e(null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.event)) {
                            var o, s = !0;
                            $9481eb156b453e62$var$R(r) && (o = r(i));
                            var a = n.call(t, i);
                            return !1 !== o && !1 !== a || (s = !1), s;
                        }
                    };
                }(t, r, a);
            }
        } else $9481eb156b453e62$var$G.error("No valid element provided to register_event");
    };
}();
function $9481eb156b453e62$var$le(e, t) {
    var n = function() {
        if (!$9481eb156b453e62$var$B) return t("document not found");
        var n = $9481eb156b453e62$var$B.createElement("script");
        n.type = "text/javascript", n.src = e, n.onload = function(e) {
            return t(void 0, e);
        }, n.onerror = function(e) {
            return t(e);
        };
        var r, i = $9481eb156b453e62$var$B.querySelectorAll("body > script");
        i.length > 0 ? null === (r = i[0].parentNode) || void 0 === r || r.insertBefore(n, i[0]) : $9481eb156b453e62$var$B.body.appendChild(n);
    };
    null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.body ? n() : null == $9481eb156b453e62$var$B || $9481eb156b453e62$var$B.addEventListener("DOMContentLoaded", n);
}
function $9481eb156b453e62$var$ce(e) {
    return e ? $9481eb156b453e62$var$Y(e).split(/\s+/) : [];
}
function $9481eb156b453e62$var$de(e) {
    var t = "";
    switch($9481eb156b453e62$var$n(e.className)){
        case "string":
            t = e.className;
            break;
        case "object":
            t = ("baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
            break;
        default:
            t = "";
    }
    return $9481eb156b453e62$var$ce(t);
}
function $9481eb156b453e62$var$fe(e) {
    var t = "";
    return $9481eb156b453e62$var$be(e) && !$9481eb156b453e62$var$we(e) && e.childNodes && e.childNodes.length && $9481eb156b453e62$var$K(e.childNodes, function(e) {
        $9481eb156b453e62$var$_e(e) && e.textContent && (t += $9481eb156b453e62$var$Y(e.textContent).split(/(\s+)/).filter($9481eb156b453e62$var$ke).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255));
    }), $9481eb156b453e62$var$Y(t);
}
function $9481eb156b453e62$var$he(e) {
    return !!e && 1 === e.nodeType;
}
function $9481eb156b453e62$var$pe(e, t) {
    return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function $9481eb156b453e62$var$_e(e) {
    return !!e && 3 === e.nodeType;
}
function $9481eb156b453e62$var$ge(e) {
    return !!e && 11 === e.nodeType;
}
var $9481eb156b453e62$var$ve = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $9481eb156b453e62$var$me(e) {
    var t = e.parentNode;
    return !(!t || !$9481eb156b453e62$var$he(t)) && t;
}
function $9481eb156b453e62$var$ye(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
    if (!$9481eb156b453e62$var$A || !e || $9481eb156b453e62$var$pe(e, "html") || !$9481eb156b453e62$var$he(e)) return !1;
    if (null != r && r.url_allowlist) {
        var i = $9481eb156b453e62$var$A.location.href, o = r.url_allowlist;
        if (o && !o.some(function(e) {
            return i.match(e);
        })) return !1;
    }
    if (null != r && r.dom_event_allowlist) {
        var s = r.dom_event_allowlist;
        if (s && !s.some(function(e) {
            return t.type === e;
        })) return !1;
    }
    for(var a = !1, u = [
        e
    ], l = !0, c = e; c.parentNode && !$9481eb156b453e62$var$pe(c, "body");)if ($9481eb156b453e62$var$ge(c.parentNode)) u.push(c.parentNode.host), c = c.parentNode.host;
    else {
        if (!(l = $9481eb156b453e62$var$me(c))) break;
        if ($9481eb156b453e62$var$ve.indexOf(l.tagName.toLowerCase()) > -1) a = !0;
        else {
            var d = $9481eb156b453e62$var$A.getComputedStyle(l);
            d && "pointer" === d.getPropertyValue("cursor") && (a = !0);
        }
        u.push(l), c = l;
    }
    if (!function(e, t) {
        var r = null == t ? void 0 : t.element_allowlist;
        if ($9481eb156b453e62$var$E(r)) return !0;
        var i, o = $9481eb156b453e62$var$v(e);
        try {
            var s = function() {
                var e = i.value;
                if (r.some(function(t) {
                    return e.tagName.toLowerCase() === t;
                })) return {
                    v: !0
                };
            };
            for(o.s(); !(i = o.n()).done;){
                var a = s();
                if ("object" === $9481eb156b453e62$var$n(a)) return a.v;
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        return !1;
    }(u, r)) return !1;
    if (!function(e, t) {
        var r = null == t ? void 0 : t.css_selector_allowlist;
        if ($9481eb156b453e62$var$E(r)) return !0;
        var i, o = $9481eb156b453e62$var$v(e);
        try {
            var s = function() {
                var e = i.value;
                if (r.some(function(t) {
                    return e.matches(t);
                })) return {
                    v: !0
                };
            };
            for(o.s(); !(i = o.n()).done;){
                var a = s();
                if ("object" === $9481eb156b453e62$var$n(a)) return a.v;
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        return !1;
    }(u, r)) return !1;
    var f = $9481eb156b453e62$var$A.getComputedStyle(e);
    if (f && "pointer" === f.getPropertyValue("cursor") && "click" === t.type) return !0;
    var h = e.tagName.toLowerCase();
    switch(h){
        case "html":
            return !1;
        case "form":
            return "submit" === t.type;
        case "input":
        case "select":
        case "textarea":
            return "change" === t.type || "click" === t.type;
        default:
            return a ? "click" === t.type : "click" === t.type && ($9481eb156b453e62$var$ve.indexOf(h) > -1 || "true" === e.getAttribute("contenteditable"));
    }
}
function $9481eb156b453e62$var$be(e) {
    for(var t = e; t.parentNode && !$9481eb156b453e62$var$pe(t, "body"); t = t.parentNode){
        var n = $9481eb156b453e62$var$de(t);
        if ($9481eb156b453e62$var$Z(n, "ph-sensitive") || $9481eb156b453e62$var$Z(n, "ph-no-capture")) return !1;
    }
    if ($9481eb156b453e62$var$Z($9481eb156b453e62$var$de(e), "ph-include")) return !0;
    var r = e.type || "";
    if ($9481eb156b453e62$var$x(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var i = e.name || e.id || "";
    if ($9481eb156b453e62$var$x(i)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(i.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $9481eb156b453e62$var$we(e) {
    return !!($9481eb156b453e62$var$pe(e, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(e.type) || $9481eb156b453e62$var$pe(e, "select") || $9481eb156b453e62$var$pe(e, "textarea") || "true" === e.getAttribute("contenteditable"));
}
function $9481eb156b453e62$var$ke(e) {
    if ($9481eb156b453e62$var$C(e)) return !1;
    if ($9481eb156b453e62$var$x(e)) {
        e = $9481eb156b453e62$var$Y(e);
        if (/^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/.test((e || "").replace(/[- ]/g, ""))) return !1;
        if (/(^\d{3}-?\d{2}-?\d{4}$)/.test(e)) return !1;
    }
    return !0;
}
function $9481eb156b453e62$var$Se(e) {
    var t = $9481eb156b453e62$var$fe(e);
    return $9481eb156b453e62$var$ke(t = "".concat(t, " ").concat($9481eb156b453e62$var$Fe(e)).trim()) ? t : "";
}
function $9481eb156b453e62$var$Fe(e) {
    var t = "";
    return e && e.childNodes && e.childNodes.length && $9481eb156b453e62$var$K(e.childNodes, function(e) {
        var n;
        if (e && "span" === (null === (n = e.tagName) || void 0 === n ? void 0 : n.toLowerCase())) try {
            var r = $9481eb156b453e62$var$fe(e);
            t = "".concat(t, " ").concat(r).trim(), e.childNodes && e.childNodes.length && (t = "".concat(t, " ").concat($9481eb156b453e62$var$Fe(e)).trim());
        } catch (e) {
            $9481eb156b453e62$var$G.error(e);
        }
    }), t;
}
function $9481eb156b453e62$var$Re(e) {
    return function(e) {
        var n = e.map(function(e) {
            var n, r, i = "";
            if (e.tag_name && (i += e.tag_name), e.attr_class) {
                e.attr_class.sort();
                var o, s = $9481eb156b453e62$var$v(e.attr_class);
                try {
                    for(s.s(); !(o = s.n()).done;){
                        var a = o.value;
                        i += ".".concat(a.replace(/"/g, ""));
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
            }
            var u = $9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, e.text ? {
                text: e.text
            } : {}), {}, {
                "nth-child": null !== (n = e.nth_child) && void 0 !== n ? n : 0,
                "nth-of-type": null !== (r = e.nth_of_type) && void 0 !== r ? r : 0
            }, e.href ? {
                href: e.href
            } : {}), e.attr_id ? {
                attr_id: e.attr_id
            } : {}), e.attributes), l = {};
            return $9481eb156b453e62$var$ee(u).sort(function(e, t) {
                var n = $9481eb156b453e62$var$h(e, 1)[0], r = $9481eb156b453e62$var$h(t, 1)[0];
                return n.localeCompare(r);
            }).forEach(function(e) {
                var t = $9481eb156b453e62$var$h(e, 2), n = t[0], r = t[1];
                return l[$9481eb156b453e62$var$Pe(n.toString())] = $9481eb156b453e62$var$Pe(r.toString());
            }), i += ":", i += $9481eb156b453e62$var$ee(u).map(function(e) {
                var t = $9481eb156b453e62$var$h(e, 2), n = t[0], r = t[1];
                return "".concat(n, '="').concat(r, '"');
            }).join("");
        });
        return n.join(";");
    }(function(e) {
        return e.map(function(e) {
            var t, n, r = {
                text: null === (t = e.$el_text) || void 0 === t ? void 0 : t.slice(0, 400),
                tag_name: e.tag_name,
                href: null === (n = e.attr__href) || void 0 === n ? void 0 : n.slice(0, 2048),
                attr_class: $9481eb156b453e62$var$Ee(e),
                attr_id: e.attr__id,
                nth_child: e.nth_child,
                nth_of_type: e.nth_of_type,
                attributes: {}
            };
            return $9481eb156b453e62$var$ee(e).filter(function(e) {
                return 0 === $9481eb156b453e62$var$h(e, 1)[0].indexOf("attr__");
            }).forEach(function(e) {
                var t = $9481eb156b453e62$var$h(e, 2), n = t[0], i = t[1];
                return r.attributes[n] = i;
            }), r;
        });
    }(e));
}
function $9481eb156b453e62$var$Pe(e) {
    return e.replace(/"|\\"/g, '\\"');
}
function $9481eb156b453e62$var$Ee(e) {
    var t = e.attr__class;
    return t ? $9481eb156b453e62$var$S(t) ? t : $9481eb156b453e62$var$ce(t) : void 0;
}
var $9481eb156b453e62$var$xe = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.clicks = [], this.enabled = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "isRageClick",
            value: function(e, t, n) {
                if (!this.enabled) return !1;
                var r = this.clicks[this.clicks.length - 1];
                if (r && Math.abs(e - r.x) + Math.abs(t - r.y) < 30 && n - r.timestamp < 1e3) {
                    if (this.clicks.push({
                        x: e,
                        y: t,
                        timestamp: n
                    }), 3 === this.clicks.length) return !0;
                } else this.clicks = [
                    {
                        x: e,
                        y: t,
                        timestamp: n
                    }
                ];
                return !1;
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Ie = "$people_distinct_id", $9481eb156b453e62$var$Ce = "__alias", $9481eb156b453e62$var$Te = "__timers", $9481eb156b453e62$var$$e = "$autocapture_disabled_server_side", $9481eb156b453e62$var$Oe = "$session_recording_enabled_server_side", $9481eb156b453e62$var$Ae = "$console_log_recording_enabled_server_side", $9481eb156b453e62$var$qe = "$session_recording_recorder_version_server_side", $9481eb156b453e62$var$Me = "$session_recording_network_payload_capture", $9481eb156b453e62$var$De = "$session_recording_canvas_recording", $9481eb156b453e62$var$Ne = "$sesid", $9481eb156b453e62$var$Le = "$session_is_sampled", $9481eb156b453e62$var$Be = "$enabled_feature_flags", $9481eb156b453e62$var$je = "$early_access_features", $9481eb156b453e62$var$He = "$stored_person_properties", $9481eb156b453e62$var$Ue = "$stored_group_properties", $9481eb156b453e62$var$Ve = "$surveys", $9481eb156b453e62$var$We = "$flag_call_reported", $9481eb156b453e62$var$ze = "$user_state", $9481eb156b453e62$var$Ge = "$posthog_quota_limited", $9481eb156b453e62$var$Qe = "$client_session_props", $9481eb156b453e62$var$Ye = [
    $9481eb156b453e62$var$Ie,
    $9481eb156b453e62$var$Ce,
    "__cmpns",
    $9481eb156b453e62$var$Te,
    $9481eb156b453e62$var$Oe,
    $9481eb156b453e62$var$Ne,
    $9481eb156b453e62$var$Be,
    $9481eb156b453e62$var$ze,
    $9481eb156b453e62$var$Ge,
    $9481eb156b453e62$var$je,
    $9481eb156b453e62$var$Ue,
    $9481eb156b453e62$var$He,
    $9481eb156b453e62$var$Ve,
    $9481eb156b453e62$var$We,
    $9481eb156b453e62$var$Qe
];
function $9481eb156b453e62$var$Je(e, t) {
    return t.length > e ? t.slice(0, e) + "..." : t;
}
var $9481eb156b453e62$var$Ke = {
    _initializedTokens: [],
    _isDisabledServerSide: null,
    _isAutocaptureEnabled: !1,
    _setIsAutocaptureEnabled: function(e) {
        var t, n = $9481eb156b453e62$var$I(this._isDisabledServerSide) ? !(null === (t = e.persistence) || void 0 === t || !t.props[$9481eb156b453e62$var$$e]) : this._isDisabledServerSide, r = !!e.config.autocapture;
        this._isAutocaptureEnabled = r && !n;
    },
    _previousElementSibling: function(e) {
        if (e.previousElementSibling) return e.previousElementSibling;
        var t = e;
        do t = t.previousSibling;
        while (t && !$9481eb156b453e62$var$he(t));
        return t;
    },
    _getAugmentPropertiesFromElement: function(e) {
        if (!$9481eb156b453e62$var$be(e)) return {};
        var t = {};
        return $9481eb156b453e62$var$K(e.attributes, function(e) {
            if (0 === e.name.indexOf("data-ph-capture-attribute")) {
                var n = e.name.replace("data-ph-capture-attribute-", ""), r = e.value;
                n && r && $9481eb156b453e62$var$ke(r) && (t[n] = r);
            }
        }), t;
    },
    _getPropertiesFromElement: function(e, t, n) {
        var r, i = e.tagName.toLowerCase(), o = {
            tag_name: i
        };
        $9481eb156b453e62$var$ve.indexOf(i) > -1 && !n && ("a" === i.toLowerCase() || "button" === i.toLowerCase() ? o.$el_text = $9481eb156b453e62$var$Je(1024, $9481eb156b453e62$var$Se(e)) : o.$el_text = $9481eb156b453e62$var$Je(1024, $9481eb156b453e62$var$fe(e)));
        var s = $9481eb156b453e62$var$de(e);
        s.length > 0 && (o.classes = s.filter(function(e) {
            return "" !== e;
        }));
        var a = null === (r = this.config) || void 0 === r ? void 0 : r.element_attribute_ignorelist;
        $9481eb156b453e62$var$K(e.attributes, function(n) {
            var r;
            if ((!$9481eb156b453e62$var$we(e) || -1 !== [
                "name",
                "id",
                "class"
            ].indexOf(n.name)) && (null == a || !a.includes(n.name)) && !t && $9481eb156b453e62$var$ke(n.value) && (r = n.name, !$9481eb156b453e62$var$x(r) || "_ngcontent" !== r.substring(0, 10) && "_nghost" !== r.substring(0, 7))) {
                var i = n.value;
                "class" === n.name && (i = $9481eb156b453e62$var$ce(i).join(" ")), o["attr__" + n.name] = $9481eb156b453e62$var$Je(1024, i);
            }
        });
        for(var u = 1, l = 1, c = e; c = this._previousElementSibling(c);)u++, c.tagName === e.tagName && l++;
        return o.nth_child = u, o.nth_of_type = l, o;
    },
    _getDefaultProperties: function(e) {
        return {
            $event_type: e,
            $ce_version: 1
        };
    },
    _extractCustomPropertyValue: function(e) {
        var t = [];
        return $9481eb156b453e62$var$K(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll(e.css_selector), function(e) {
            var n;
            [
                "input",
                "select"
            ].indexOf(e.tagName.toLowerCase()) > -1 ? n = e.value : e.textContent && (n = e.textContent), $9481eb156b453e62$var$ke(n) && t.push(n);
        }), t.join(", ");
    },
    _getCustomProperties: function(e) {
        var t = this, n = {};
        return $9481eb156b453e62$var$K(this._customProperties, function(r) {
            $9481eb156b453e62$var$K(r.event_selectors, function(i) {
                $9481eb156b453e62$var$K(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll(i), function(i) {
                    $9481eb156b453e62$var$Z(e, i) && $9481eb156b453e62$var$be(i) && (n[r.name] = t._extractCustomPropertyValue(r));
                });
            });
        }), n;
    },
    _getEventTarget: function(e) {
        var t;
        return $9481eb156b453e62$var$E(e.target) ? e.srcElement || null : null !== (t = e.target) && void 0 !== t && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
    },
    _captureEvent: function(e, t) {
        var n, r = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "$autocapture", o = this._getEventTarget(e);
        ($9481eb156b453e62$var$_e(o) && (o = o.parentNode || null), "$autocapture" === i && "click" === e.type && e instanceof MouseEvent) && null !== (n = this.rageclicks) && void 0 !== n && n.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._captureEvent(e, t, "$rageclick");
        if (o && $9481eb156b453e62$var$ye(o, e, this.config)) {
            for(var s, a, u = [
                o
            ], l = o; l.parentNode && !$9481eb156b453e62$var$pe(l, "body");)$9481eb156b453e62$var$ge(l.parentNode) ? (u.push(l.parentNode.host), l = l.parentNode.host) : (u.push(l.parentNode), l = l.parentNode);
            var c, d = [], f = {}, h = !1;
            if ($9481eb156b453e62$var$K(u, function(e) {
                var n = $9481eb156b453e62$var$be(e);
                "a" === e.tagName.toLowerCase() && (c = e.getAttribute("href"), c = n && $9481eb156b453e62$var$ke(c) && c), $9481eb156b453e62$var$Z($9481eb156b453e62$var$de(e), "ph-no-capture") && (h = !0), d.push(r._getPropertiesFromElement(e, t.config.mask_all_element_attributes, t.config.mask_all_text));
                var i = r._getAugmentPropertiesFromElement(e);
                $9481eb156b453e62$var$X(f, i);
            }), t.config.mask_all_text || ("a" === o.tagName.toLowerCase() || "button" === o.tagName.toLowerCase() ? d[0].$el_text = $9481eb156b453e62$var$Se(o) : d[0].$el_text = $9481eb156b453e62$var$fe(o)), c && (d[0].attr__href = c), h) return !1;
            var p = $9481eb156b453e62$var$X(this._getDefaultProperties(e.type), t.elementsChainAsString ? {
                $elements_chain: $9481eb156b453e62$var$Re(d)
            } : {
                $elements: d
            }, null !== (s = d[0]) && void 0 !== s && s.$el_text ? {
                $el_text: null === (a = d[0]) || void 0 === a ? void 0 : a.$el_text
            } : {}, this._getCustomProperties(u), f);
            return t.capture(i, p), !0;
        }
    },
    _navigate: function(e) {
        $9481eb156b453e62$var$A && ($9481eb156b453e62$var$A.location.href = e);
    },
    _addDomEventHandlers: function(e) {
        var t = this;
        if ($9481eb156b453e62$var$A && $9481eb156b453e62$var$B) {
            var n = function(n) {
                n = n || (null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.event), t._captureEvent(n, e);
            };
            $9481eb156b453e62$var$ue($9481eb156b453e62$var$B, "submit", n, !1, !0), $9481eb156b453e62$var$ue($9481eb156b453e62$var$B, "change", n, !1, !0), $9481eb156b453e62$var$ue($9481eb156b453e62$var$B, "click", n, !1, !0);
        }
    },
    _customProperties: [],
    rageclicks: null,
    config: void 0,
    init: function(e) {
        var t;
        $9481eb156b453e62$var$$(e.__autocapture) || (this.config = e.__autocapture), null !== (t = this.config) && void 0 !== t && t.url_allowlist && (this.config.url_allowlist = this.config.url_allowlist.map(function(e) {
            return new RegExp(e);
        })), this.rageclicks = new $9481eb156b453e62$var$xe(e.config.rageclick);
    },
    afterDecideResponse: function(e, t) {
        var n = t.config.token;
        this._initializedTokens.indexOf(n) > -1 ? $9481eb156b453e62$var$G.info('autocapture already initialized for token "' + n + '"') : (t.persistence && t.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$$e, !!e.autocapture_opt_out)), this._isDisabledServerSide = !!e.autocapture_opt_out, this._setIsAutocaptureEnabled(t), this._initializedTokens.push(n), e && e.config && e.config.enable_collect_everything && this._isAutocaptureEnabled ? (e.custom_properties && (this._customProperties = e.custom_properties), this._addDomEventHandlers(t)) : t.__autocapture = !1);
    },
    enabledForProject: function(e, t, n) {
        if (!e) return !0;
        t = $9481eb156b453e62$var$E(t) ? 10 : t, n = $9481eb156b453e62$var$E(n) ? 10 : n;
        for(var r = 0, i = 0; i < e.length; i++)r += e.charCodeAt(i);
        return r % t < n;
    },
    isBrowserSupported: function() {
        return $9481eb156b453e62$var$R(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll);
    }
};
!function(e) {
    for(var t in e)$9481eb156b453e62$var$R(e[t]) && (e[t] = e[t].bind(e));
}($9481eb156b453e62$var$Ke), function(e) {
    for(var t in e)$9481eb156b453e62$var$R(e[t]) && (e[t] = $9481eb156b453e62$var$re(e[t]));
}($9481eb156b453e62$var$Ke);
var $9481eb156b453e62$var$Xe = "$active_feature_flags", $9481eb156b453e62$var$Ze = "$override_feature_flags", $9481eb156b453e62$var$et = "$feature_flag_payloads", $9481eb156b453e62$var$tt = function(e) {
    var t, n = {}, r = $9481eb156b453e62$var$v($9481eb156b453e62$var$ee(e || {}));
    try {
        for(r.s(); !(t = r.n()).done;){
            var i = $9481eb156b453e62$var$h(t.value, 2), o = i[0], s = i[1];
            s && (n[o] = s);
        }
    } catch (e) {
        r.e(e);
    } finally{
        r.f();
    }
    return n;
}, $9481eb156b453e62$var$nt = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t, this._override_warning = !1, this.featureFlagEventHandlers = [], this.reloadFeatureFlagsQueued = !1, this.reloadFeatureFlagsInAction = !1;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "getFlags",
            value: function() {
                return Object.keys(this.getFlagVariants());
            }
        },
        {
            key: "getFlagVariants",
            value: function() {
                var e = this.instance.get_property($9481eb156b453e62$var$Be), t = this.instance.get_property($9481eb156b453e62$var$Ze);
                if (!t) return e || {};
                for(var n = $9481eb156b453e62$var$X({}, e), r = Object.keys(t), i = 0; i < r.length; i++)!1 === t[r[i]] ? delete n[r[i]] : n[r[i]] = t[r[i]];
                return this._override_warning || ($9481eb156b453e62$var$G.warn(" Overriding feature flags!", {
                    enabledFlags: e,
                    overriddenFlags: t,
                    finalFlags: n
                }), this._override_warning = !0), n;
            }
        },
        {
            key: "getFlagPayloads",
            value: function() {
                return this.instance.get_property($9481eb156b453e62$var$et) || {};
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.reloadFeatureFlagsQueued || (this.reloadFeatureFlagsQueued = !0, this._startReloadTimer());
            }
        },
        {
            key: "setAnonymousDistinctId",
            value: function(e) {
                this.$anon_distinct_id = e;
            }
        },
        {
            key: "setReloadingPaused",
            value: function(e) {
                this.reloadFeatureFlagsInAction = e;
            }
        },
        {
            key: "resetRequestQueue",
            value: function() {
                this.reloadFeatureFlagsQueued = !1;
            }
        },
        {
            key: "_startReloadTimer",
            value: function() {
                var e = this;
                this.reloadFeatureFlagsQueued && !this.reloadFeatureFlagsInAction && setTimeout(function() {
                    !e.reloadFeatureFlagsInAction && e.reloadFeatureFlagsQueued && (e.reloadFeatureFlagsQueued = !1, e._reloadFeatureFlagsRequest());
                }, 5);
            }
        },
        {
            key: "_reloadFeatureFlagsRequest",
            value: function() {
                var e = this;
                if (!this.instance.config.advanced_disable_feature_flags) {
                    this.setReloadingPaused(!0);
                    var t = this.instance.config.token, n = this.instance.get_property($9481eb156b453e62$var$He), r = this.instance.get_property($9481eb156b453e62$var$Ue), i = $9481eb156b453e62$var$se(JSON.stringify({
                        token: t,
                        distinct_id: this.instance.get_distinct_id(),
                        groups: this.instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: n,
                        group_properties: r,
                        disable_flags: this.instance.config.advanced_disable_feature_flags || void 0
                    }));
                    this.instance._send_request(this.instance.requestRouter.endpointFor("api", "/decide/?v=3"), {
                        data: i
                    }, {
                        method: "POST"
                    }, this.instance._prepare_callback(function(t) {
                        e.$anon_distinct_id = void 0, e.receivedFeatureFlags(t), e.setReloadingPaused(!1), e._startReloadTimer();
                    }));
                }
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) {
                    var n, r = this.getFlagVariants()[e], i = "".concat(r), o = this.instance.get_property($9481eb156b453e62$var$We) || {};
                    if (t.send_event || !("send_event" in t)) {
                        if (!(e in o) || !o[e].includes(i)) $9481eb156b453e62$var$S(o[e]) ? o[e].push(i) : o[e] = [
                            i
                        ], null === (n = this.instance.persistence) || void 0 === n || n.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$We, o)), this.instance.capture("$feature_flag_called", {
                            $feature_flag: e,
                            $feature_flag_response: r
                        });
                    }
                    return r;
                }
                $9481eb156b453e62$var$G.warn('getFeatureFlag for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                return this.getFlagPayloads()[e];
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(e, t);
                $9481eb156b453e62$var$G.warn('isFeatureEnabled for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "addFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers.push(e);
            }
        },
        {
            key: "removeFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter(function(t) {
                    return t !== e;
                });
            }
        },
        {
            key: "receivedFeatureFlags",
            value: function(e) {
                if (this.instance.persistence) {
                    this.instance.decideEndpointWasHit = !0;
                    var n = this.getFlagVariants(), r = this.getFlagPayloads();
                    !function(e, n) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o = e.featureFlags, a = e.featureFlagPayloads;
                        if (o) {
                            if ($9481eb156b453e62$var$S(o)) {
                                var u, l = {};
                                if (o) for(var c = 0; c < o.length; c++)l[o[c]] = !0;
                                n && n.register(($9481eb156b453e62$var$s(u = {}, $9481eb156b453e62$var$Xe, o), $9481eb156b453e62$var$s(u, $9481eb156b453e62$var$Be, l), u));
                            } else {
                                var d, f = o, h = a;
                                e.errorsWhileComputingFlags && (f = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), f), h = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, i), h)), n && n.register(($9481eb156b453e62$var$s(d = {}, $9481eb156b453e62$var$Xe, Object.keys($9481eb156b453e62$var$tt(f))), $9481eb156b453e62$var$s(d, $9481eb156b453e62$var$Be, f || {}), $9481eb156b453e62$var$s(d, $9481eb156b453e62$var$et, h || {}), d));
                            }
                        }
                    }(e, this.instance.persistence, n, r), this._fireFeatureFlagsCallbacks();
                }
            }
        },
        {
            key: "override",
            value: function(e) {
                if (!this.instance.__loaded || !this.instance.persistence) return $9481eb156b453e62$var$G.uninitializedWarning("posthog.feature_flags.override");
                if (this._override_warning = !1, !1 === e) this.instance.persistence.unregister($9481eb156b453e62$var$Ze);
                else if ($9481eb156b453e62$var$S(e)) {
                    for(var t = {}, n = 0; n < e.length; n++)t[e[n]] = !0;
                    this.instance.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ze, t));
                } else this.instance.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ze, e));
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                var t = this;
                if (this.addFeatureFlagsHandler(e), this.instance.decideEndpointWasHit) {
                    var n = this._prepareFeatureFlagsForCallbacks(), r = n.flags, i = n.flagVariants;
                    e(r, i);
                }
                return function() {
                    return t.removeFeatureFlagsHandler(e);
                };
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, n) {
                var r, i, o = $9481eb156b453e62$var$s({}, "$feature_enrollment/".concat(e), n);
                this.instance.capture("$feature_enrollment_update", {
                    $feature_flag: e,
                    $feature_enrollment: n,
                    $set: o
                }), this.setPersonPropertiesForFlags(o, !1);
                var a = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.getFlagVariants()), {}, $9481eb156b453e62$var$s({}, e, n));
                null === (r = this.instance.persistence) || void 0 === r || r.register(($9481eb156b453e62$var$s(i = {}, $9481eb156b453e62$var$Xe, Object.keys($9481eb156b453e62$var$tt(a))), $9481eb156b453e62$var$s(i, $9481eb156b453e62$var$Be, a), i)), this._fireFeatureFlagsCallbacks();
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = this.instance.get_property($9481eb156b453e62$var$je);
                if (r && !n) return e(r);
                this.instance._send_request(this.instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=".concat(this.instance.config.token)), {}, {
                    method: "GET"
                }, function(n) {
                    var r, i = n.earlyAccessFeatures;
                    return null === (r = t.instance.persistence) || void 0 === r || r.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$je, i)), e(i);
                });
            }
        },
        {
            key: "_prepareFeatureFlagsForCallbacks",
            value: function() {
                var e = this.getFlags(), t = this.getFlagVariants();
                return {
                    flags: e.filter(function(e) {
                        return t[e];
                    }),
                    flagVariants: Object.keys(t).filter(function(e) {
                        return t[e];
                    }).reduce(function(e, n) {
                        return e[n] = t[n], e;
                    }, {})
                };
            }
        },
        {
            key: "_fireFeatureFlagsCallbacks",
            value: function() {
                var e = this._prepareFeatureFlagsForCallbacks(), t = e.flags, n = e.flagVariants;
                this.featureFlagEventHandlers.forEach(function(e) {
                    return e(t, n);
                });
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = this.instance.get_property($9481eb156b453e62$var$He) || {};
                this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$He, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.instance.unregister($9481eb156b453e62$var$He);
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = this.instance.get_property($9481eb156b453e62$var$Ue) || {};
                0 !== Object.keys(r).length && Object.keys(r).forEach(function(n) {
                    r[n] = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r[n]), e[n]), delete e[n];
                }), this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ue, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                if (e) {
                    var n = this.instance.get_property($9481eb156b453e62$var$Ue) || {};
                    this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ue, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, n), {}, $9481eb156b453e62$var$s({}, e, {}))));
                } else this.instance.unregister($9481eb156b453e62$var$Ue);
            }
        }
    ]), e;
}();
Math.trunc || (Math.trunc = function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
    return $9481eb156b453e62$var$T(e) && isFinite(e) && Math.floor(e) === e;
});
var $9481eb156b453e62$var$rt = "0123456789abcdef", $9481eb156b453e62$var$it = function() {
    function e(t) {
        if ($9481eb156b453e62$var$r(this, e), this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "toString",
            value: function() {
                for(var e = "", t = 0; t < this.bytes.length; t++)e = e + $9481eb156b453e62$var$rt.charAt(this.bytes[t] >>> 4) + $9481eb156b453e62$var$rt.charAt(15 & this.bytes[t]), 3 !== t && 5 !== t && 7 !== t && 9 !== t || (e += "-");
                if (36 !== e.length) throw new Error("Invalid UUIDv7 was generated");
                return e;
            }
        },
        {
            key: "clone",
            value: function() {
                return new e(this.bytes.slice(0));
            }
        },
        {
            key: "equals",
            value: function(e) {
                return 0 === this.compareTo(e);
            }
        },
        {
            key: "compareTo",
            value: function(e) {
                for(var t = 0; t < 16; t++){
                    var n = this.bytes[t] - e.bytes[t];
                    if (0 !== n) return Math.sign(n);
                }
                return 0;
            }
        }
    ], [
        {
            key: "fromFieldsV7",
            value: function(t, n, r, i) {
                if (!Number.isInteger(t) || !Number.isInteger(n) || !Number.isInteger(r) || !Number.isInteger(i) || t < 0 || n < 0 || r < 0 || i < 0 || t > 0xffffffffffff || n > 4095 || r > 1073741823 || i > 4294967295) throw new RangeError("invalid field value");
                var o = new Uint8Array(16);
                return o[0] = t / Math.pow(2, 40), o[1] = t / Math.pow(2, 32), o[2] = t / Math.pow(2, 24), o[3] = t / Math.pow(2, 16), o[4] = t / Math.pow(2, 8), o[5] = t, o[6] = 112 | n >>> 8, o[7] = n, o[8] = 128 | r >>> 24, o[9] = r >>> 16, o[10] = r >>> 8, o[11] = r, o[12] = i >>> 24, o[13] = i >>> 16, o[14] = i >>> 8, o[15] = i, new e(o);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$ot = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "timestamp", 0), $9481eb156b453e62$var$s(this, "counter", 0), $9481eb156b453e62$var$s(this, "random", new $9481eb156b453e62$var$ut);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "generate",
            value: function() {
                var e = this.generateOrAbort();
                if ($9481eb156b453e62$var$E(e)) {
                    this.timestamp = 0;
                    var t = this.generateOrAbort();
                    if ($9481eb156b453e62$var$E(t)) throw new Error("Could not generate UUID after timestamp reset");
                    return t;
                }
                return e;
            }
        },
        {
            key: "generateOrAbort",
            value: function() {
                var e = Date.now();
                if (e > this.timestamp) this.timestamp = e, this.resetCounter();
                else {
                    if (!(e + 1e4 > this.timestamp)) return;
                    this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
                }
                return $9481eb156b453e62$var$it.fromFieldsV7(this.timestamp, Math.trunc(this.counter / Math.pow(2, 30)), this.counter & Math.pow(2, 30) - 1, this.random.nextUint32());
            }
        },
        {
            key: "resetCounter",
            value: function() {
                this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$st = function(e) {
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var t = 0; t < e.length; t++)e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return e;
};
$9481eb156b453e62$var$A && !$9481eb156b453e62$var$E($9481eb156b453e62$var$A.crypto) && crypto.getRandomValues && ($9481eb156b453e62$var$st = function(e) {
    return crypto.getRandomValues(e);
});
var $9481eb156b453e62$var$at, $9481eb156b453e62$var$ut = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "buffer", new Uint32Array(8)), $9481eb156b453e62$var$s(this, "cursor", 1 / 0);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "nextUint32",
            value: function() {
                return this.cursor >= this.buffer.length && ($9481eb156b453e62$var$st(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$lt = function() {
    return $9481eb156b453e62$var$ct().toString();
}, $9481eb156b453e62$var$ct = function() {
    return ($9481eb156b453e62$var$at || ($9481eb156b453e62$var$at = new $9481eb156b453e62$var$ot)).generate();
}, $9481eb156b453e62$var$dt = "Thu, 01 Jan 1970 00:00:00 GMT", $9481eb156b453e62$var$ft = "";
var $9481eb156b453e62$var$ht = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $9481eb156b453e62$var$pt(e, t) {
    if (t) {
        var n = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $9481eb156b453e62$var$B;
            if ($9481eb156b453e62$var$ft) return $9481eb156b453e62$var$ft;
            if (!t) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(e)) return "";
            for(var n = e.split("."), r = Math.min(n.length, 8), i = "dmn_chk_" + $9481eb156b453e62$var$lt(), o = new RegExp("(^|;)\\s*" + i + "=1"); !$9481eb156b453e62$var$ft && r--;){
                var s = n.slice(r).join("."), a = i + "=1;domain=." + s;
                t.cookie = a, o.test(t.cookie) && (t.cookie = a + ";expires=" + $9481eb156b453e62$var$dt, $9481eb156b453e62$var$ft = s);
            }
            return $9481eb156b453e62$var$ft;
        }(e);
        if (!n) {
            var r = function(e) {
                var t = e.match($9481eb156b453e62$var$ht);
                return t ? t[0] : "";
            }(e);
            r !== n && $9481eb156b453e62$var$G.info("Warning: cookie subdomain discovery mismatch", r, n), n = r;
        }
        return n ? "; domain=." + n : "";
    }
    return "";
}
var $9481eb156b453e62$var$_t, $9481eb156b453e62$var$gt = {
    is_supported: function() {
        return !!$9481eb156b453e62$var$B;
    },
    error: function(e) {
        $9481eb156b453e62$var$G.error("cookieStore error: " + e);
    },
    get: function(e) {
        if ($9481eb156b453e62$var$B) {
            try {
                for(var t = e + "=", n = $9481eb156b453e62$var$B.cookie.split(";").filter(function(e) {
                    return e.length;
                }), r = 0; r < n.length; r++){
                    for(var i = n[r]; " " == i.charAt(0);)i = i.substring(1, i.length);
                    if (0 === i.indexOf(t)) return decodeURIComponent(i.substring(t.length, i.length));
                }
            } catch (e) {}
            return null;
        }
    },
    parse: function(e) {
        var t;
        try {
            t = JSON.parse($9481eb156b453e62$var$gt.get(e)) || {};
        } catch (e) {}
        return t;
    },
    set: function(e, t, n, r, i) {
        if ($9481eb156b453e62$var$B) try {
            var o = "", s = "", a = $9481eb156b453e62$var$pt($9481eb156b453e62$var$B.location.hostname, r);
            if (n) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * n * 3600000), o = "; expires=" + u.toUTCString();
            }
            i && (s = "; secure");
            var l = e + "=" + encodeURIComponent(JSON.stringify(t)) + o + "; SameSite=Lax; path=/" + a + s;
            return l.length > 3686.4 && $9481eb156b453e62$var$G.warn("cookieStore warning: large cookie, len=" + l.length), $9481eb156b453e62$var$B.cookie = l, l;
        } catch (e) {
            return;
        }
    },
    remove: function(e, t) {
        try {
            $9481eb156b453e62$var$gt.set(e, "", -1, t);
        } catch (e) {
            return;
        }
    }
}, $9481eb156b453e62$var$vt = null, $9481eb156b453e62$var$mt = {
    is_supported: function() {
        if (!$9481eb156b453e62$var$I($9481eb156b453e62$var$vt)) return $9481eb156b453e62$var$vt;
        var e = !0;
        if ($9481eb156b453e62$var$E($9481eb156b453e62$var$A)) e = !1;
        else try {
            var t = "__mplssupport__";
            $9481eb156b453e62$var$mt.set(t, "xyz"), '"xyz"' !== $9481eb156b453e62$var$mt.get(t) && (e = !1), $9481eb156b453e62$var$mt.remove(t);
        } catch (t) {
            e = !1;
        }
        return e || $9481eb156b453e62$var$G.error("localStorage unsupported; falling back to cookie store"), $9481eb156b453e62$var$vt = e, e;
    },
    error: function(e) {
        $9481eb156b453e62$var$G.error("localStorage error: " + e);
    },
    get: function(e) {
        try {
            return null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.localStorage.getItem(e);
        } catch (e) {
            $9481eb156b453e62$var$mt.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($9481eb156b453e62$var$mt.get(e)) || {};
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.localStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $9481eb156b453e62$var$mt.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.localStorage.removeItem(e);
        } catch (e) {
            $9481eb156b453e62$var$mt.error(e);
        }
    }
}, $9481eb156b453e62$var$yt = [
    "distinct_id",
    $9481eb156b453e62$var$Ne,
    $9481eb156b453e62$var$Le
], $9481eb156b453e62$var$bt = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, $9481eb156b453e62$var$mt), {}, {
    parse: function(e) {
        try {
            var t = {};
            try {
                t = $9481eb156b453e62$var$gt.parse(e) || {};
            } catch (e) {}
            var n = $9481eb156b453e62$var$X(t, JSON.parse($9481eb156b453e62$var$mt.get(e) || "{}"));
            return $9481eb156b453e62$var$mt.set(e, n), n;
        } catch (e) {}
        return null;
    },
    set: function(e, t, n, r, i) {
        try {
            $9481eb156b453e62$var$mt.set(e, t);
            var o = {};
            $9481eb156b453e62$var$yt.forEach(function(e) {
                t[e] && (o[e] = t[e]);
            }), Object.keys(o).length && $9481eb156b453e62$var$gt.set(e, o, n, r, i);
        } catch (e) {
            $9481eb156b453e62$var$mt.error(e);
        }
    },
    remove: function(e, t) {
        try {
            null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.localStorage.removeItem(e), $9481eb156b453e62$var$gt.remove(e, t);
        } catch (e) {
            $9481eb156b453e62$var$mt.error(e);
        }
    }
}), $9481eb156b453e62$var$wt = {}, $9481eb156b453e62$var$kt = {
    is_supported: function() {
        return !0;
    },
    error: function(e) {
        $9481eb156b453e62$var$G.error("memoryStorage error: " + e);
    },
    get: function(e) {
        return $9481eb156b453e62$var$wt[e] || null;
    },
    parse: function(e) {
        return $9481eb156b453e62$var$wt[e] || null;
    },
    set: function(e, t) {
        $9481eb156b453e62$var$wt[e] = t;
    },
    remove: function(e) {
        delete $9481eb156b453e62$var$wt[e];
    }
}, $9481eb156b453e62$var$St = null, $9481eb156b453e62$var$Ft = {
    is_supported: function() {
        if (!$9481eb156b453e62$var$I($9481eb156b453e62$var$St)) return $9481eb156b453e62$var$St;
        if ($9481eb156b453e62$var$St = !0, $9481eb156b453e62$var$E($9481eb156b453e62$var$A)) $9481eb156b453e62$var$St = !1;
        else try {
            var e = "__support__";
            $9481eb156b453e62$var$Ft.set(e, "xyz"), '"xyz"' !== $9481eb156b453e62$var$Ft.get(e) && ($9481eb156b453e62$var$St = !1), $9481eb156b453e62$var$Ft.remove(e);
        } catch (e) {
            $9481eb156b453e62$var$St = !1;
        }
        return $9481eb156b453e62$var$St;
    },
    error: function(e) {
        $9481eb156b453e62$var$G.error("sessionStorage error: ", e);
    },
    get: function(e) {
        try {
            return null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.sessionStorage.getItem(e);
        } catch (e) {
            $9481eb156b453e62$var$Ft.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($9481eb156b453e62$var$Ft.get(e)) || null;
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.sessionStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $9481eb156b453e62$var$Ft.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.sessionStorage.removeItem(e);
        } catch (e) {
            $9481eb156b453e62$var$Ft.error(e);
        }
    }
}, $9481eb156b453e62$var$Rt = [
    "localhost",
    "127.0.0.1"
], $9481eb156b453e62$var$Pt = !(!$9481eb156b453e62$var$U || !("withCredentials" in new $9481eb156b453e62$var$U)) || !!$9481eb156b453e62$var$H, $9481eb156b453e62$var$Et = function(e) {
    var t = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.createElement("a");
    return $9481eb156b453e62$var$E(t) ? null : (t.href = e, t);
}, $9481eb156b453e62$var$xt = function(e, t) {
    return !!function(e) {
        try {
            new RegExp(e);
        } catch (e) {
            return !1;
        }
        return !0;
    }(t) && new RegExp(t).test(e);
}, $9481eb156b453e62$var$It = function(e) {
    var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "&", i = [];
    return $9481eb156b453e62$var$K(e, function(e, r) {
        $9481eb156b453e62$var$E(e) || $9481eb156b453e62$var$E(r) || "undefined" === r || (t = encodeURIComponent(function(e) {
            return e instanceof File;
        }(e) ? e.name : e.toString()), n = encodeURIComponent(r), i[i.length] = n + "=" + t);
    }), i.join(r);
}, $9481eb156b453e62$var$Ct = function(e, t) {
    for(var n, r = ((e.split("#")[0] || "").split("?")[1] || "").split("&"), i = 0; i < r.length; i++){
        var o = r[i].split("=");
        if (o[0] === t) {
            n = o;
            break;
        }
    }
    if (!$9481eb156b453e62$var$S(n) || n.length < 2) return "";
    var s = n[1];
    try {
        s = decodeURIComponent(s);
    } catch (e) {
        $9481eb156b453e62$var$G.error("Skipping decoding for malformed query param: " + s);
    }
    return s.replace(/\+/g, " ");
}, $9481eb156b453e62$var$Tt = function(e, t) {
    var n = e.match(new RegExp(t + "=([^&]*)"));
    return n ? n[1] : null;
}, $9481eb156b453e62$var$$t = "Mobile", $9481eb156b453e62$var$Ot = "iOS", $9481eb156b453e62$var$At = "Android", $9481eb156b453e62$var$qt = "Tablet", $9481eb156b453e62$var$Mt = $9481eb156b453e62$var$At + " " + $9481eb156b453e62$var$qt, $9481eb156b453e62$var$Dt = "iPad", $9481eb156b453e62$var$Nt = "Apple", $9481eb156b453e62$var$Lt = $9481eb156b453e62$var$Nt + " Watch", $9481eb156b453e62$var$Bt = "Safari", $9481eb156b453e62$var$jt = "BlackBerry", $9481eb156b453e62$var$Ht = "Samsung", $9481eb156b453e62$var$Ut = $9481eb156b453e62$var$Ht + "Browser", $9481eb156b453e62$var$Vt = $9481eb156b453e62$var$Ht + " Internet", $9481eb156b453e62$var$Wt = "Chrome", $9481eb156b453e62$var$zt = $9481eb156b453e62$var$Wt + " OS", $9481eb156b453e62$var$Gt = $9481eb156b453e62$var$Wt + " " + $9481eb156b453e62$var$Ot, $9481eb156b453e62$var$Qt = "Internet Explorer", $9481eb156b453e62$var$Yt = $9481eb156b453e62$var$Qt + " " + $9481eb156b453e62$var$$t, $9481eb156b453e62$var$Jt = "Opera", $9481eb156b453e62$var$Kt = $9481eb156b453e62$var$Jt + " Mini", $9481eb156b453e62$var$Xt = "Edge", $9481eb156b453e62$var$Zt = "Microsoft " + $9481eb156b453e62$var$Xt, $9481eb156b453e62$var$en = "Firefox", $9481eb156b453e62$var$tn = $9481eb156b453e62$var$en + " " + $9481eb156b453e62$var$Ot, $9481eb156b453e62$var$nn = "Nintendo", $9481eb156b453e62$var$rn = "PlayStation", $9481eb156b453e62$var$on = "Xbox", $9481eb156b453e62$var$sn = $9481eb156b453e62$var$At + " " + $9481eb156b453e62$var$$t, $9481eb156b453e62$var$an = $9481eb156b453e62$var$$t + " " + $9481eb156b453e62$var$Bt, $9481eb156b453e62$var$un = "Windows", $9481eb156b453e62$var$ln = $9481eb156b453e62$var$un + " Phone", $9481eb156b453e62$var$cn = "Nokia", $9481eb156b453e62$var$dn = "Ouya", $9481eb156b453e62$var$fn = "Generic", $9481eb156b453e62$var$hn = $9481eb156b453e62$var$fn + " " + $9481eb156b453e62$var$$t.toLowerCase(), $9481eb156b453e62$var$pn = $9481eb156b453e62$var$fn + " " + $9481eb156b453e62$var$qt.toLowerCase(), $9481eb156b453e62$var$_n = "Konqueror", $9481eb156b453e62$var$gn = "(\\d+(\\.\\d+)?)", $9481eb156b453e62$var$vn = new RegExp("Version/" + $9481eb156b453e62$var$gn), $9481eb156b453e62$var$mn = new RegExp($9481eb156b453e62$var$on, "i"), $9481eb156b453e62$var$yn = new RegExp($9481eb156b453e62$var$rn + " \\w+", "i"), $9481eb156b453e62$var$bn = new RegExp($9481eb156b453e62$var$nn + " \\w+", "i"), $9481eb156b453e62$var$wn = new RegExp($9481eb156b453e62$var$jt + "|PlayBook|BB10", "i"), $9481eb156b453e62$var$kn = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $9481eb156b453e62$var$Sn = function(e, t) {
    return t && $9481eb156b453e62$var$Z(t, $9481eb156b453e62$var$Nt) || function(e) {
        return $9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$Bt) && !$9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$Wt) && !$9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$At);
    }(e);
}, $9481eb156b453e62$var$Fn = function(e, t, n) {
    return n ? $9481eb156b453e62$var$Jt : (t = t || "", $9481eb156b453e62$var$Z(e, " OPR/") && $9481eb156b453e62$var$Z(e, "Mini") ? $9481eb156b453e62$var$Kt : $9481eb156b453e62$var$Z(e, " OPR/") ? $9481eb156b453e62$var$Jt : $9481eb156b453e62$var$wn.test(e) ? $9481eb156b453e62$var$jt : $9481eb156b453e62$var$Z(e, "IE" + $9481eb156b453e62$var$$t) || $9481eb156b453e62$var$Z(e, "WPDesktop") ? $9481eb156b453e62$var$Yt : $9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$Ut) ? $9481eb156b453e62$var$Vt : $9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$Xt) || $9481eb156b453e62$var$Z(e, "Edg/") ? $9481eb156b453e62$var$Zt : $9481eb156b453e62$var$Z(e, "FBIOS") ? "Facebook " + $9481eb156b453e62$var$$t : $9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$Wt) ? $9481eb156b453e62$var$Wt : $9481eb156b453e62$var$Z(e, "CriOS") ? $9481eb156b453e62$var$Gt : $9481eb156b453e62$var$Z(e, "UCWEB") || $9481eb156b453e62$var$Z(e, "UCBrowser") ? "UC Browser" : $9481eb156b453e62$var$Z(e, "FxiOS") ? $9481eb156b453e62$var$tn : $9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$At) ? $9481eb156b453e62$var$sn : $9481eb156b453e62$var$Z(e.toLowerCase(), $9481eb156b453e62$var$_n.toLowerCase()) ? $9481eb156b453e62$var$_n : $9481eb156b453e62$var$Sn(e, t) ? $9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$$t) ? $9481eb156b453e62$var$an : $9481eb156b453e62$var$Bt : $9481eb156b453e62$var$Z(e, $9481eb156b453e62$var$en) ? $9481eb156b453e62$var$en : $9481eb156b453e62$var$Z(e, "MSIE") || $9481eb156b453e62$var$Z(e, "Trident/") ? $9481eb156b453e62$var$Qt : $9481eb156b453e62$var$Z(e, "Gecko") ? $9481eb156b453e62$var$en : "");
}, $9481eb156b453e62$var$Rn = ($9481eb156b453e62$var$s($9481eb156b453e62$var$_t = {}, $9481eb156b453e62$var$Yt, [
    new RegExp("rv:" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$Zt, [
    new RegExp($9481eb156b453e62$var$Xt + "?\\/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$Wt, [
    new RegExp($9481eb156b453e62$var$Wt + "/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$Gt, [
    new RegExp("CriOS\\/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, "UC Browser", [
    new RegExp("(UCBrowser|UCWEB)\\/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$Bt, [
    $9481eb156b453e62$var$vn
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$an, [
    $9481eb156b453e62$var$vn
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$Jt, [
    new RegExp("(Opera|OPR)\\/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$en, [
    new RegExp($9481eb156b453e62$var$en + "\\/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$tn, [
    new RegExp("FxiOS\\/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$_n, [
    new RegExp("Konqueror[:/]?" + $9481eb156b453e62$var$gn, "i")
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$jt, [
    new RegExp($9481eb156b453e62$var$jt + " " + $9481eb156b453e62$var$gn),
    $9481eb156b453e62$var$vn
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$sn, [
    new RegExp("android\\s" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$Vt, [
    new RegExp($9481eb156b453e62$var$Ut + "\\/" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, $9481eb156b453e62$var$Qt, [
    new RegExp("(rv:|MSIE )" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$s($9481eb156b453e62$var$_t, "Mozilla", [
    new RegExp("rv:" + $9481eb156b453e62$var$gn)
]), $9481eb156b453e62$var$_t), $9481eb156b453e62$var$Pn = [
    [
        new RegExp($9481eb156b453e62$var$on + "; " + $9481eb156b453e62$var$on + " (.*?)[);]", "i"),
        function(e) {
            return [
                $9481eb156b453e62$var$on,
                e && e[1] || ""
            ];
        }
    ],
    [
        new RegExp($9481eb156b453e62$var$nn, "i"),
        [
            $9481eb156b453e62$var$nn,
            ""
        ]
    ],
    [
        new RegExp($9481eb156b453e62$var$rn, "i"),
        [
            $9481eb156b453e62$var$rn,
            ""
        ]
    ],
    [
        $9481eb156b453e62$var$wn,
        [
            $9481eb156b453e62$var$jt,
            ""
        ]
    ],
    [
        new RegExp($9481eb156b453e62$var$un, "i"),
        function(e, t) {
            if (/Phone/.test(t) || /WPDesktop/.test(t)) return [
                $9481eb156b453e62$var$ln,
                ""
            ];
            if (new RegExp($9481eb156b453e62$var$$t).test(t) && !/IEMobile\b/.test(t)) return [
                $9481eb156b453e62$var$un + " " + $9481eb156b453e62$var$$t,
                ""
            ];
            var n = /Windows NT ([0-9.]+)/i.exec(t);
            if (n && n[1]) {
                var r = n[1], i = $9481eb156b453e62$var$kn[r] || "";
                return /arm/i.test(t) && (i = "RT"), [
                    $9481eb156b453e62$var$un,
                    i
                ];
            }
            return [
                $9481eb156b453e62$var$un,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        function(e) {
            if (e && e[3]) {
                var t = [
                    e[3],
                    e[4],
                    e[5] || "0"
                ];
                return [
                    $9481eb156b453e62$var$Ot,
                    t.join(".")
                ];
            }
            return [
                $9481eb156b453e62$var$Ot,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        function(e) {
            var t = "";
            return e && e.length >= 3 && (t = $9481eb156b453e62$var$E(e[2]) ? e[3] : e[2]), [
                "watchOS",
                t
            ];
        }
    ],
    [
        new RegExp("(" + $9481eb156b453e62$var$At + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $9481eb156b453e62$var$At + ")", "i"),
        function(e) {
            if (e && e[2]) {
                var t = [
                    e[2],
                    e[3],
                    e[4] || "0"
                ];
                return [
                    $9481eb156b453e62$var$At,
                    t.join(".")
                ];
            }
            return [
                $9481eb156b453e62$var$At,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        function(e) {
            var t = [
                "Mac OS X",
                ""
            ];
            if (e && e[1]) {
                var n = [
                    e[1],
                    e[2],
                    e[3] || "0"
                ];
                t[1] = n.join(".");
            }
            return t;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $9481eb156b453e62$var$zt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $9481eb156b453e62$var$En = function(e) {
    return $9481eb156b453e62$var$bn.test(e) ? $9481eb156b453e62$var$nn : $9481eb156b453e62$var$yn.test(e) ? $9481eb156b453e62$var$rn : $9481eb156b453e62$var$mn.test(e) ? $9481eb156b453e62$var$on : new RegExp($9481eb156b453e62$var$dn, "i").test(e) ? $9481eb156b453e62$var$dn : new RegExp("(" + $9481eb156b453e62$var$ln + "|WPDesktop)", "i").test(e) ? $9481eb156b453e62$var$ln : /iPad/.test(e) ? $9481eb156b453e62$var$Dt : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? $9481eb156b453e62$var$Lt : $9481eb156b453e62$var$wn.test(e) ? $9481eb156b453e62$var$jt : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp($9481eb156b453e62$var$cn, "i").test(e) ? $9481eb156b453e62$var$cn : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? !new RegExp($9481eb156b453e62$var$$t).test(e) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) ? /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? $9481eb156b453e62$var$At : $9481eb156b453e62$var$Mt : $9481eb156b453e62$var$At : new RegExp("(pda|" + $9481eb156b453e62$var$$t + ")", "i").test(e) ? $9481eb156b453e62$var$hn : new RegExp($9481eb156b453e62$var$qt, "i").test(e) && !new RegExp($9481eb156b453e62$var$qt + " pc", "i").test(e) ? $9481eb156b453e62$var$pn : "";
}, $9481eb156b453e62$var$xn = "https?://(.*)", $9481eb156b453e62$var$In = {
    campaignParams: function(e) {
        var t = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content",
            "utm_term",
            "gclid",
            "gad_source",
            "gbraid",
            "wbraid",
            "fbclid",
            "msclkid"
        ].concat(e || []), n = {};
        return $9481eb156b453e62$var$K(t, function(e) {
            var t = $9481eb156b453e62$var$B ? $9481eb156b453e62$var$Ct($9481eb156b453e62$var$B.URL, e) : "";
            t.length && (n[e] = t);
        }), n;
    },
    searchEngine: function() {
        var e = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.referrer;
        return e ? 0 === e.search($9481eb156b453e62$var$xn + "google.([^/?]*)") ? "google" : 0 === e.search($9481eb156b453e62$var$xn + "bing.com") ? "bing" : 0 === e.search($9481eb156b453e62$var$xn + "yahoo.com") ? "yahoo" : 0 === e.search($9481eb156b453e62$var$xn + "duckduckgo.com") ? "duckduckgo" : null : null;
    },
    searchInfo: function() {
        var e = $9481eb156b453e62$var$In.searchEngine(), t = "yahoo" != e ? "q" : "p", n = {};
        if (!$9481eb156b453e62$var$I(e)) {
            n.$search_engine = e;
            var r = $9481eb156b453e62$var$B ? $9481eb156b453e62$var$Ct($9481eb156b453e62$var$B.referrer, t) : "";
            r.length && (n.ph_keyword = r);
        }
        return n;
    },
    browser: $9481eb156b453e62$var$Fn,
    browserVersion: function(e, t, n) {
        var r = $9481eb156b453e62$var$Fn(e, t, n), i = $9481eb156b453e62$var$Rn[r];
        if ($9481eb156b453e62$var$E(i)) return null;
        for(var o = 0; o < i.length; o++){
            var s = i[o], a = e.match(s);
            if (a) return parseFloat(a[a.length - 2]);
        }
        return null;
    },
    browserLanguage: function() {
        return navigator.language || navigator.userLanguage;
    },
    os: function(e) {
        for(var t = 0; t < $9481eb156b453e62$var$Pn.length; t++){
            var n = $9481eb156b453e62$var$h($9481eb156b453e62$var$Pn[t], 2), r = n[0], i = n[1], o = r.exec(e), s = o && ($9481eb156b453e62$var$R(i) ? i(o, e) : i);
            if (s) return s;
        }
        return [
            "",
            ""
        ];
    },
    device: $9481eb156b453e62$var$En,
    deviceType: function(e) {
        var t = $9481eb156b453e62$var$En(e);
        return t === $9481eb156b453e62$var$Dt || t === $9481eb156b453e62$var$Mt || "Kobo" === t || "Kindle Fire" === t || t === $9481eb156b453e62$var$pn ? $9481eb156b453e62$var$qt : t === $9481eb156b453e62$var$nn || t === $9481eb156b453e62$var$on || t === $9481eb156b453e62$var$rn || t === $9481eb156b453e62$var$dn ? "Console" : t === $9481eb156b453e62$var$Lt ? "Wearable" : t ? $9481eb156b453e62$var$$t : "Desktop";
    },
    referrer: function() {
        return (null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.referrer) || "$direct";
    },
    referringDomain: function() {
        var e;
        return null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.referrer && (null === (e = $9481eb156b453e62$var$Et($9481eb156b453e62$var$B.referrer)) || void 0 === e ? void 0 : e.host) || "$direct";
    },
    properties: function() {
        if (!$9481eb156b453e62$var$V) return {};
        var e = $9481eb156b453e62$var$h($9481eb156b453e62$var$In.os($9481eb156b453e62$var$V), 2), t = e[0], n = e[1];
        return $9481eb156b453e62$var$X($9481eb156b453e62$var$ie({
            $os: t,
            $os_version: n,
            $browser: $9481eb156b453e62$var$In.browser($9481eb156b453e62$var$V, navigator.vendor, $9481eb156b453e62$var$W.opera),
            $device: $9481eb156b453e62$var$In.device($9481eb156b453e62$var$V),
            $device_type: $9481eb156b453e62$var$In.deviceType($9481eb156b453e62$var$V)
        }), {
            $current_url: null == $9481eb156b453e62$var$j ? void 0 : $9481eb156b453e62$var$j.href,
            $host: null == $9481eb156b453e62$var$j ? void 0 : $9481eb156b453e62$var$j.host,
            $pathname: null == $9481eb156b453e62$var$j ? void 0 : $9481eb156b453e62$var$j.pathname,
            $raw_user_agent: $9481eb156b453e62$var$V.length > 1e3 ? $9481eb156b453e62$var$V.substring(0, 997) + "..." : $9481eb156b453e62$var$V,
            $browser_version: $9481eb156b453e62$var$In.browserVersion($9481eb156b453e62$var$V, navigator.vendor, $9481eb156b453e62$var$W.opera),
            $browser_language: $9481eb156b453e62$var$In.browserLanguage(),
            $screen_height: null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.screen.height,
            $screen_width: null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.screen.width,
            $viewport_height: null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.innerHeight,
            $viewport_width: null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.innerWidth,
            $lib: "web",
            $lib_version: $9481eb156b453e62$var$m.LIB_VERSION,
            $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
            $time: $9481eb156b453e62$var$te() / 1e3
        });
    },
    people_properties: function() {
        if (!$9481eb156b453e62$var$V) return {};
        var e = $9481eb156b453e62$var$h($9481eb156b453e62$var$In.os($9481eb156b453e62$var$V), 2), t = e[0], n = e[1];
        return $9481eb156b453e62$var$X($9481eb156b453e62$var$ie({
            $os: t,
            $os_version: n,
            $browser: $9481eb156b453e62$var$In.browser($9481eb156b453e62$var$V, navigator.vendor, $9481eb156b453e62$var$W.opera)
        }), {
            $browser_version: $9481eb156b453e62$var$In.browserVersion($9481eb156b453e62$var$V, navigator.vendor, $9481eb156b453e62$var$W.opera)
        });
    }
}, $9481eb156b453e62$var$Cn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $9481eb156b453e62$var$Tn = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.config = t, this.props = {}, this.campaign_params_saved = !1, this.name = function(e) {
            var t = "";
            return e.token && (t = e.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), e.persistence_name ? "ph_" + e.persistence_name : "ph_" + t + "_posthog";
        }(t), this.storage = this.buildStorage(t), this.load(), this.update_config(t, t), this.save();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "buildStorage",
            value: function(e) {
                -1 === $9481eb156b453e62$var$Cn.indexOf(e.persistence.toLowerCase()) && ($9481eb156b453e62$var$G.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
                var t = e.persistence.toLowerCase();
                return "localstorage" === t && $9481eb156b453e62$var$mt.is_supported() ? $9481eb156b453e62$var$mt : "localstorage+cookie" === t && $9481eb156b453e62$var$bt.is_supported() ? $9481eb156b453e62$var$bt : "sessionstorage" === t && $9481eb156b453e62$var$Ft.is_supported() ? $9481eb156b453e62$var$Ft : "memory" === t ? $9481eb156b453e62$var$kt : "cookie" === t ? $9481eb156b453e62$var$gt : $9481eb156b453e62$var$bt.is_supported() ? $9481eb156b453e62$var$bt : $9481eb156b453e62$var$gt;
            }
        },
        {
            key: "properties",
            value: function() {
                var e = {};
                return $9481eb156b453e62$var$K(this.props, function(t, n) {
                    if (n === $9481eb156b453e62$var$Be && $9481eb156b453e62$var$P(t)) for(var r = Object.keys(t), i = 0; i < r.length; i++)e["$feature/".concat(r[i])] = t[r[i]];
                    else s = n, a = !1, ($9481eb156b453e62$var$I(o = $9481eb156b453e62$var$Ye) ? a : $9481eb156b453e62$var$N && o.indexOf === $9481eb156b453e62$var$N ? -1 != o.indexOf(s) : ($9481eb156b453e62$var$K(o, function(e) {
                        if (a || (a = e === s)) return $9481eb156b453e62$var$Q;
                    }), a)) || (e[n] = t);
                    var o, s, a;
                }), e;
            }
        },
        {
            key: "load",
            value: function() {
                if (!this.disabled) {
                    var e = this.storage.parse(this.name);
                    e && (this.props = $9481eb156b453e62$var$X({}, e));
                }
            }
        },
        {
            key: "save",
            value: function() {
                this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure);
            }
        },
        {
            key: "remove",
            value: function() {
                this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
            }
        },
        {
            key: "clear",
            value: function() {
                this.remove(), this.props = {};
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var r = this;
                if ($9481eb156b453e62$var$P(e)) {
                    $9481eb156b453e62$var$E(t) && (t = "None"), this.expire_days = $9481eb156b453e62$var$E(n) ? this.default_expiry : n;
                    var i = !1;
                    if ($9481eb156b453e62$var$K(e, function(e, n) {
                        r.props.hasOwnProperty(n) && r.props[n] !== t || (r.props[n] = e, i = !0);
                    }), i) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n = this;
                if ($9481eb156b453e62$var$P(e)) {
                    this.expire_days = $9481eb156b453e62$var$E(t) ? this.default_expiry : t;
                    var r = !1;
                    if ($9481eb156b453e62$var$K(e, function(t, i) {
                        e.hasOwnProperty(i) && n.props[i] !== t && (n.props[i] = t, r = !0);
                    }), r) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "unregister",
            value: function(e) {
                e in this.props && (delete this.props[e], this.save());
            }
        },
        {
            key: "update_campaign_params",
            value: function() {
                this.campaign_params_saved || (this.register($9481eb156b453e62$var$In.campaignParams(this.config.custom_campaign_params)), this.campaign_params_saved = !0);
            }
        },
        {
            key: "update_search_keyword",
            value: function() {
                this.register($9481eb156b453e62$var$In.searchInfo());
            }
        },
        {
            key: "update_referrer_info",
            value: function() {
                this.register({
                    $referrer: this.props.$referrer || $9481eb156b453e62$var$In.referrer(),
                    $referring_domain: this.props.$referring_domain || $9481eb156b453e62$var$In.referringDomain()
                });
            }
        },
        {
            key: "get_referrer_info",
            value: function() {
                return $9481eb156b453e62$var$ie({
                    $referrer: this.props.$referrer,
                    $referring_domain: this.props.$referring_domain
                });
            }
        },
        {
            key: "safe_merge",
            value: function(e) {
                return $9481eb156b453e62$var$K(this.props, function(t, n) {
                    n in e || (e[n] = t);
                }), e;
            }
        },
        {
            key: "update_config",
            value: function(e, t) {
                if (this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie), e.persistence !== t.persistence) {
                    var n = this.buildStorage(e), r = this.props;
                    this.clear(), this.storage = n, this.props = r, this.save();
                }
            }
        },
        {
            key: "set_disabled",
            value: function(e) {
                this.disabled = e, this.disabled ? this.remove() : this.save();
            }
        },
        {
            key: "set_cross_subdomain",
            value: function(e) {
                e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
            }
        },
        {
            key: "get_cross_subdomain",
            value: function() {
                return !!this.cross_subdomain;
            }
        },
        {
            key: "set_secure",
            value: function(e) {
                e !== this.secure && (this.secure = e, this.remove(), this.save());
            }
        },
        {
            key: "set_event_timer",
            value: function(e, t) {
                var n = this.props[$9481eb156b453e62$var$Te] || {};
                n[e] = t, this.props[$9481eb156b453e62$var$Te] = n, this.save();
            }
        },
        {
            key: "remove_event_timer",
            value: function(e) {
                var t = (this.props[$9481eb156b453e62$var$Te] || {})[e];
                return $9481eb156b453e62$var$E(t) || (delete this.props[$9481eb156b453e62$var$Te][e], this.save()), t;
            }
        },
        {
            key: "get_user_state",
            value: function() {
                return this.props[$9481eb156b453e62$var$ze] || "anonymous";
            }
        },
        {
            key: "set_user_state",
            value: function(e) {
                this.props[$9481eb156b453e62$var$ze] = e, this.save();
            }
        },
        {
            key: "get_quota_limits",
            value: function() {
                return this.props[$9481eb156b453e62$var$Ge] || {};
            }
        },
        {
            key: "set_quota_limits",
            value: function(e) {
                this.props[$9481eb156b453e62$var$Ge] = e, this.save();
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$$n = 2, $9481eb156b453e62$var$On = 4;
var $9481eb156b453e62$var$An = $9481eb156b453e62$var$o(function e(t) {
    var n, i, o = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "bucketSize", 100), $9481eb156b453e62$var$s(this, "refillRate", 10), $9481eb156b453e62$var$s(this, "mutationBuckets", {}), $9481eb156b453e62$var$s(this, "loggedTracker", {}), $9481eb156b453e62$var$s(this, "refillBuckets", function() {
        Object.keys(o.mutationBuckets).forEach(function(e) {
            o.mutationBuckets[e] = o.mutationBuckets[e] + o.refillRate, o.mutationBuckets[e] >= o.bucketSize && delete o.mutationBuckets[e];
        });
    }), $9481eb156b453e62$var$s(this, "getNodeOrRelevantParent", function(e) {
        var t = o.rrweb.mirror.getNode(e);
        if ("svg" !== (null == t ? void 0 : t.nodeName) && t instanceof Element) {
            var n = t.closest("svg");
            if (n) return [
                o.rrweb.mirror.getId(n),
                n
            ];
        }
        return [
            e,
            t
        ];
    }), $9481eb156b453e62$var$s(this, "numberOfChanges", function(e) {
        var t, n, r, i, o, s, a, u;
        return (null !== (t = null === (n = e.removes) || void 0 === n ? void 0 : n.length) && void 0 !== t ? t : 0) + (null !== (r = null === (i = e.attributes) || void 0 === i ? void 0 : i.length) && void 0 !== r ? r : 0) + (null !== (o = null === (s = e.texts) || void 0 === s ? void 0 : s.length) && void 0 !== o ? o : 0) + (null !== (a = null === (u = e.adds) || void 0 === u ? void 0 : u.length) && void 0 !== a ? a : 0);
    }), $9481eb156b453e62$var$s(this, "throttleMutations", function(e) {
        if (3 !== e.type || 0 !== e.data.source) return e;
        var t = e.data, n = o.numberOfChanges(t);
        t.attributes && (t.attributes = t.attributes.filter(function(e) {
            var t, n, r, i = $9481eb156b453e62$var$h(o.getNodeOrRelevantParent(e.id), 2), s = i[0], a = i[1];
            if (0 === o.mutationBuckets[s]) return !1;
            (o.mutationBuckets[s] = null !== (t = o.mutationBuckets[s]) && void 0 !== t ? t : o.bucketSize, o.mutationBuckets[s] = Math.max(o.mutationBuckets[s] - 1, 0), 0 === o.mutationBuckets[s]) && (o.loggedTracker[s] || (o.loggedTracker[s] = !0, null === (n = (r = o.options).onBlockedNode) || void 0 === n || n.call(r, s, a)));
            return e;
        }));
        var r = o.numberOfChanges(t);
        return 0 !== r || n === r ? e : void 0;
    }), this.rrweb = t, this.options = a, this.refillRate = null !== (n = this.options.refillRate) && void 0 !== n ? n : this.refillRate, this.bucketSize = null !== (i = this.options.bucketSize) && void 0 !== i ? i : this.bucketSize, setInterval(function() {
        o.refillBuckets();
    }, 1e3);
}), $9481eb156b453e62$var$qn = function(e) {
    return e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e;
}($9481eb156b453e62$var$qn || {}), $9481eb156b453e62$var$Mn = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: function(e) {
        return e;
    },
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6
}, $9481eb156b453e62$var$Dn = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $9481eb156b453e62$var$Nn = [
    "/s/",
    "/e/",
    "/i/vo/e/"
];
function $9481eb156b453e62$var$Ln(e, t, n, r) {
    if ($9481eb156b453e62$var$C(e)) return e;
    var i = (null == t ? void 0 : t["content-length"]) || function(e) {
        return new Blob([
            e
        ]).size;
    }(e);
    return $9481eb156b453e62$var$x(i) && (i = parseInt(i)), i > n ? "[SessionReplay] ".concat(r, " body too large to record (").concat(i, " bytes)") : e;
}
var $9481eb156b453e62$var$Bn = function(e, n) {
    var r, i, o, s = e.session_recording, a = !1 !== s.recordHeaders && n.recordHeaders, u = !1 !== s.recordBody && n.recordBody, l = !1 !== s.recordPerformance && n.recordPerformance, c = (r = s, o = Math.min(1e6, null !== (i = r.payloadSizeLimitBytes) && void 0 !== i ? i : 1e6), function(e) {
        return null != e && e.requestBody && (e.requestBody = $9481eb156b453e62$var$Ln(e.requestBody, e.requestHeaders, o, "Request")), null != e && e.responseBody && (e.responseBody = $9481eb156b453e62$var$Ln(e.responseBody, e.responseHeaders, o, "Response")), e;
    }), d = function(e) {
        var t, n;
        return c(function(e) {
            var t = $9481eb156b453e62$var$Et(e.name);
            if (!(t && t.pathname && $9481eb156b453e62$var$Nn.includes(t.pathname))) return e;
        }((t = e, Object.keys(null !== (n = t.requestHeaders) && void 0 !== n ? n : {}).forEach(function(e) {
            var n;
            $9481eb156b453e62$var$Dn.includes(e.toLowerCase()) && (null === (n = t.requestHeaders) || void 0 === n || delete n[e]);
        }), t)));
    }, f = $9481eb156b453e62$var$R(e.session_recording.maskNetworkRequestFn);
    return f && $9481eb156b453e62$var$R(e.session_recording.maskCapturedNetworkRequestFn) && $9481eb156b453e62$var$G.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), f && (e.session_recording.maskCapturedNetworkRequestFn = function(n) {
        var r = e.session_recording.maskNetworkRequestFn({
            url: n.name
        });
        return $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, n), {}, {
            name: null == r ? void 0 : r.url
        });
    }), s.maskRequestFn = $9481eb156b453e62$var$R(e.session_recording.maskCapturedNetworkRequestFn) ? function(t) {
        var n, r, i, o = d(t);
        return o && null !== (n = null === (r = (i = e.session_recording).maskCapturedNetworkRequestFn) || void 0 === r ? void 0 : r.call(i, o)) && void 0 !== n ? n : void 0;
    } : void 0, s.maskRequestFn || (s.maskRequestFn = d), $9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, $9481eb156b453e62$var$Mn), s), {}, {
        recordHeaders: a,
        recordBody: u,
        recordPerformance: l,
        recordInitialRequests: l
    });
}, $9481eb156b453e62$var$jn = "__ph_opt_in_out_";
function $9481eb156b453e62$var$Hn(e, t) {
    $9481eb156b453e62$var$Jn(!0, e, t);
}
function $9481eb156b453e62$var$Un(e, t) {
    $9481eb156b453e62$var$Jn(!1, e, t);
}
function $9481eb156b453e62$var$Vn(e, t) {
    return "1" === $9481eb156b453e62$var$Yn(e, t);
}
function $9481eb156b453e62$var$Wn(e, t) {
    return !!function(e) {
        if (e && e.respectDnt) {
            var t = e && e.window || $9481eb156b453e62$var$A, n = null == t ? void 0 : t.navigator, r = !1;
            return $9481eb156b453e62$var$K([
                null == n ? void 0 : n.doNotTrack,
                n.msDoNotTrack,
                t.doNotTrack
            ], function(e) {
                $9481eb156b453e62$var$Z([
                    !0,
                    1,
                    "1",
                    "yes"
                ], e) && (r = !0);
            }), r;
        }
        return !1;
    }(t) || "0" === $9481eb156b453e62$var$Yn(e, t);
}
function $9481eb156b453e62$var$zn(e, t) {
    $9481eb156b453e62$var$Gn(t = t || {}).remove($9481eb156b453e62$var$Qn(e, t), !!t.crossSubdomainCookie);
}
function $9481eb156b453e62$var$Gn(e) {
    return "localStorage" === (e = e || {}).persistenceType ? $9481eb156b453e62$var$mt : "localStorage+cookie" === e.persistenceType ? $9481eb156b453e62$var$bt : $9481eb156b453e62$var$gt;
}
function $9481eb156b453e62$var$Qn(e, t) {
    return ((t = t || {}).persistencePrefix || $9481eb156b453e62$var$jn) + e;
}
function $9481eb156b453e62$var$Yn(e, t) {
    return $9481eb156b453e62$var$Gn(t).get($9481eb156b453e62$var$Qn(e, t));
}
function $9481eb156b453e62$var$Jn(e, t, n) {
    $9481eb156b453e62$var$x(t) && t.length ? ($9481eb156b453e62$var$Gn(n = n || {}).set($9481eb156b453e62$var$Qn(t, n), e ? 1 : 0, $9481eb156b453e62$var$T(n.cookieExpiration) ? n.cookieExpiration : null, n.crossSubdomainCookie, n.secureCookie), n.capture && e && n.capture(n.captureEventName || "$opt_in", n.captureProperties || {}, {
        send_instantly: !0
    })) : $9481eb156b453e62$var$G.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
}
function $9481eb156b453e62$var$Kn(e) {
    var t = !1;
    try {
        var n = e.config.token, r = e.config.respect_dnt, i = e.config.opt_out_capturing_persistence_type, o = e.config.opt_out_capturing_cookie_prefix || void 0, s = e.config.window;
        n && (t = $9481eb156b453e62$var$Wn(n, {
            respectDnt: r,
            persistenceType: i,
            persistencePrefix: o,
            window: s
        }));
    } catch (e) {
        $9481eb156b453e62$var$G.error("Unexpected error when checking capturing opt-out status: " + e);
    }
    return t;
}
var $9481eb156b453e62$var$Xn, $9481eb156b453e62$var$Zn = 3e5, $9481eb156b453e62$var$er = $9481eb156b453e62$var$Zn;
!function(e) {
    e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet";
}($9481eb156b453e62$var$Xn || ($9481eb156b453e62$var$Xn = {}));
var $9481eb156b453e62$var$tr = [
    $9481eb156b453e62$var$Xn.MouseMove,
    $9481eb156b453e62$var$Xn.MouseInteraction,
    $9481eb156b453e62$var$Xn.Scroll,
    $9481eb156b453e62$var$Xn.ViewportResize,
    $9481eb156b453e62$var$Xn.Input,
    $9481eb156b453e62$var$Xn.TouchMove,
    $9481eb156b453e62$var$Xn.MediaInteraction,
    $9481eb156b453e62$var$Xn.Drag
], $9481eb156b453e62$var$nr = function(e) {
    return {
        rrwebMethod: e,
        enqueuedAt: Date.now(),
        attempt: 1
    };
}, $9481eb156b453e62$var$rr = "[SessionRecording]", $9481eb156b453e62$var$ir = function() {
    function e(t) {
        var n = this;
        if ($9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "queuedRRWebEvents", []), $9481eb156b453e62$var$s(this, "isIdle", !1), $9481eb156b453e62$var$s(this, "_linkedFlagSeen", !1), $9481eb156b453e62$var$s(this, "_lastActivityTimestamp", Date.now()), $9481eb156b453e62$var$s(this, "windowId", null), $9481eb156b453e62$var$s(this, "sessionId", null), $9481eb156b453e62$var$s(this, "_linkedFlag", null), $9481eb156b453e62$var$s(this, "_sampleRate", null), $9481eb156b453e62$var$s(this, "_minimumDuration", null), $9481eb156b453e62$var$s(this, "_forceAllowLocalhostNetworkCapture", !1), this.instance = t, this._captureStarted = !1, this._endpoint = "/s/", this.stopRrweb = void 0, this.receivedDecide = !1, null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.addEventListener("beforeunload", function() {
            n._flushBuffer();
        }), null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.addEventListener("offline", function() {
            n._tryAddCustomEvent("browser offline", {});
        }), null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.addEventListener("online", function() {
            n._tryAddCustomEvent("browser online", {});
        }), !this.instance.sessionManager) throw $9481eb156b453e62$var$G.error($9481eb156b453e62$var$rr + " started without valid sessionManager"), new Error($9481eb156b453e62$var$rr + " started without valid sessionManager. This is a bug.");
        this.buffer = this.clearBuffer();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "started",
            get: function() {
                return this._captureStarted;
            }
        },
        {
            key: "sessionManager",
            get: function() {
                if (!this.instance.sessionManager) throw $9481eb156b453e62$var$G.error($9481eb156b453e62$var$rr + " started without valid sessionManager"), new Error($9481eb156b453e62$var$rr + " started without valid sessionManager. This is a bug.");
                return this.instance.sessionManager;
            }
        },
        {
            key: "isSampled",
            get: function() {
                return $9481eb156b453e62$var$T(this._sampleRate) ? this.instance.get_property($9481eb156b453e62$var$Le) : null;
            }
        },
        {
            key: "sessionDuration",
            get: function() {
                var e, t, n = null === (e = this.buffer) || void 0 === e ? void 0 : e.data[(null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) - 1], r = this.sessionManager.checkAndGetSessionAndWindowId(!0).sessionStartTimestamp;
                return n ? n.timestamp - r : null;
            }
        },
        {
            key: "isRecordingEnabled",
            get: function() {
                var e = !!this.instance.get_property($9481eb156b453e62$var$Oe), t = !this.instance.config.disable_session_recording;
                return $9481eb156b453e62$var$A && e && t;
            }
        },
        {
            key: "isConsoleLogCaptureEnabled",
            get: function() {
                var e = !!this.instance.get_property($9481eb156b453e62$var$Ae), t = this.instance.config.enable_recording_console_log;
                return null != t ? t : e;
            }
        },
        {
            key: "canvasRecording",
            get: function() {
                var e = this.instance.get_property($9481eb156b453e62$var$De);
                return e && e.fps && e.quality ? {
                    enabled: e.enabled,
                    fps: e.fps,
                    quality: e.quality
                } : void 0;
            }
        },
        {
            key: "recordingVersion",
            get: function() {
                var e, t = this.instance.get_property($9481eb156b453e62$var$qe);
                return (null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recorderVersion) || t || "v1";
            }
        },
        {
            key: "networkPayloadCapture",
            get: function() {
                var e, t, n = this.instance.get_property($9481eb156b453e62$var$Me), r = {
                    recordHeaders: null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recordHeaders,
                    recordBody: null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.recordBody
                }, i = (null == r ? void 0 : r.recordHeaders) || (null == n ? void 0 : n.recordHeaders), o = (null == r ? void 0 : r.recordBody) || (null == n ? void 0 : n.recordBody), s = this.instance.config.capture_performance || (null == n ? void 0 : n.capturePerformance);
                return i || o || s ? {
                    recordHeaders: i,
                    recordBody: o,
                    recordPerformance: s
                } : void 0;
            }
        },
        {
            key: "status",
            get: function() {
                return this.receivedDecide ? this.isRecordingEnabled ? $9481eb156b453e62$var$C(this._linkedFlag) || this._linkedFlagSeen ? $9481eb156b453e62$var$$(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "buffering" : "disabled" : "buffering";
            }
        },
        {
            key: "startRecordingIfEnabled",
            value: function() {
                this.isRecordingEnabled ? (this._startCapture(), $9481eb156b453e62$var$G.info($9481eb156b453e62$var$rr + " started")) : (this.stopRecording(), this.clearBuffer());
            }
        },
        {
            key: "stopRecording",
            value: function() {
                this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1, $9481eb156b453e62$var$G.info($9481eb156b453e62$var$rr + " stopped"));
            }
        },
        {
            key: "makeSamplingDecision",
            value: function(e) {
                var t, n = this.sessionId !== e;
                if ($9481eb156b453e62$var$T(this._sampleRate)) {
                    var r, i = this.isSampled;
                    if (n || !$9481eb156b453e62$var$$(i)) r = Math.random() < this._sampleRate;
                    else r = i;
                    r || $9481eb156b453e62$var$G.warn($9481eb156b453e62$var$rr + " Sample rate (".concat(this._sampleRate, ") has determined that this sessionId (").concat(e, ") will not be sent to the server.")), null === (t = this.instance.persistence) || void 0 === t || t.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Le, r));
                } else {
                    var o;
                    null === (o = this.instance.persistence) || void 0 === o || o.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Le, null));
                }
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var n, r, i, o, a, u, l, c, d, f, h, p = this;
                this.instance.persistence && this.instance.persistence.register(($9481eb156b453e62$var$s(h = {}, $9481eb156b453e62$var$Oe, !!e.sessionRecording), $9481eb156b453e62$var$s(h, $9481eb156b453e62$var$Ae, null === (a = e.sessionRecording) || void 0 === a ? void 0 : a.consoleLogRecordingEnabled), $9481eb156b453e62$var$s(h, $9481eb156b453e62$var$qe, null === (u = e.sessionRecording) || void 0 === u ? void 0 : u.recorderVersion), $9481eb156b453e62$var$s(h, $9481eb156b453e62$var$Me, $9481eb156b453e62$var$t({
                    capturePerformance: e.capturePerformance
                }, null === (l = e.sessionRecording) || void 0 === l ? void 0 : l.networkPayloadCapture)), $9481eb156b453e62$var$s(h, $9481eb156b453e62$var$De, {
                    enabled: null === (c = e.sessionRecording) || void 0 === c ? void 0 : c.recordCanvas,
                    fps: null === (d = e.sessionRecording) || void 0 === d ? void 0 : d.canvasFps,
                    quality: null === (f = e.sessionRecording) || void 0 === f ? void 0 : f.canvasQuality
                }), h));
                var _ = null === (n = e.sessionRecording) || void 0 === n ? void 0 : n.sampleRate;
                this._sampleRate = $9481eb156b453e62$var$C(_) ? null : parseFloat(_);
                var g, v = null === (r = e.sessionRecording) || void 0 === r ? void 0 : r.minimumDurationMilliseconds;
                (this._minimumDuration = $9481eb156b453e62$var$E(v) ? null : v, this._linkedFlag = (null === (i = e.sessionRecording) || void 0 === i ? void 0 : i.linkedFlag) || null, null !== (o = e.sessionRecording) && void 0 !== o && o.endpoint) && (this._endpoint = null === (g = e.sessionRecording) || void 0 === g ? void 0 : g.endpoint);
                if ($9481eb156b453e62$var$T(this._sampleRate) && this.sessionManager.onSessionId(function(e) {
                    p.makeSamplingDecision(e);
                }), !$9481eb156b453e62$var$C(this._linkedFlag)) {
                    var m, y, b = $9481eb156b453e62$var$x(this._linkedFlag) ? this._linkedFlag : null === (m = this._linkedFlag) || void 0 === m ? void 0 : m.flag, w = $9481eb156b453e62$var$x(this._linkedFlag) ? null : null === (y = this._linkedFlag) || void 0 === y ? void 0 : y.variant;
                    this.instance.onFeatureFlags(function(e, t) {
                        var n = $9481eb156b453e62$var$P(t) && b in t, r = w ? t[b] === w : n;
                        r && $9481eb156b453e62$var$G.info($9481eb156b453e62$var$rr + " linked flag matched", {
                            linkedFlag: b,
                            linkedVariant: w
                        }), p._linkedFlagSeen = r;
                    });
                }
                this.receivedDecide = !0, this.startRecordingIfEnabled();
            }
        },
        {
            key: "log",
            value: function(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "log";
                null === (t = this.instance.sessionRecording) || void 0 === t || t.onRRwebEmit({
                    type: 6,
                    data: {
                        plugin: "rrweb/console@1",
                        payload: {
                            level: n,
                            trace: [],
                            payload: [
                                JSON.stringify(e)
                            ]
                        }
                    },
                    timestamp: $9481eb156b453e62$var$te()
                });
            }
        },
        {
            key: "_startCapture",
            value: function() {
                var e = this;
                if (!$9481eb156b453e62$var$E(Object.assign) && !(this._captureStarted || this.instance.config.disable_session_recording || $9481eb156b453e62$var$Kn(this.instance))) {
                    this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId();
                    var t = "v2" === this.recordingVersion ? "recorder-v2.js" : "recorder.js";
                    this.instance.__loaded_recorder_version !== this.recordingVersion ? $9481eb156b453e62$var$le(this.instance.requestRouter.endpointFor("assets", "/static/".concat(t, "?v=").concat($9481eb156b453e62$var$m.LIB_VERSION)), function(n) {
                        if (n) return $9481eb156b453e62$var$G.error($9481eb156b453e62$var$rr + " could not load ".concat(t), n);
                        e._onScriptLoaded();
                    }) : this._onScriptLoaded();
                }
            }
        },
        {
            key: "_isInteractiveEvent",
            value: function(e) {
                var t;
                return 3 === e.type && -1 !== $9481eb156b453e62$var$tr.indexOf(null === (t = e.data) || void 0 === t ? void 0 : t.source);
            }
        },
        {
            key: "_updateWindowAndSessionIds",
            value: function(e) {
                var t = this._isInteractiveEvent(e);
                t || this.isIdle || e.timestamp - this._lastActivityTimestamp > $9481eb156b453e62$var$er && (this.isIdle = !0, this._tryAddCustomEvent("sessionIdle", {
                    reason: "user inactivity",
                    timeSinceLastActive: e.timestamp - this._lastActivityTimestamp,
                    threshold: $9481eb156b453e62$var$er
                }));
                var n = !1;
                if (t && (this._lastActivityTimestamp = e.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", {
                    reason: "user activity",
                    type: e.type
                }), n = !0)), !this.isIdle) {
                    var r = this.sessionManager.checkAndGetSessionAndWindowId(!t, e.timestamp), i = r.windowId, o = r.sessionId, s = this.sessionId !== o, a = this.windowId !== i;
                    this.windowId = i, this.sessionId = o, (n || -1 === [
                        $9481eb156b453e62$var$$n,
                        $9481eb156b453e62$var$On
                    ].indexOf(e.type) && (a || s)) && this._tryTakeFullSnapshot();
                }
            }
        },
        {
            key: "_tryRRWebMethod",
            value: function(e) {
                try {
                    return e.rrwebMethod(), !0;
                } catch (t) {
                    return $9481eb156b453e62$var$G.warn($9481eb156b453e62$var$rr + " could not emit queued rrweb event.", t), this.queuedRRWebEvents.length < 10 && this.queuedRRWebEvents.push({
                        enqueuedAt: e.enqueuedAt || Date.now(),
                        attempt: e.attempt++,
                        rrwebMethod: e.rrwebMethod
                    }), !1;
                }
            }
        },
        {
            key: "_tryAddCustomEvent",
            value: function(e, t) {
                var n = this;
                return this._tryRRWebMethod($9481eb156b453e62$var$nr(function() {
                    return n.rrwebRecord.addCustomEvent(e, t);
                }));
            }
        },
        {
            key: "_tryTakeFullSnapshot",
            value: function() {
                var e = this;
                return this._tryRRWebMethod($9481eb156b453e62$var$nr(function() {
                    return e.rrwebRecord.takeFullSnapshot();
                }));
            }
        },
        {
            key: "_onScriptLoaded",
            value: function() {
                var e, n = this, r = {
                    blockClass: "ph-no-capture",
                    blockSelector: void 0,
                    ignoreClass: "ph-ignore-input",
                    maskTextClass: "ph-mask",
                    maskTextSelector: void 0,
                    maskTextFn: void 0,
                    maskAllInputs: !0,
                    maskInputOptions: {},
                    maskInputFn: void 0,
                    slimDOMOptions: {},
                    collectFonts: !1,
                    inlineStylesheet: !0,
                    recordCrossOriginIframes: !1
                };
                this.rrwebRecord = $9481eb156b453e62$var$A.rrweb ? $9481eb156b453e62$var$A.rrweb.record : $9481eb156b453e62$var$A.rrwebRecord;
                for(var i = this.instance.config.session_recording, o = 0, s = Object.entries(i || {}); o < s.length; o++){
                    var a = $9481eb156b453e62$var$h(s[o], 2), u = a[0], l = a[1];
                    u in r && (r[u] = l);
                }
                if (this.canvasRecording && this.canvasRecording.enabled && (r.recordCanvas = !0, r.sampling = {
                    canvas: this.canvasRecording.fps
                }, r.dataURLOptions = {
                    type: "image/webp",
                    quality: this.canvasRecording.quality
                }), this.rrwebRecord) {
                    this.mutationRateLimiter = null !== (e = this.mutationRateLimiter) && void 0 !== e ? e : new $9481eb156b453e62$var$An(this.rrwebRecord, {
                        onBlockedNode: function(e, t) {
                            var r = "Too many mutations on node '".concat(e, "'. Rate limiting. This could be due to SVG animations or something similar");
                            $9481eb156b453e62$var$G.info(r, {
                                node: t
                            }), n.log($9481eb156b453e62$var$rr + " " + r, "warn");
                        }
                    }), this._scheduleFullSnapshot();
                    var c = this._gatherRRWebPlugins();
                    this.stopRrweb = this.rrwebRecord($9481eb156b453e62$var$t({
                        emit: function(e) {
                            n.onRRwebEmit(e);
                        },
                        plugins: c
                    }, r)), this.instance._addCaptureHook(function(e) {
                        try {
                            if ("$pageview" === e) {
                                var t = $9481eb156b453e62$var$A ? n._maskUrl($9481eb156b453e62$var$A.location.href) : "";
                                if (!t) return;
                                n._tryAddCustomEvent("$pageview", {
                                    href: t
                                }), n._tryTakeFullSnapshot();
                            }
                        } catch (e) {
                            $9481eb156b453e62$var$G.error("Could not add $pageview to rrweb session", e);
                        }
                    }), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", {
                        sessionRecordingOptions: r,
                        activePlugins: c.map(function(e) {
                            return null == e ? void 0 : e.name;
                        })
                    }), this._tryAddCustomEvent("$posthog_config", {
                        config: this.instance.config
                    });
                } else $9481eb156b453e62$var$G.error($9481eb156b453e62$var$rr + "onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
            }
        },
        {
            key: "_scheduleFullSnapshot",
            value: function() {
                var e = this;
                this._fullSnapshotTimer && clearInterval(this._fullSnapshotTimer), this._fullSnapshotTimer = setInterval(function() {
                    e._tryTakeFullSnapshot();
                }, $9481eb156b453e62$var$Zn);
            }
        },
        {
            key: "_gatherRRWebPlugins",
            value: function() {
                var e = [];
                ($9481eb156b453e62$var$W.rrwebConsoleRecord && this.isConsoleLogCaptureEnabled && e.push($9481eb156b453e62$var$W.rrwebConsoleRecord.getRecordConsolePlugin()), this.networkPayloadCapture && $9481eb156b453e62$var$R($9481eb156b453e62$var$W.getRecordNetworkPlugin)) && (!$9481eb156b453e62$var$Rt.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? e.push($9481eb156b453e62$var$W.getRecordNetworkPlugin($9481eb156b453e62$var$Bn(this.instance.config, this.networkPayloadCapture))) : $9481eb156b453e62$var$G.info($9481eb156b453e62$var$rr + " NetworkCapture not started because we are on localhost."));
                return e;
            }
        },
        {
            key: "onRRwebEmit",
            value: function(e) {
                if (this._processQueuedEvents(), e && $9481eb156b453e62$var$P(e)) {
                    if (e.type === $9481eb156b453e62$var$qn.Meta) {
                        var t = this._maskUrl(e.data.href);
                        if (!t) return;
                        e.data.href = t;
                    }
                    e.type === $9481eb156b453e62$var$qn.FullSnapshot && this._scheduleFullSnapshot();
                    var n = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(e) : e;
                    if (n) {
                        var r = function(e) {
                            var t = e;
                            if (t && $9481eb156b453e62$var$P(t) && 6 === t.type && $9481eb156b453e62$var$P(t.data) && "rrweb/console@1" === t.data.plugin) {
                                t.data.payload.payload.length > 10 && (t.data.payload.payload = t.data.payload.payload.slice(0, 10), t.data.payload.payload.push("...[truncated]"));
                                for(var n = [], r = 0; r < t.data.payload.payload.length; r++)t.data.payload.payload[r] && t.data.payload.payload[r].length > 2e3 ? n.push(t.data.payload.payload[r].slice(0, 2e3) + "...[truncated]") : n.push(t.data.payload.payload[r]);
                                return t.data.payload.payload = n, e;
                            }
                            return e;
                        }(n), i = JSON.stringify(r).length;
                        if (this._updateWindowAndSessionIds(r), !this.isIdle || r.type === $9481eb156b453e62$var$qn.Custom) {
                            var o = {
                                $snapshot_bytes: i,
                                $snapshot_data: r,
                                $session_id: this.sessionId,
                                $window_id: this.windowId
                            };
                            "disabled" !== this.status ? this._captureSnapshotBuffered(o) : this.clearBuffer();
                        }
                    }
                }
            }
        },
        {
            key: "_processQueuedEvents",
            value: function() {
                var e = this;
                if (this.queuedRRWebEvents.length) {
                    var t = $9481eb156b453e62$var$p(this.queuedRRWebEvents);
                    this.queuedRRWebEvents = [], t.forEach(function(n) {
                        Date.now() - n.enqueuedAt > 2e3 ? e._tryAddCustomEvent("rrwebQueueTimeout", {
                            enqueuedAt: n.enqueuedAt,
                            attempt: n.attempt,
                            queueLength: t.length
                        }) : e._tryRRWebMethod(n) && e._tryAddCustomEvent("rrwebQueueSuccess", {
                            enqueuedAt: n.enqueuedAt,
                            attempt: n.attempt,
                            queueLength: t.length
                        });
                    });
                }
            }
        },
        {
            key: "_maskUrl",
            value: function(e) {
                var t = this.instance.config.session_recording;
                if (t.maskNetworkRequestFn) {
                    var n, r = {
                        url: e
                    };
                    return null === (n = r = t.maskNetworkRequestFn(r)) || void 0 === n ? void 0 : n.url;
                }
                return e;
            }
        },
        {
            key: "clearBuffer",
            value: function() {
                return this.buffer = void 0, {
                    size: 0,
                    data: [],
                    sessionId: this.sessionId,
                    windowId: this.windowId
                };
            }
        },
        {
            key: "_flushBuffer",
            value: function() {
                var e = this;
                this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
                var t = this._minimumDuration, n = this.sessionDuration, r = $9481eb156b453e62$var$T(n) && n >= 0, i = $9481eb156b453e62$var$T(t) && r && n < t;
                return "buffering" === this.status || i ? (this.flushBufferTimer = setTimeout(function() {
                    e._flushBuffer();
                }, 2e3), this.buffer || this.clearBuffer()) : this.buffer && 0 !== this.buffer.data.length ? (this._captureSnapshot({
                    $snapshot_bytes: this.buffer.size,
                    $snapshot_data: this.buffer.data,
                    $session_id: this.buffer.sessionId,
                    $window_id: this.buffer.windowId
                }), this.clearBuffer()) : this.buffer || this.clearBuffer();
            }
        },
        {
            key: "_captureSnapshotBuffered",
            value: function(e) {
                var t, n = this, r = 2 + ((null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) || 0);
                (!this.buffer || this.buffer.size + e.$snapshot_bytes + r > 943718.4 || this.buffer.sessionId && this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), $9481eb156b453e62$var$I(this.buffer.sessionId) && !$9481eb156b453e62$var$I(this.sessionId) && (this.buffer.sessionId = this.sessionId, this.buffer.windowId = this.windowId), this.buffer.size += e.$snapshot_bytes, this.buffer.data.push(e.$snapshot_data), this.flushBufferTimer || (this.flushBufferTimer = setTimeout(function() {
                    n._flushBuffer();
                }, 2e3));
            }
        },
        {
            key: "_captureSnapshot",
            value: function(e) {
                this.instance.capture("$snapshot", e, {
                    method: "POST",
                    _url: this.instance.requestRouter.endpointFor("api", this._endpoint),
                    _noTruncate: !0,
                    _batchKey: "recordings",
                    _metrics: {
                        rrweb_full_snapshot: e.$snapshot_data.type === $9481eb156b453e62$var$$n
                    }
                });
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$or = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t, this.instance.decideEndpointWasHit = this.instance._hasBootstrappedFeatureFlags();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "call",
            value: function() {
                var e = this, t = $9481eb156b453e62$var$se(JSON.stringify({
                    token: this.instance.config.token,
                    distinct_id: this.instance.get_distinct_id(),
                    groups: this.instance.getGroups(),
                    person_properties: this.instance.get_property($9481eb156b453e62$var$He),
                    group_properties: this.instance.get_property($9481eb156b453e62$var$Ue),
                    disable_flags: this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load || void 0
                }));
                this.instance._send_request(this.instance.requestRouter.endpointFor("api", "/decide/?v=3"), {
                    data: t,
                    verbose: !0
                }, {
                    method: "POST"
                }, function(t) {
                    return e.parseDecideResponse(t);
                });
            }
        },
        {
            key: "parseDecideResponse",
            value: function(e) {
                var t, n = this;
                if (this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags._startReloadTimer(), 0 !== (null == e ? void 0 : e.status)) {
                    if (!$9481eb156b453e62$var$B || !$9481eb156b453e62$var$B.body) return $9481eb156b453e62$var$G.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(function() {
                        n.parseDecideResponse(e);
                    }, 500);
                    this.instance.toolbar.afterDecideResponse(e), null === (t = this.instance.sessionRecording) || void 0 === t || t.afterDecideResponse(e), $9481eb156b453e62$var$Ke.afterDecideResponse(e, this.instance), this.instance._afterDecideResponse(e), this.instance.config.advanced_disable_feature_flags_on_first_load || this.instance.config.advanced_disable_feature_flags || this.instance.featureFlags.receivedFeatureFlags(e);
                    var r = null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.extendPostHogWithSurveys;
                    e.surveys && !r && $9481eb156b453e62$var$le(this.instance.requestRouter.endpointFor("assets", "/static/surveys.js"), function(e) {
                        if (e) return $9481eb156b453e62$var$G.error("Could not load surveys script", e);
                        $9481eb156b453e62$var$A.extendPostHogWithSurveys(n.instance);
                    });
                    var i = null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.extendPostHogWithExceptionAutoCapture;
                    if (e.autocaptureExceptions && e.autocaptureExceptions && $9481eb156b453e62$var$E(i) && $9481eb156b453e62$var$le(this.instance.requestRouter.endpointFor("assets", "/static/exception-autocapture.js"), function(t) {
                        if (t) return $9481eb156b453e62$var$G.error("Could not load exception autocapture script", t);
                        $9481eb156b453e62$var$A.extendPostHogWithExceptionAutocapture(n.instance, e);
                    }), e.siteApps) {
                        if (this.instance.config.opt_in_site_apps) {
                            var o, s = $9481eb156b453e62$var$v(e.siteApps);
                            try {
                                var a = function() {
                                    var e = o.value, t = e.id, r = e.url, i = n.instance.requestRouter.endpointFor("api", r);
                                    $9481eb156b453e62$var$W["__$$ph_site_app_".concat(t)] = n.instance, $9481eb156b453e62$var$le(i, function(e) {
                                        e && $9481eb156b453e62$var$G.error("Error while initializing PostHog app with config id ".concat(t), e);
                                    });
                                };
                                for(s.s(); !(o = s.n()).done;)a();
                            } catch (e) {
                                s.e(e);
                            } finally{
                                s.f();
                            }
                        } else e.siteApps.length > 0 && $9481eb156b453e62$var$G.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
                    }
                } else $9481eb156b453e62$var$G.error("Failed to fetch feature flags from PostHog.");
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$sr = [
    "source"
], $9481eb156b453e62$var$ar = null != $9481eb156b453e62$var$A && $9481eb156b453e62$var$A.location ? $9481eb156b453e62$var$Tt($9481eb156b453e62$var$A.location.hash, "__posthog") || $9481eb156b453e62$var$Tt(location.hash, "state") : null, $9481eb156b453e62$var$ur = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "afterDecideResponse",
            value: function(e) {
                var n = e.toolbarParams || e.editorParams || (e.toolbarVersion ? {
                    toolbarVersion: e.toolbarVersion
                } : {});
                e.isAuthenticated && n.toolbarVersion && 0 === n.toolbarVersion.indexOf("toolbar") && this.loadToolbar($9481eb156b453e62$var$t({}, n));
            }
        },
        {
            key: "maybeLoadToolbar",
            value: function() {
                var e, t, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                if (!$9481eb156b453e62$var$A || !$9481eb156b453e62$var$B) return !1;
                n = null !== (e = n) && void 0 !== e ? e : $9481eb156b453e62$var$A.location, i = null !== (t = i) && void 0 !== t ? t : $9481eb156b453e62$var$A.history;
                try {
                    if (!r) {
                        try {
                            $9481eb156b453e62$var$A.localStorage.setItem("test", "test"), $9481eb156b453e62$var$A.localStorage.removeItem("test");
                        } catch (e) {
                            return !1;
                        }
                        r = null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.localStorage;
                    }
                    var o, s = $9481eb156b453e62$var$ar || $9481eb156b453e62$var$Tt(n.hash, "__posthog") || $9481eb156b453e62$var$Tt(n.hash, "state"), a = s ? $9481eb156b453e62$var$ne(function() {
                        return JSON.parse(atob(decodeURIComponent(s)));
                    }) || $9481eb156b453e62$var$ne(function() {
                        return JSON.parse(decodeURIComponent(s));
                    }) : null;
                    return a && "ph_authorize" === a.action ? ((o = a).source = "url", o && Object.keys(o).length > 0 && (a.desiredHash ? n.hash = a.desiredHash : i ? i.replaceState("", $9481eb156b453e62$var$B.title, n.pathname + n.search) : n.hash = "")) : ((o = JSON.parse(r.getItem("_postHogToolbarParams") || "{}")).source = "localstorage", delete o.userIntent), !(!o.token || this.instance.config.token !== o.token) && (this.loadToolbar(o), !0);
                } catch (e) {
                    return !1;
                }
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                var n = this;
                if (!$9481eb156b453e62$var$A || $9481eb156b453e62$var$W._postHogToolbarLoaded) return !1;
                $9481eb156b453e62$var$W._postHogToolbarLoaded = !0;
                var r = 3e5, i = Math.floor(Date.now() / r) * r, o = this.instance.requestRouter.endpointFor("assets", "/static/toolbar.js?t=".concat(i)), s = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, a = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({
                    token: this.instance.config.token
                }, e), {}, {
                    apiURL: this.instance.requestRouter.endpointFor("ui")
                }, s ? {
                    instrument: !1
                } : {});
                a.source;
                var u = $9481eb156b453e62$var$c(a, $9481eb156b453e62$var$sr);
                return $9481eb156b453e62$var$A.localStorage.setItem("_postHogToolbarParams", JSON.stringify(u)), $9481eb156b453e62$var$le(o, function(e) {
                    e ? $9481eb156b453e62$var$G.error("Failed to load toolbar", e) : ($9481eb156b453e62$var$W.ph_load_toolbar || $9481eb156b453e62$var$W.ph_load_editor)(a, n.instance);
                }), $9481eb156b453e62$var$ue($9481eb156b453e62$var$A, "turbolinks:load", function() {
                    $9481eb156b453e62$var$W._postHogToolbarLoaded = !1, n.loadToolbar(a);
                }), !0;
            }
        },
        {
            key: "_loadEditor",
            value: function(e) {
                return this.loadToolbar(e);
            }
        },
        {
            key: "maybeLoadEditor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                return this.maybeLoadToolbar(e, t, n);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$lr = function() {
    function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 3e3;
        $9481eb156b453e62$var$r(this, e), this.isPolling = !0, this._event_queue = [], this._empty_queue_count = 0, this._poller = void 0, this._pollInterval = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "setPollInterval",
            value: function(e) {
                this._pollInterval = e, this.isPolling && this.poll();
            }
        },
        {
            key: "poll",
            value: function() {}
        },
        {
            key: "unload",
            value: function() {}
        },
        {
            key: "getTime",
            value: function() {
                return (new Date).getTime();
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$cr = function(e) {
    $9481eb156b453e62$var$a(i, $9481eb156b453e62$var$lr);
    var n = $9481eb156b453e62$var$f(i);
    function i(e) {
        var t, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3e3;
        return $9481eb156b453e62$var$r(this, i), (t = n.call(this, o)).handlePollRequest = e, t;
    }
    return $9481eb156b453e62$var$o(i, [
        {
            key: "enqueue",
            value: function(e, t, n) {
                this._event_queue.push({
                    url: e,
                    data: t,
                    options: n
                }), this.isPolling || (this.isPolling = !0, this.poll());
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                clearTimeout(this._poller), this._poller = setTimeout(function() {
                    if (e._event_queue.length > 0) {
                        var t = e.formatQueue(), n = function(n) {
                            var r = t[n], i = r.url, o = r.data, s = r.options;
                            $9481eb156b453e62$var$K(o, function(t, n) {
                                o[n].offset = Math.abs(o[n].timestamp - e.getTime()), delete o[n].timestamp;
                            }), e.handlePollRequest(i, o, s);
                        };
                        for(var r in t)n(r);
                        e._event_queue.length = 0, e._empty_queue_count = 0;
                    } else e._empty_queue_count++;
                    e._empty_queue_count > 4 && (e.isPolling = !1, e._empty_queue_count = 0), e.isPolling && e.poll();
                }, this._pollInterval);
            }
        },
        {
            key: "unload",
            value: function() {
                var e = this;
                clearTimeout(this._poller);
                var n = this._event_queue.length > 0 ? this.formatQueue() : {};
                this._event_queue.length = 0;
                var r = Object.values(n);
                [].concat($9481eb156b453e62$var$p(r.filter(function(e) {
                    return 0 === e.url.indexOf("/e");
                })), $9481eb156b453e62$var$p(r.filter(function(e) {
                    return 0 !== e.url.indexOf("/e");
                }))).map(function(n) {
                    var r = n.url, i = n.data, o = n.options;
                    e.handlePollRequest(r, i, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, o), {}, {
                        transport: "sendBeacon"
                    }));
                });
            }
        },
        {
            key: "formatQueue",
            value: function() {
                var e = {};
                return $9481eb156b453e62$var$K(this._event_queue, function(t) {
                    var n = t.url, r = t.data, i = t.options, o = (i ? i._batchKey : null) || n;
                    $9481eb156b453e62$var$E(e[o]) && (e[o] = {
                        data: [],
                        url: n,
                        options: i
                    }), i && e[o].options && e[o].options._metrics && !e[o].options._metrics.rrweb_full_snapshot && (e[o].options._metrics.rrweb_full_snapshot = i._metrics.rrweb_full_snapshot), e[o].data.push(r);
                }), e;
            }
        }
    ]), i;
}(), $9481eb156b453e62$var$dr = Uint8Array, $9481eb156b453e62$var$fr = Uint16Array, $9481eb156b453e62$var$hr = Uint32Array, $9481eb156b453e62$var$pr = new $9481eb156b453e62$var$dr([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $9481eb156b453e62$var$_r = new $9481eb156b453e62$var$dr([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $9481eb156b453e62$var$gr = new $9481eb156b453e62$var$dr([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $9481eb156b453e62$var$vr = function(e, t) {
    for(var n = new $9481eb156b453e62$var$fr(31), r = 0; r < 31; ++r)n[r] = t += 1 << e[r - 1];
    var i = new $9481eb156b453e62$var$hr(n[30]);
    for(r = 1; r < 30; ++r)for(var o = n[r]; o < n[r + 1]; ++o)i[o] = o - n[r] << 5 | r;
    return [
        n,
        i
    ];
}, $9481eb156b453e62$var$mr = $9481eb156b453e62$var$vr($9481eb156b453e62$var$pr, 2), $9481eb156b453e62$var$yr = $9481eb156b453e62$var$mr[0], $9481eb156b453e62$var$br = $9481eb156b453e62$var$mr[1];
$9481eb156b453e62$var$yr[28] = 258, $9481eb156b453e62$var$br[258] = 28;
for(var $9481eb156b453e62$var$wr = $9481eb156b453e62$var$vr($9481eb156b453e62$var$_r, 0)[1], $9481eb156b453e62$var$kr = new $9481eb156b453e62$var$fr(32768), $9481eb156b453e62$var$Sr = 0; $9481eb156b453e62$var$Sr < 32768; ++$9481eb156b453e62$var$Sr){
    var $9481eb156b453e62$var$Fr = (43690 & $9481eb156b453e62$var$Sr) >>> 1 | (21845 & $9481eb156b453e62$var$Sr) << 1;
    $9481eb156b453e62$var$Fr = (61680 & ($9481eb156b453e62$var$Fr = (52428 & $9481eb156b453e62$var$Fr) >>> 2 | (13107 & $9481eb156b453e62$var$Fr) << 2)) >>> 4 | (3855 & $9481eb156b453e62$var$Fr) << 4, $9481eb156b453e62$var$kr[$9481eb156b453e62$var$Sr] = ((65280 & $9481eb156b453e62$var$Fr) >>> 8 | (255 & $9481eb156b453e62$var$Fr) << 8) >>> 1;
}
var $9481eb156b453e62$var$Rr = function(e, t, n) {
    for(var r = e.length, i = 0, o = new $9481eb156b453e62$var$fr(t); i < r; ++i)++o[e[i] - 1];
    var s, a = new $9481eb156b453e62$var$fr(t);
    for(i = 0; i < t; ++i)a[i] = a[i - 1] + o[i - 1] << 1;
    if (n) {
        s = new $9481eb156b453e62$var$fr(1 << t);
        var u = 15 - t;
        for(i = 0; i < r; ++i)if (e[i]) for(var l = i << 4 | e[i], c = t - e[i], d = a[e[i] - 1]++ << c, f = d | (1 << c) - 1; d <= f; ++d)s[$9481eb156b453e62$var$kr[d] >>> u] = l;
    } else for(s = new $9481eb156b453e62$var$fr(r), i = 0; i < r; ++i)s[i] = $9481eb156b453e62$var$kr[a[e[i] - 1]++] >>> 15 - e[i];
    return s;
}, $9481eb156b453e62$var$Pr = new $9481eb156b453e62$var$dr(288);
for($9481eb156b453e62$var$Sr = 0; $9481eb156b453e62$var$Sr < 144; ++$9481eb156b453e62$var$Sr)$9481eb156b453e62$var$Pr[$9481eb156b453e62$var$Sr] = 8;
for($9481eb156b453e62$var$Sr = 144; $9481eb156b453e62$var$Sr < 256; ++$9481eb156b453e62$var$Sr)$9481eb156b453e62$var$Pr[$9481eb156b453e62$var$Sr] = 9;
for($9481eb156b453e62$var$Sr = 256; $9481eb156b453e62$var$Sr < 280; ++$9481eb156b453e62$var$Sr)$9481eb156b453e62$var$Pr[$9481eb156b453e62$var$Sr] = 7;
for($9481eb156b453e62$var$Sr = 280; $9481eb156b453e62$var$Sr < 288; ++$9481eb156b453e62$var$Sr)$9481eb156b453e62$var$Pr[$9481eb156b453e62$var$Sr] = 8;
var $9481eb156b453e62$var$Er = new $9481eb156b453e62$var$dr(32);
for($9481eb156b453e62$var$Sr = 0; $9481eb156b453e62$var$Sr < 32; ++$9481eb156b453e62$var$Sr)$9481eb156b453e62$var$Er[$9481eb156b453e62$var$Sr] = 5;
var $9481eb156b453e62$export$6a00d17b5aff0af, $9481eb156b453e62$var$Ir = $9481eb156b453e62$var$Rr($9481eb156b453e62$var$Pr, 9, 0), $9481eb156b453e62$var$Cr = $9481eb156b453e62$var$Rr($9481eb156b453e62$var$Er, 5, 0), $9481eb156b453e62$var$Tr = function(e) {
    return (e / 8 >> 0) + (7 & e && 1);
}, $9481eb156b453e62$var$$r = function(e, t, n) {
    (null == t || t < 0) && (t = 0), (null == n || n > e.length) && (n = e.length);
    var r = new (e instanceof $9481eb156b453e62$var$fr ? $9481eb156b453e62$var$fr : e instanceof $9481eb156b453e62$var$hr ? $9481eb156b453e62$var$hr : $9481eb156b453e62$var$dr)(n - t);
    return r.set(e.subarray(t, n)), r;
}, $9481eb156b453e62$var$Or = function(e, t, n) {
    n <<= 7 & t;
    var r = t / 8 >> 0;
    e[r] |= n, e[r + 1] |= n >>> 8;
}, $9481eb156b453e62$var$Ar = function(e, t, n) {
    n <<= 7 & t;
    var r = t / 8 >> 0;
    e[r] |= n, e[r + 1] |= n >>> 8, e[r + 2] |= n >>> 16;
}, $9481eb156b453e62$var$qr = function(e, t) {
    for(var n = [], r = 0; r < e.length; ++r)e[r] && n.push({
        s: r,
        f: e[r]
    });
    var i = n.length, o = n.slice();
    if (!i) return [
        new $9481eb156b453e62$var$dr(0),
        0
    ];
    if (1 == i) {
        var s = new $9481eb156b453e62$var$dr(n[0].s + 1);
        return s[n[0].s] = 1, [
            s,
            1
        ];
    }
    n.sort(function(e, t) {
        return e.f - t.f;
    }), n.push({
        s: -1,
        f: 25001
    });
    var a = n[0], u = n[1], l = 0, c = 1, d = 2;
    for(n[0] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    }; c != i - 1;)a = n[n[l].f < n[d].f ? l++ : d++], u = n[l != c && n[l].f < n[d].f ? l++ : d++], n[c++] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    };
    var f = o[0].s;
    for(r = 1; r < i; ++r)o[r].s > f && (f = o[r].s);
    var h = new $9481eb156b453e62$var$fr(f + 1), p = $9481eb156b453e62$var$Mr(n[c - 1], h, 0);
    if (p > t) {
        r = 0;
        var _ = 0, g = p - t, v = 1 << g;
        for(o.sort(function(e, t) {
            return h[t.s] - h[e.s] || e.f - t.f;
        }); r < i; ++r){
            var m = o[r].s;
            if (!(h[m] > t)) break;
            _ += v - (1 << p - h[m]), h[m] = t;
        }
        for(_ >>>= g; _ > 0;){
            var y = o[r].s;
            h[y] < t ? _ -= 1 << t - h[y]++ - 1 : ++r;
        }
        for(; r >= 0 && _; --r){
            var b = o[r].s;
            h[b] == t && (--h[b], ++_);
        }
        p = t;
    }
    return [
        new $9481eb156b453e62$var$dr(h),
        p
    ];
}, $9481eb156b453e62$var$Mr = function e(t, n, r) {
    return -1 == t.s ? Math.max(e(t.l, n, r + 1), e(t.r, n, r + 1)) : n[t.s] = r;
}, $9481eb156b453e62$var$Dr = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var n = new $9481eb156b453e62$var$fr(++t), r = 0, i = e[0], o = 1, s = function(e) {
        n[r++] = e;
    }, a = 1; a <= t; ++a)if (e[a] == i && a != t) ++o;
    else {
        if (!i && o > 2) {
            for(; o > 138; o -= 138)s(32754);
            o > 2 && (s(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0);
        } else if (o > 3) {
            for(s(i), --o; o > 6; o -= 6)s(8304);
            o > 2 && (s(o - 3 << 5 | 8208), o = 0);
        }
        for(; o--;)s(i);
        o = 1, i = e[a];
    }
    return [
        n.subarray(0, r),
        t
    ];
}, $9481eb156b453e62$var$Nr = function(e, t) {
    for(var n = 0, r = 0; r < t.length; ++r)n += e[r] * t[r];
    return n;
}, $9481eb156b453e62$var$Lr = function(e, t, n) {
    var r = n.length, i = $9481eb156b453e62$var$Tr(t + 2);
    e[i] = 255 & r, e[i + 1] = r >>> 8, e[i + 2] = 255 ^ e[i], e[i + 3] = 255 ^ e[i + 1];
    for(var o = 0; o < r; ++o)e[i + o + 4] = n[o];
    return 8 * (i + 4 + r);
}, $9481eb156b453e62$var$Br = function(e, t, n, r, i, o, s, a, u, l, c) {
    $9481eb156b453e62$var$Or(t, c++, n), ++i[256];
    for(var d = $9481eb156b453e62$var$qr(i, 15), f = d[0], h = d[1], p = $9481eb156b453e62$var$qr(o, 15), _ = p[0], g = p[1], v = $9481eb156b453e62$var$Dr(f), m = v[0], y = v[1], b = $9481eb156b453e62$var$Dr(_), w = b[0], k = b[1], S = new $9481eb156b453e62$var$fr(19), F = 0; F < m.length; ++F)S[31 & m[F]]++;
    for(F = 0; F < w.length; ++F)S[31 & w[F]]++;
    for(var R = $9481eb156b453e62$var$qr(S, 7), P = R[0], E = R[1], x = 19; x > 4 && !P[$9481eb156b453e62$var$gr[x - 1]]; --x);
    var I, C, T, $, O = l + 5 << 3, A = $9481eb156b453e62$var$Nr(i, $9481eb156b453e62$var$Pr) + $9481eb156b453e62$var$Nr(o, $9481eb156b453e62$var$Er) + s, q = $9481eb156b453e62$var$Nr(i, f) + $9481eb156b453e62$var$Nr(o, _) + s + 14 + 3 * x + $9481eb156b453e62$var$Nr(S, P) + (2 * S[16] + 3 * S[17] + 7 * S[18]);
    if (O <= A && O <= q) return $9481eb156b453e62$var$Lr(t, c, e.subarray(u, u + l));
    if ($9481eb156b453e62$var$Or(t, c, 1 + (q < A)), c += 2, q < A) {
        I = $9481eb156b453e62$var$Rr(f, h, 0), C = f, T = $9481eb156b453e62$var$Rr(_, g, 0), $ = _;
        var M = $9481eb156b453e62$var$Rr(P, E, 0);
        $9481eb156b453e62$var$Or(t, c, y - 257), $9481eb156b453e62$var$Or(t, c + 5, k - 1), $9481eb156b453e62$var$Or(t, c + 10, x - 4), c += 14;
        for(F = 0; F < x; ++F)$9481eb156b453e62$var$Or(t, c + 3 * F, P[$9481eb156b453e62$var$gr[F]]);
        c += 3 * x;
        for(var D = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var L = D[N];
            for(F = 0; F < L.length; ++F){
                var B = 31 & L[F];
                $9481eb156b453e62$var$Or(t, c, M[B]), c += P[B], B > 15 && ($9481eb156b453e62$var$Or(t, c, L[F] >>> 5 & 127), c += L[F] >>> 12);
            }
        }
    } else I = $9481eb156b453e62$var$Ir, C = $9481eb156b453e62$var$Pr, T = $9481eb156b453e62$var$Cr, $ = $9481eb156b453e62$var$Er;
    for(F = 0; F < a; ++F)if (r[F] > 255) {
        B = r[F] >>> 18 & 31;
        $9481eb156b453e62$var$Ar(t, c, I[B + 257]), c += C[B + 257], B > 7 && ($9481eb156b453e62$var$Or(t, c, r[F] >>> 23 & 31), c += $9481eb156b453e62$var$pr[B]);
        var j = 31 & r[F];
        $9481eb156b453e62$var$Ar(t, c, T[j]), c += $[j], j > 3 && ($9481eb156b453e62$var$Ar(t, c, r[F] >>> 5 & 8191), c += $9481eb156b453e62$var$_r[j]);
    } else $9481eb156b453e62$var$Ar(t, c, I[r[F]]), c += C[r[F]];
    return $9481eb156b453e62$var$Ar(t, c, I[256]), c + C[256];
}, $9481eb156b453e62$var$jr = new $9481eb156b453e62$var$hr([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $9481eb156b453e62$var$Hr = new $9481eb156b453e62$var$dr(0), $9481eb156b453e62$var$Ur = function() {
    for(var e = new $9481eb156b453e62$var$hr(256), t = 0; t < 256; ++t){
        for(var n = t, r = 9; --r;)n = (1 & n && 3988292384) ^ n >>> 1;
        e[t] = n;
    }
    return e;
}(), $9481eb156b453e62$var$Vr = function() {
    var e = 4294967295;
    return {
        p: function(t) {
            for(var n = e, r = 0; r < t.length; ++r)n = $9481eb156b453e62$var$Ur[255 & n ^ t[r]] ^ n >>> 8;
            e = n;
        },
        d: function() {
            return 4294967295 ^ e;
        }
    };
}, $9481eb156b453e62$var$Wr = function(e, t, n, r, i) {
    return function(e, t, n, r, i, o) {
        var s = e.length, a = new $9481eb156b453e62$var$dr(r + s + 5 * (1 + Math.floor(s / 7e3)) + i), u = a.subarray(r, a.length - i), l = 0;
        if (!t || s < 8) for(var c = 0; c <= s; c += 65535){
            var d = c + 65535;
            d < s ? l = $9481eb156b453e62$var$Lr(u, l, e.subarray(c, d)) : (u[c] = o, l = $9481eb156b453e62$var$Lr(u, l, e.subarray(c, s)));
        }
        else {
            for(var f = $9481eb156b453e62$var$jr[t - 1], h = f >>> 13, p = 8191 & f, _ = (1 << n) - 1, g = new $9481eb156b453e62$var$fr(32768), v = new $9481eb156b453e62$var$fr(_ + 1), m = Math.ceil(n / 3), y = 2 * m, b = function(t) {
                return (e[t] ^ e[t + 1] << m ^ e[t + 2] << y) & _;
            }, w = new $9481eb156b453e62$var$hr(25e3), k = new $9481eb156b453e62$var$fr(288), S = new $9481eb156b453e62$var$fr(32), F = 0, R = 0, P = (c = 0, 0), E = 0, x = 0; c < s; ++c){
                var I = b(c), C = 32767 & c, T = v[I];
                if (g[C] = T, v[I] = C, E <= c) {
                    var $ = s - c;
                    if ((F > 7e3 || P > 24576) && $ > 423) {
                        l = $9481eb156b453e62$var$Br(e, u, 0, w, k, S, R, P, x, c - x, l), P = F = R = 0, x = c;
                        for(var O = 0; O < 286; ++O)k[O] = 0;
                        for(O = 0; O < 30; ++O)S[O] = 0;
                    }
                    var A = 2, q = 0, M = p, D = C - T & 32767;
                    if ($ > 2 && I == b(c - D)) for(var N = Math.min(h, $) - 1, L = Math.min(32767, c), B = Math.min(258, $); D <= L && --M && C != T;){
                        if (e[c + A] == e[c + A - D]) {
                            for(var j = 0; j < B && e[c + j] == e[c + j - D]; ++j);
                            if (j > A) {
                                if (A = j, q = D, j > N) break;
                                var H = Math.min(D, j - 2), U = 0;
                                for(O = 0; O < H; ++O){
                                    var V = c - D + O + 32768 & 32767, W = V - g[V] + 32768 & 32767;
                                    W > U && (U = W, T = V);
                                }
                            }
                        }
                        D += (C = T) - (T = g[C]) + 32768 & 32767;
                    }
                    if (q) {
                        w[P++] = 268435456 | $9481eb156b453e62$var$br[A] << 18 | $9481eb156b453e62$var$wr[q];
                        var z = 31 & $9481eb156b453e62$var$br[A], G = 31 & $9481eb156b453e62$var$wr[q];
                        R += $9481eb156b453e62$var$pr[z] + $9481eb156b453e62$var$_r[G], ++k[257 + z], ++S[G], E = c + A, ++F;
                    } else w[P++] = e[c], ++k[e[c]];
                }
            }
            l = $9481eb156b453e62$var$Br(e, u, o, w, k, S, R, P, x, c - x, l), o || (l = $9481eb156b453e62$var$Lr(u, l, $9481eb156b453e62$var$Hr));
        }
        return $9481eb156b453e62$var$$r(a, 0, r + $9481eb156b453e62$var$Tr(l) + i);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, n, r, !i);
}, $9481eb156b453e62$var$zr = function(e, t, n) {
    for(; n; ++t)e[t] = n, n >>>= 8;
}, $9481eb156b453e62$var$Gr = function(e, t) {
    var n = t.filename;
    if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : 9 == t.level ? 2 : 0, e[9] = 3, 0 != t.mtime && $9481eb156b453e62$var$zr(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), n) {
        e[3] = 8;
        for(var r = 0; r <= n.length; ++r)e[r + 10] = n.charCodeAt(r);
    }
}, $9481eb156b453e62$var$Qr = function(e) {
    return 10 + (e.filename && e.filename.length + 1 || 0);
};
function $9481eb156b453e62$var$Yr(e, t) {
    void 0 === t && (t = {});
    var n = $9481eb156b453e62$var$Vr(), r = e.length;
    n.p(e);
    var i = $9481eb156b453e62$var$Wr(e, t, $9481eb156b453e62$var$Qr(t), 8), o = i.length;
    return $9481eb156b453e62$var$Gr(i, t), $9481eb156b453e62$var$zr(i, o - 8, n.d()), $9481eb156b453e62$var$zr(i, o - 4, r), i;
}
function $9481eb156b453e62$var$Jr(e, t) {
    var n = e.length;
    if (!t && "undefined" != typeof TextEncoder) return (new TextEncoder).encode(e);
    for(var r = new $9481eb156b453e62$var$dr(e.length + (e.length >>> 1)), i = 0, o = function(e) {
        r[i++] = e;
    }, s = 0; s < n; ++s){
        if (i + 5 > r.length) {
            var a = new $9481eb156b453e62$var$dr(i + 8 + (n - s << 1));
            a.set(r), r = a;
        }
        var u = e.charCodeAt(s);
        u < 128 || t ? o(u) : u < 2048 ? (o(192 | u >>> 6), o(128 | 63 & u)) : u > 55295 && u < 57344 ? (o(240 | (u = 65536 + (1047552 & u) | 1023 & e.charCodeAt(++s)) >>> 18), o(128 | u >>> 12 & 63), o(128 | u >>> 6 & 63), o(128 | 63 & u)) : (o(224 | u >>> 12), o(128 | u >>> 6 & 63), o(128 | 63 & u));
    }
    return $9481eb156b453e62$var$$r(r, 0, i);
}
!function(e) {
    e.GZipJS = "gzip-js", e.Base64 = "base64";
}($9481eb156b453e62$export$6a00d17b5aff0af || ($9481eb156b453e62$export$6a00d17b5aff0af = {}));
var $9481eb156b453e62$var$Kr = function(e, t, n) {
    var r = t || {};
    r.ip = n.ip ? 1 : 0, r._ = (new Date).getTime().toString(), r.ver = $9481eb156b453e62$var$m.LIB_VERSION;
    var i = e.split("?");
    if (i.length > 1) {
        var o, s = $9481eb156b453e62$var$v(i[1].split("&"));
        try {
            for(s.s(); !(o = s.n()).done;){
                var a = o.value.split("=")[0];
                $9481eb156b453e62$var$E(r[a]) || delete r[a];
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
    }
    var u = e.indexOf("?") > -1 ? "&" : "?";
    return e + u + $9481eb156b453e62$var$It(r);
}, $9481eb156b453e62$var$Xr = function e(t, n) {
    if (n.blob && t.buffer) return new Blob([
        $9481eb156b453e62$var$F(t) ? t : t.buffer
    ], {
        type: "text/plain"
    });
    if (n.sendBeacon || n.blob) {
        var r = e(t, {
            method: "POST"
        });
        return new Blob([
            r
        ], {
            type: "application/x-www-form-urlencoded"
        });
    }
    var i;
    return "POST" !== n.method ? null : (i = $9481eb156b453e62$var$S(t) || $9481eb156b453e62$var$F(t) ? "data=" + encodeURIComponent(t) : "data=" + encodeURIComponent(t.data), "compression" in t && t.compression && (i += "&compression=" + t.compression), i);
}, $9481eb156b453e62$var$Zr = function(e) {
    if ($9481eb156b453e62$var$H && "fetch" === e.options.transport) {
        var n, r = $9481eb156b453e62$var$Xr(e.data, e.options), i = new Headers;
        $9481eb156b453e62$var$K(i, function(e, t) {
            i.append(t, e);
        }), "POST" !== e.options.method || e.options.blob || i.append("Content-Type", "application/x-www-form-urlencoded");
        var o = e.url;
        return $9481eb156b453e62$var$T(e.retriesPerformedSoFar) && e.retriesPerformedSoFar > 0 && (o = $9481eb156b453e62$var$Kr(o, {
            retry_count: e.retriesPerformedSoFar
        }, {})), void $9481eb156b453e62$var$H(o, {
            method: (null === (n = e.options) || void 0 === n ? void 0 : n.method) || "GET",
            headers: i,
            keepalive: "POST" === e.options.method,
            body: r
        }).then(function(n) {
            var r = n.status;
            return n.text().then(function(n) {
                var o, s;
                if (null === (o = e.onResponse) || void 0 === o || o.call(e, {
                    statusCode: r,
                    responseText: n
                }), 200 !== r) $9481eb156b453e62$var$R(e.onError) && e.onError({
                    statusCode: r,
                    responseText: n
                }), (r < 400 || r > 500) && e.retryQueue.enqueue($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, e), {}, {
                    headers: i,
                    retriesPerformedSoFar: (e.retriesPerformedSoFar || 0) + 1
                })), null === (s = e.callback) || void 0 === s || s.call(e, {
                    status: 0
                });
                else try {
                    var a;
                    null === (a = e.callback) || void 0 === a || a.call(e, JSON.parse(n));
                } catch (e) {
                    $9481eb156b453e62$var$G.error(e);
                }
            });
        }).catch(function(t) {
            var n;
            $9481eb156b453e62$var$G.error(t), null === (n = e.callback) || void 0 === n || n.call(e, {
                status: 0
            });
        });
    }
    return $9481eb156b453e62$var$ei(e);
}, $9481eb156b453e62$var$ei = function(e) {
    var t = e.url, n = e.data, r = e.headers, i = e.options, o = e.callback, s = e.retriesPerformedSoFar, a = e.retryQueue, u = e.onError, l = e.timeout, c = void 0 === l ? 6e4 : l, d = e.onResponse;
    $9481eb156b453e62$var$T(s) && s > 0 && (t = $9481eb156b453e62$var$Kr(t, {
        retry_count: s
    }, {}));
    var f = new XMLHttpRequest;
    f.open(i.method || "GET", t, !0);
    var h = $9481eb156b453e62$var$Xr(n, i);
    $9481eb156b453e62$var$K(r, function(e, t) {
        f.setRequestHeader(t, e);
    }), "POST" !== i.method || i.blob || f.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), f.timeout = c, f.withCredentials = !0, f.onreadystatechange = function() {
        if (4 === f.readyState) {
            var e = {
                statusCode: f.status,
                responseText: f.responseText
            };
            if (null == d || d(e), 200 === f.status) {
                if (o) {
                    var l;
                    try {
                        l = JSON.parse(f.responseText);
                    } catch (e) {
                        return void $9481eb156b453e62$var$G.error(e);
                    }
                    o(l);
                }
            } else $9481eb156b453e62$var$R(u) && u(e), (f.status < 400 || f.status > 500) && a.enqueue({
                url: t,
                data: n,
                options: i,
                headers: r,
                retriesPerformedSoFar: (s || 0) + 1,
                callback: o
            }), null == o || o({
                status: 0
            });
        }
    }, f.send(h);
};
var $9481eb156b453e62$var$ti, $9481eb156b453e62$var$ni = function(e) {
    $9481eb156b453e62$var$a(i, $9481eb156b453e62$var$lr);
    var n = $9481eb156b453e62$var$f(i);
    function i(e, t) {
        var o;
        return $9481eb156b453e62$var$r(this, i), (o = n.call(this)).isPolling = !1, o.queue = [], o.areWeOnline = !0, o.onRequestError = e, o.rateLimiter = t, !$9481eb156b453e62$var$E($9481eb156b453e62$var$A) && "onLine" in $9481eb156b453e62$var$A.navigator && (o.areWeOnline = $9481eb156b453e62$var$A.navigator.onLine, $9481eb156b453e62$var$A.addEventListener("online", function() {
            o._handleWeAreNowOnline();
        }), $9481eb156b453e62$var$A.addEventListener("offline", function() {
            o.areWeOnline = !1;
        })), o;
    }
    return $9481eb156b453e62$var$o(i, [
        {
            key: "enqueue",
            value: function(e) {
                var t = e.retriesPerformedSoFar || 0;
                if (!(t >= 10)) {
                    var n = function(e) {
                        var t = 3e3 * Math.pow(2, e), n = t / 2, r = Math.min(18e5, t), i = (Math.random() - .5) * (r - n);
                        return Math.ceil(r + i);
                    }(t), r = new Date(Date.now() + n);
                    this.queue.push({
                        retryAt: r,
                        requestData: e
                    });
                    var i = "Enqueued failed request for retry in ".concat(n);
                    navigator.onLine || (i += " (Browser is offline)"), $9481eb156b453e62$var$G.warn(i), this.isPolling || (this.isPolling = !0, this.poll());
                }
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                this._poller && clearTimeout(this._poller), this._poller = setTimeout(function() {
                    e.areWeOnline && e.queue.length > 0 && e.flush(), e.poll();
                }, this._pollInterval);
            }
        },
        {
            key: "flush",
            value: function() {
                var e = new Date(Date.now()), t = this.queue.filter(function(t) {
                    return t.retryAt < e;
                });
                if (t.length > 0) {
                    this.queue = this.queue.filter(function(t) {
                        return t.retryAt >= e;
                    });
                    var n, r = $9481eb156b453e62$var$v(t);
                    try {
                        for(r.s(); !(n = r.n()).done;){
                            var i = n.value.requestData;
                            this._executeXhrRequest(i);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
            }
        },
        {
            key: "unload",
            value: function() {
                this._poller && (clearTimeout(this._poller), this._poller = void 0);
                var e, n = $9481eb156b453e62$var$v(this.queue);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var r = e.value.requestData, i = r.url, o = r.data, s = r.options;
                        if (this.rateLimiter.isRateLimited(s._batchKey)) $9481eb156b453e62$var$G.warn("[RetryQueue] is quota limited. Dropping request.");
                        else try {
                            null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.navigator.sendBeacon(i, $9481eb156b453e62$var$Xr(o, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, s), {}, {
                                sendBeacon: !0
                            })));
                        } catch (e) {
                            $9481eb156b453e62$var$G.error(e);
                        }
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                this.queue = [];
            }
        },
        {
            key: "_executeXhrRequest",
            value: function(e) {
                var t = e.url, n = e.data, r = e.options, i = e.headers, o = e.callback, s = e.retriesPerformedSoFar;
                this.rateLimiter.isRateLimited(r._batchKey) || $9481eb156b453e62$var$Zr({
                    url: t,
                    data: n || {},
                    options: r || {},
                    headers: i || {},
                    retriesPerformedSoFar: s || 0,
                    callback: o,
                    retryQueue: this,
                    onError: this.onRequestError,
                    onResponse: this.rateLimiter.checkForLimiting
                });
            }
        },
        {
            key: "_handleWeAreNowOnline",
            value: function() {
                this.areWeOnline = !0, this.flush();
            }
        }
    ]), i;
}(), $9481eb156b453e62$var$ri = 1800, $9481eb156b453e62$var$ii = function() {
    function e(t, n, i, o) {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_sessionIdChangedHandlers", []), this.config = t, this.persistence = n, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = i || $9481eb156b453e62$var$lt, this._windowIdGenerator = o || $9481eb156b453e62$var$lt;
        var a = t.persistence_name || t.token, u = t.session_idle_timeout_seconds || $9481eb156b453e62$var$ri;
        if ($9481eb156b453e62$var$T(u) ? u > $9481eb156b453e62$var$ri ? $9481eb156b453e62$var$G.warn("session_idle_timeout_seconds cannot be  greater than 30 minutes. Using 30 minutes instead.") : u < 60 && $9481eb156b453e62$var$G.warn("session_idle_timeout_seconds cannot be less than 60 seconds. Using 60 seconds instead.") : ($9481eb156b453e62$var$G.warn("session_idle_timeout_seconds must be a number. Defaulting to 30 minutes."), u = $9481eb156b453e62$var$ri), this._sessionTimeoutMs = 1e3 * Math.min(Math.max(u, 60), $9481eb156b453e62$var$ri), this._window_id_storage_key = "ph_" + a + "_window_id", this._primary_window_exists_storage_key = "ph_" + a + "_primary_window_exists", this._canUseSessionStorage()) {
            var l = $9481eb156b453e62$var$Ft.parse(this._window_id_storage_key), c = $9481eb156b453e62$var$Ft.parse(this._primary_window_exists_storage_key);
            l && !c ? this._windowId = l : $9481eb156b453e62$var$Ft.remove(this._window_id_storage_key), $9481eb156b453e62$var$Ft.set(this._primary_window_exists_storage_key, !0);
        }
        this._listenToReloadWindow();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "onSessionId",
            value: function(e) {
                var t = this;
                return $9481eb156b453e62$var$E(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(e), this._sessionId && e(this._sessionId, this._windowId), function() {
                    t._sessionIdChangedHandlers = t._sessionIdChangedHandlers.filter(function(t) {
                        return t !== e;
                    });
                };
            }
        },
        {
            key: "_canUseSessionStorage",
            value: function() {
                return "memory" !== this.config.persistence && !this.persistence.disabled && $9481eb156b453e62$var$Ft.is_supported();
            }
        },
        {
            key: "_setWindowId",
            value: function(e) {
                e !== this._windowId && (this._windowId = e, this._canUseSessionStorage() && $9481eb156b453e62$var$Ft.set(this._window_id_storage_key, e));
            }
        },
        {
            key: "_getWindowId",
            value: function() {
                return this._windowId ? this._windowId : this._canUseSessionStorage() ? $9481eb156b453e62$var$Ft.parse(this._window_id_storage_key) : null;
            }
        },
        {
            key: "_setSessionId",
            value: function(e, t, n) {
                e === this._sessionId && t === this._sessionActivityTimestamp && n === this._sessionStartTimestamp || (this._sessionStartTimestamp = n, this._sessionActivityTimestamp = t, this._sessionId = e, this.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ne, [
                    t,
                    e,
                    n
                ])));
            }
        },
        {
            key: "_getSessionId",
            value: function() {
                if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
                    this._sessionActivityTimestamp,
                    this._sessionId,
                    this._sessionStartTimestamp
                ];
                var e = this.persistence.props[$9481eb156b453e62$var$Ne];
                return $9481eb156b453e62$var$S(e) && 2 === e.length && e.push(e[0]), e || [
                    0,
                    null,
                    0
                ];
            }
        },
        {
            key: "resetSessionId",
            value: function() {
                this._setSessionId(null, null, null);
            }
        },
        {
            key: "_listenToReloadWindow",
            value: function() {
                var e = this;
                null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.addEventListener("beforeunload", function() {
                    e._canUseSessionStorage() && $9481eb156b453e62$var$Ft.remove(e._primary_window_exists_storage_key);
                });
            }
        },
        {
            key: "checkAndGetSessionAndWindowId",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || (new Date).getTime(), n = $9481eb156b453e62$var$h(this._getSessionId(), 3), r = n[0], i = n[1], o = n[2], s = this._getWindowId(), a = o && o > 0 && Math.abs(t - o) > 864e5, u = !1, l = !i, c = !e && Math.abs(t - r) > this._sessionTimeoutMs;
                l || c || a ? (i = this._sessionIdGenerator(), s = this._windowIdGenerator(), $9481eb156b453e62$var$G.info("[SessionId] new session ID generated", {
                    sessionId: i,
                    windowId: s,
                    changeReason: {
                        noSessionId: l,
                        activityTimeout: c,
                        sessionPastMaximumLength: a
                    }
                }), o = t, u = !0) : s || (s = this._windowIdGenerator(), u = !0);
                var d = 0 === r || !e || a ? t : r, f = 0 === o ? (new Date).getTime() : o;
                return this._setWindowId(s), this._setSessionId(i, d, f), u && this._sessionIdChangedHandlers.forEach(function(e) {
                    return e(i, s);
                }), {
                    sessionId: i,
                    windowId: s,
                    sessionStartTimestamp: f
                };
            }
        }
    ]), e;
}();
!function(e) {
    e.US = "us", e.EU = "eu", e.CUSTOM = "custom";
}($9481eb156b453e62$var$ti || ($9481eb156b453e62$var$ti = {}));
var $9481eb156b453e62$var$oi = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "apiHost",
            get: function() {
                return this.instance.config.api_host.trim().replace(/\/$/, "");
            }
        },
        {
            key: "uiHost",
            get: function() {
                var e;
                return null === (e = this.instance.config.ui_host) || void 0 === e ? void 0 : e.replace(/\/$/, "");
            }
        },
        {
            key: "region",
            get: function() {
                switch(this.apiHost){
                    case "https://app.posthog.com":
                    case "https://us.posthog.com":
                        return $9481eb156b453e62$var$ti.US;
                    case "https://eu.posthog.com":
                        return $9481eb156b453e62$var$ti.EU;
                    default:
                        return $9481eb156b453e62$var$ti.CUSTOM;
                }
            }
        },
        {
            key: "endpointFor",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                if (t && (t = "/" === t[0] ? t : "/".concat(t)), "ui" === e) return (this.uiHost || this.apiHost) + t;
                if (this.region === $9481eb156b453e62$var$ti.CUSTOM) return this.apiHost + t;
                var n = "i.posthog.com" + t;
                switch(e){
                    case "assets":
                        return "https://".concat(this.region, "-assets.").concat(n);
                    case "api":
                        return "https://".concat(this.region, ".").concat(n);
                }
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$si = $9481eb156b453e62$var$o(function e(t, n, i, o) {
    $9481eb156b453e62$var$r(this, e), this.name = "posthog-js", this.setupOnce = function(e) {
        e(function(e) {
            var r, s, a, u, l;
            if ("error" !== e.level || !t.__loaded) return e;
            e.tags || (e.tags = {});
            var c = t.requestRouter.endpointFor("ui", "/person/" + t.get_distinct_id());
            e.tags["PostHog Person URL"] = c, t.sessionRecordingStarted() && (e.tags["PostHog Recording URL"] = t.get_session_replay_url({
                withTimestamp: !0
            }));
            var d = (null === (r = e.exception) || void 0 === r ? void 0 : r.values) || [], f = {
                $exception_message: null === (s = d[0]) || void 0 === s ? void 0 : s.value,
                $exception_type: null === (a = d[0]) || void 0 === a ? void 0 : a.type,
                $exception_personURL: c,
                $sentry_event_id: e.event_id,
                $sentry_exception: e.exception,
                $sentry_exception_message: null === (u = d[0]) || void 0 === u ? void 0 : u.value,
                $sentry_exception_type: null === (l = d[0]) || void 0 === l ? void 0 : l.type,
                $sentry_tags: e.tags
            };
            return n && i && (f.$sentry_url = (o || "https://sentry.io/organizations/") + n + "/issues/?project=" + i + "&query=" + e.event_id), t.capture("$exception", f), e;
        });
    };
}), $9481eb156b453e62$var$ai = function() {
    function e(t) {
        var n = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_hasSeenPageView", !1), $9481eb156b453e62$var$s(this, "_updateScrollData", function() {
            var e, t, r, i;
            n._pageViewData || (n._pageViewData = n._createPageViewData());
            var o = n._pageViewData, s = n._scrollY(), a = n._scrollHeight(), u = n._contentY(), l = n._contentHeight();
            o.lastScrollY = s, o.maxScrollY = Math.max(s, null !== (e = o.maxScrollY) && void 0 !== e ? e : 0), o.maxScrollHeight = Math.max(a, null !== (t = o.maxScrollHeight) && void 0 !== t ? t : 0), o.lastContentY = u, o.maxContentY = Math.max(u, null !== (r = o.maxContentY) && void 0 !== r ? r : 0), o.maxContentHeight = Math.max(l, null !== (i = o.maxContentHeight) && void 0 !== i ? i : 0);
        }), this._instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_createPageViewData",
            value: function() {
                var e;
                return {
                    pathname: null !== (e = null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.location.pathname) && void 0 !== e ? e : ""
                };
            }
        },
        {
            key: "doPageView",
            value: function() {
                var e, n;
                return this._hasSeenPageView ? (n = this._pageViewData, this._pageViewData = this._createPageViewData()) : (this._hasSeenPageView = !0, n = void 0, this._pageViewData || (this._pageViewData = this._createPageViewData())), setTimeout(this._updateScrollData, 0), $9481eb156b453e62$var$t({
                    $prev_pageview_pathname: null === (e = n) || void 0 === e ? void 0 : e.pathname
                }, this._calculatePrevPageScrollProperties(n));
            }
        },
        {
            key: "doPageLeave",
            value: function() {
                var e = this._pageViewData;
                return $9481eb156b453e62$var$t({
                    $prev_pageview_pathname: null == e ? void 0 : e.pathname
                }, this._calculatePrevPageScrollProperties(e));
            }
        },
        {
            key: "_calculatePrevPageScrollProperties",
            value: function(e) {
                if (!e || null == e.maxScrollHeight || null == e.lastScrollY || null == e.maxScrollY || null == e.maxContentHeight || null == e.lastContentY || null == e.maxContentY) return {};
                var t = e.maxScrollHeight, n = e.lastScrollY, r = e.maxScrollY, i = e.maxContentHeight, o = e.lastContentY, s = e.maxContentY;
                return t = Math.ceil(t), n = Math.ceil(n), r = Math.ceil(r), i = Math.ceil(i), o = Math.ceil(o), s = Math.ceil(s), {
                    $prev_pageview_last_scroll: n,
                    $prev_pageview_last_scroll_percentage: t <= 1 ? 1 : $9481eb156b453e62$var$ui(n / t, 0, 1),
                    $prev_pageview_max_scroll: r,
                    $prev_pageview_max_scroll_percentage: t <= 1 ? 1 : $9481eb156b453e62$var$ui(r / t, 0, 1),
                    $prev_pageview_last_content: o,
                    $prev_pageview_last_content_percentage: i <= 1 ? 1 : $9481eb156b453e62$var$ui(o / i, 0, 1),
                    $prev_pageview_max_content: s,
                    $prev_pageview_max_content_percentage: i <= 1 ? 1 : $9481eb156b453e62$var$ui(s / i, 0, 1)
                };
            }
        },
        {
            key: "startMeasuringScrollPosition",
            value: function() {
                null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.addEventListener("scroll", this._updateScrollData, !0), null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.addEventListener("scrollend", this._updateScrollData, !0), null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.addEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "stopMeasuringScrollPosition",
            value: function() {
                null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.removeEventListener("scroll", this._updateScrollData), null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.removeEventListener("scrollend", this._updateScrollData), null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.removeEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "_scrollElement",
            value: function() {
                if (!this._instance.config.scroll_root_selector) return null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.document.documentElement;
                var e, t = $9481eb156b453e62$var$v($9481eb156b453e62$var$S(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
                    this._instance.config.scroll_root_selector
                ]);
                try {
                    for(t.s(); !(e = t.n()).done;){
                        var n = e.value, r = null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.document.querySelector(n);
                        if (r) return r;
                    }
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
            }
        },
        {
            key: "_scrollHeight",
            value: function() {
                var e = this._scrollElement();
                return e ? Math.max(0, e.scrollHeight - e.clientHeight) : 0;
            }
        },
        {
            key: "_scrollY",
            value: function() {
                if (this._instance.config.scroll_root_selector) {
                    var e = this._scrollElement();
                    return e && e.scrollTop || 0;
                }
                return $9481eb156b453e62$var$A && ($9481eb156b453e62$var$A.scrollY || $9481eb156b453e62$var$A.pageYOffset || $9481eb156b453e62$var$A.document.documentElement.scrollTop) || 0;
            }
        },
        {
            key: "_contentHeight",
            value: function() {
                var e = this._scrollElement();
                return (null == e ? void 0 : e.scrollHeight) || 0;
            }
        },
        {
            key: "_contentY",
            value: function() {
                var e = this._scrollElement(), t = (null == e ? void 0 : e.clientHeight) || 0;
                return this._scrollY() + t;
            }
        }
    ]), e;
}();
function $9481eb156b453e62$var$ui(e, t, n) {
    return Math.max(t, Math.min(e, n));
}
var $9481eb156b453e62$var$li, $9481eb156b453e62$var$ci, $9481eb156b453e62$var$di, $9481eb156b453e62$var$fi = {
    icontains: function(e) {
        return !!$9481eb156b453e62$var$A && $9481eb156b453e62$var$A.location.href.toLowerCase().indexOf(e.toLowerCase()) > -1;
    },
    regex: function(e) {
        return !!$9481eb156b453e62$var$A && $9481eb156b453e62$var$xt($9481eb156b453e62$var$A.location.href, e);
    },
    exact: function(e) {
        return (null == $9481eb156b453e62$var$A ? void 0 : $9481eb156b453e62$var$A.location.href) === e;
    }
}, $9481eb156b453e62$var$hi = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "getSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = this.instance.get_property($9481eb156b453e62$var$Ve);
                if (r && !n) return e(r);
                this.instance._send_request(this.instance.requestRouter.endpointFor("api", "/api/surveys/?token=".concat(this.instance.config.token)), {}, {
                    method: "GET"
                }, function(n) {
                    var r, i = n.surveys || [];
                    return null === (r = t.instance.persistence) || void 0 === r || r.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ve, i)), e(i);
                });
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.getSurveys(function(n) {
                    var r = n.filter(function(e) {
                        return !(!e.start_date || e.end_date);
                    }).filter(function(e) {
                        var t, n, r, i;
                        if (!e.conditions) return !0;
                        var o = null === (t = e.conditions) || void 0 === t || !t.url || $9481eb156b453e62$var$fi[null !== (n = null === (r = e.conditions) || void 0 === r ? void 0 : r.urlMatchType) && void 0 !== n ? n : "icontains"](e.conditions.url), s = null === (i = e.conditions) || void 0 === i || !i.selector || (null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelector(e.conditions.selector));
                        return o && s;
                    }).filter(function(e) {
                        if (!e.linked_flag_key && !e.targeting_flag_key) return !0;
                        var n = !e.linked_flag_key || t.instance.featureFlags.isFeatureEnabled(e.linked_flag_key), r = !e.targeting_flag_key || t.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key);
                        return n && r;
                    });
                    return e(r);
                }, n);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$pi = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "limits", {}), $9481eb156b453e62$var$s(this, "checkForLimiting", function(e) {
            var n = e.responseText;
            if (n && n.length) try {
                (JSON.parse(n).quota_limited || []).forEach(function(e) {
                    $9481eb156b453e62$var$G.info("[RateLimiter] ".concat(e || "events", " is quota limited.")), t.limits[e] = (new Date).getTime() + 6e4;
                });
            } catch (e) {
                return void $9481eb156b453e62$var$G.warn('[RateLimiter] could not rate limit - continuing. Error: "'.concat(null == e ? void 0 : e.message, '"'), {
                    text: n
                });
            }
        });
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "isRateLimited",
            value: function(e) {
                var t = this.limits[e || "events"] || !1;
                return !1 !== t && (new Date).getTime() < t;
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$_i = function() {
    return $9481eb156b453e62$var$t({
        initialPathName: (null == $9481eb156b453e62$var$j ? void 0 : $9481eb156b453e62$var$j.pathname) || "",
        referringDomain: $9481eb156b453e62$var$In.referringDomain()
    }, $9481eb156b453e62$var$In.campaignParams());
}, $9481eb156b453e62$var$gi = function() {
    function e(t, n, i) {
        var o = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_onSessionIdCallback", function(e) {
            var t = o._getStoredProps();
            if (!t || t.sessionId !== e) {
                var n = {
                    sessionId: e,
                    props: o._sessionSourceParamGenerator()
                };
                o._persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Qe, n));
            }
        }), this._sessionIdManager = t, this._persistence = n, this._sessionSourceParamGenerator = i || $9481eb156b453e62$var$_i, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_getStoredProps",
            value: function() {
                return this._persistence.props[$9481eb156b453e62$var$Qe];
            }
        },
        {
            key: "getSessionProps",
            value: function() {
                var e, t = null === (e = this._getStoredProps()) || void 0 === e ? void 0 : e.props;
                return t ? {
                    $client_session_initial_referring_host: t.referringDomain,
                    $client_session_initial_pathname: t.initialPathName,
                    $client_session_initial_utm_source: t.utm_source,
                    $client_session_initial_utm_campaign: t.utm_campaign,
                    $client_session_initial_utm_medium: t.utm_medium,
                    $client_session_initial_utm_content: t.utm_content,
                    $client_session_initial_utm_term: t.utm_term
                } : {};
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$vi = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "applebot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "bot.htm",
    "bot.php",
    "crawler",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "gptbot",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "semrushbot",
    "sitebulb",
    "slurp",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
], $9481eb156b453e62$var$mi = function(e, t) {
    if (!e) return !1;
    var n = e.toLowerCase();
    return $9481eb156b453e62$var$vi.concat(t || []).some(function(e) {
        var t = e.toLowerCase();
        return n.includes ? n.includes(t) : -1 !== n.indexOf(t);
    });
};
!function(e) {
    e[e.INIT_MODULE = 0] = "INIT_MODULE", e[e.INIT_SNIPPET = 1] = "INIT_SNIPPET";
}($9481eb156b453e62$var$li || ($9481eb156b453e62$var$li = {}));
var $9481eb156b453e62$var$yi = function() {}, $9481eb156b453e62$var$bi = {}, $9481eb156b453e62$var$wi = "posthog", $9481eb156b453e62$var$ki = !$9481eb156b453e62$var$Pt && -1 === (null == $9481eb156b453e62$var$V ? void 0 : $9481eb156b453e62$var$V.indexOf("MSIE")) && -1 === (null == $9481eb156b453e62$var$V ? void 0 : $9481eb156b453e62$var$V.indexOf("Mozilla")), $9481eb156b453e62$var$Si = function() {
    var e, t, n;
    return {
        api_host: "https://app.posthog.com",
        api_method: "POST",
        api_transport: "XHR",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: (t = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.location, n = null == t ? void 0 : t.hostname, !!$9481eb156b453e62$var$x(n) && "herokuapp.com" !== n.split(".").slice(-2).join(".")),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_name: "",
        loaded: $9481eb156b453e62$var$yi,
        store_google: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: !0,
        debug: !1,
        verbose: !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_cookie: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $9481eb156b453e62$var$A || null === (e = $9481eb156b453e62$var$A.location) || void 0 === e ? void 0 : e.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_blacklist: [],
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        inapp_protocol: "//",
        inapp_link_new_window: !1,
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        on_request_error: function(e) {
            var t = "Bad HTTP status: " + e.statusCode + " " + e.responseText;
            $9481eb156b453e62$var$G.error(t);
        },
        get_device_id: function(e) {
            return e;
        },
        _onCapture: $9481eb156b453e62$var$yi,
        capture_performance: void 0,
        name: "posthog",
        callback_fn: "posthog._jsc",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800
    };
}, $9481eb156b453e62$var$Fi = function(e, t, n, r) {
    var i, o = n !== $9481eb156b453e62$var$wi && $9481eb156b453e62$var$di ? n ? $9481eb156b453e62$var$di[n] : void 0 : $9481eb156b453e62$var$di, s = {
        initComplete: !1,
        syncCode: !1
    }, a = function(e) {
        return function(t) {
            s[e] || (s[e] = !0, s.initComplete && s.syncCode && (null == r || r(t)));
        };
    };
    if (o && $9481eb156b453e62$var$ci === $9481eb156b453e62$var$li.INIT_MODULE) i = o;
    else {
        if (o && !$9481eb156b453e62$var$S(o)) return void $9481eb156b453e62$var$G.error("You have already initialized " + n);
        i = new $9481eb156b453e62$export$a9d6b9cbf49b8241;
    }
    if (i._init(e, t, n, a("initComplete")), i.toolbar.maybeLoadToolbar(), i.sessionRecording = new $9481eb156b453e62$var$ir(i), i.sessionRecording.startRecordingIfEnabled(), i.config.disable_scroll_properties || i.pageViewManager.startMeasuringScrollPosition(), i.__autocapture = i.config.autocapture, $9481eb156b453e62$var$Ke._setIsAutocaptureEnabled(i), $9481eb156b453e62$var$Ke._isAutocaptureEnabled) {
        i.__autocapture = i.config.autocapture;
        $9481eb156b453e62$var$Ke.enabledForProject(i.config.token, 100, 100) ? $9481eb156b453e62$var$Ke.isBrowserSupported() ? $9481eb156b453e62$var$Ke.init(i) : (i.__autocapture = !1, $9481eb156b453e62$var$G.info("Disabling Automatic Event Collection because this browser is not supported")) : (i.__autocapture = !1, $9481eb156b453e62$var$G.info("Not in active bucket: disabling Automatic Event Collection."));
    }
    return $9481eb156b453e62$var$m.DEBUG = $9481eb156b453e62$var$m.DEBUG || i.config.debug, !$9481eb156b453e62$var$E(o) && $9481eb156b453e62$var$S(o) && (i._execute_array.call(i.people, o.people), i._execute_array(o)), a("syncCode")(i), i;
}, $9481eb156b453e62$var$Ri = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "__forceAllowLocalhost", !1);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_forceAllowLocalhost",
            get: function() {
                return this.__forceAllowLocalhost;
            },
            set: function(e) {
                $9481eb156b453e62$var$G.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
            }
        }
    ]), e;
}(), $9481eb156b453e62$export$a9d6b9cbf49b8241 = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "webPerformance", new $9481eb156b453e62$var$Ri), this.config = $9481eb156b453e62$var$Si(), this.compression = {}, this.decideEndpointWasHit = !1, this.SentryIntegration = $9481eb156b453e62$var$si, this.segmentIntegration = function() {
            return function(e) {
                Promise && Promise.resolve || $9481eb156b453e62$var$G.warn("This browser does not have Promise support, and can not use the segment integration");
                var t = function(t, n) {
                    t.event.userId || t.event.anonymousId === e.get_distinct_id() || e.reset(), t.event.userId && t.event.userId !== e.get_distinct_id() && (e.register({
                        distinct_id: t.event.userId
                    }), e.reloadFeatureFlags());
                    var r = e._calculate_event_properties(n, t.event.properties);
                    return t.event.properties = Object.assign({}, r, t.event.properties), t;
                };
                return {
                    name: "PostHog JS",
                    type: "enrichment",
                    version: "1.0.0",
                    isLoaded: function() {
                        return !0;
                    },
                    load: function() {
                        return Promise.resolve();
                    },
                    track: function(e) {
                        return t(e, e.event.event);
                    },
                    page: function(e) {
                        return t(e, "$pageview");
                    },
                    identify: function(e) {
                        return t(e, "$identify");
                    },
                    screen: function(e) {
                        return t(e, "$screen");
                    }
                };
            }(t);
        }, this.__captureHooks = [], this.__request_queue = [], this.__loaded = !1, this.__loaded_recorder_version = void 0, this.__autocapture = void 0, this._jsc = function() {}, this.analyticsDefaultEndpoint = "/e/", this.elementsChainAsString = !1, this.featureFlags = new $9481eb156b453e62$var$nt(this), this.toolbar = new $9481eb156b453e62$var$ur(this), this.pageViewManager = new $9481eb156b453e62$var$ai(this), this.surveys = new $9481eb156b453e62$var$hi(this), this.rateLimiter = new $9481eb156b453e62$var$pi, this.requestRouter = new $9481eb156b453e62$var$oi(this), this.people = {
            set: function(e, n, r) {
                var i = $9481eb156b453e62$var$x(e) ? $9481eb156b453e62$var$s({}, e, n) : e;
                t.setPersonProperties(i), null == r || r({});
            },
            set_once: function(e, n, r) {
                var i = $9481eb156b453e62$var$x(e) ? $9481eb156b453e62$var$s({}, e, n) : e;
                t.setPersonProperties(void 0, i), null == r || r({});
            }
        };
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "init",
            value: function(e, t, n) {
                if ($9481eb156b453e62$var$E(n)) $9481eb156b453e62$var$G.critical("You must name your new library: init(token, config, name)");
                else if ($9481eb156b453e62$var$E(e) || function(e) {
                    return $9481eb156b453e62$var$x(e) && 0 === e.trim().length;
                }(e)) $9481eb156b453e62$var$G.critical("You must provide a token to initialize posthog");
                else {
                    if (n !== $9481eb156b453e62$var$wi) {
                        var r = $9481eb156b453e62$var$Fi(e, t, n, function(e) {
                            $9481eb156b453e62$var$di[n] = e, e._loaded();
                        });
                        return $9481eb156b453e62$var$di[n] = r, r;
                    }
                    $9481eb156b453e62$var$G.critical("You must initialize the main posthog object right after you include the PostHog js snippet");
                }
            }
        },
        {
            key: "_init",
            value: function(e) {
                var n, r, i, o = this, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 ? arguments[2] : void 0, u = arguments.length > 3 ? arguments[3] : void 0;
                this.__loaded = !0, this.config = {}, this._triggered_notifs = [];
                var l, c = {
                    segmentRegister: !1,
                    syncCode: !1
                }, d = function(e) {
                    return function() {
                        c[e] || (c[e] = !0, c.segmentRegister && c.syncCode && (null == u || u(o)));
                    };
                };
                (s.request_headers = s.request_headers || s.xhr_headers, this.set_config($9481eb156b453e62$var$X({}, $9481eb156b453e62$var$Si(), s, {
                    name: a,
                    token: e,
                    callback_fn: (a === $9481eb156b453e62$var$wi ? a : $9481eb156b453e62$var$wi + "." + a) + "._jsc"
                })), this._jsc = function() {}, null != $9481eb156b453e62$var$A && null !== (n = $9481eb156b453e62$var$A.rrweb) && void 0 !== n && n.record || null != $9481eb156b453e62$var$A && $9481eb156b453e62$var$A.rrwebRecord) && (this.__loaded_recorder_version = null == $9481eb156b453e62$var$A || null === (l = $9481eb156b453e62$var$A.rrweb) || void 0 === l ? void 0 : l.version);
                if (this.persistence = new $9481eb156b453e62$var$Tn(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $9481eb156b453e62$var$Tn($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                })), this._requestQueue = new $9481eb156b453e62$var$cr(this._handle_queued_event.bind(this)), this._retryQueue = new $9481eb156b453e62$var$ni(this.config.on_request_error, this.rateLimiter), this.__captureHooks = [], this.__request_queue = [], this.sessionManager = new $9481eb156b453e62$var$ii(this.config, this.persistence), this.sessionPropsManager = new $9481eb156b453e62$var$gi(this.sessionManager, this.persistence), this._gdpr_init(), s.segment ? (this.config.get_device_id = function() {
                    return s.segment.user().anonymousId();
                }, s.segment.user().id() && (this.register({
                    distinct_id: s.segment.user().id()
                }), this.persistence.set_user_state("identified")), s.segment.register(this.segmentIntegration()).then(d("segmentRegister"))) : d("segmentRegister")(), void 0 !== (null === (r = s.bootstrap) || void 0 === r ? void 0 : r.distinctID)) {
                    var f, h, p = this.config.get_device_id($9481eb156b453e62$var$lt()), _ = null !== (f = s.bootstrap) && void 0 !== f && f.isIdentifiedID ? p : s.bootstrap.distinctID;
                    this.persistence.set_user_state(null !== (h = s.bootstrap) && void 0 !== h && h.isIdentifiedID ? "identified" : "anonymous"), this.register({
                        distinct_id: s.bootstrap.distinctID,
                        $device_id: _
                    });
                }
                if (this._hasBootstrappedFeatureFlags()) {
                    var g, v, m = Object.keys((null === (g = s.bootstrap) || void 0 === g ? void 0 : g.featureFlags) || {}).filter(function(e) {
                        var t, n;
                        return !(null === (t = s.bootstrap) || void 0 === t || null === (n = t.featureFlags) || void 0 === n || !n[e]);
                    }).reduce(function(e, t) {
                        var n, r;
                        return e[t] = (null === (n = s.bootstrap) || void 0 === n || null === (r = n.featureFlags) || void 0 === r ? void 0 : r[t]) || !1, e;
                    }, {}), y = Object.keys((null === (v = s.bootstrap) || void 0 === v ? void 0 : v.featureFlagPayloads) || {}).filter(function(e) {
                        return m[e];
                    }).reduce(function(e, t) {
                        var n, r, i, o;
                        null !== (n = s.bootstrap) && void 0 !== n && null !== (r = n.featureFlagPayloads) && void 0 !== r && r[t] && (e[t] = null === (i = s.bootstrap) || void 0 === i || null === (o = i.featureFlagPayloads) || void 0 === o ? void 0 : o[t]);
                        return e;
                    }, {});
                    this.featureFlags.receivedFeatureFlags({
                        featureFlags: m,
                        featureFlagPayloads: y
                    });
                }
                if (!this.get_distinct_id()) {
                    var b = this.config.get_device_id($9481eb156b453e62$var$lt());
                    this.register_once({
                        distinct_id: b,
                        $device_id: b
                    }, ""), this.persistence.set_user_state("anonymous");
                }
                null == $9481eb156b453e62$var$A || null === (i = $9481eb156b453e62$var$A.addEventListener) || void 0 === i || i.call($9481eb156b453e62$var$A, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), d("syncCode")();
            }
        },
        {
            key: "_afterDecideResponse",
            value: function(e) {
                var t;
                if (this.compression = {}, e.supportedCompression && !this.config.disable_compression) {
                    var n, r = {}, i = $9481eb156b453e62$var$v(e.supportedCompression);
                    try {
                        for(i.s(); !(n = i.n()).done;)r[n.value] = !0;
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    this.compression = r;
                }
                null !== (t = e.analytics) && void 0 !== t && t.endpoint && (this.analyticsDefaultEndpoint = e.analytics.endpoint), e.elementsChainAsString && (this.elementsChainAsString = e.elementsChainAsString);
            }
        },
        {
            key: "_loaded",
            value: function() {
                var e = this.config.advanced_disable_decide;
                e || this.featureFlags.setReloadingPaused(!0);
                try {
                    this.config.loaded(this);
                } catch (e) {
                    $9481eb156b453e62$var$G.critical("`loaded` function failed", e);
                }
                this._start_queue_if_opted_in(), this.config.capture_pageview && $9481eb156b453e62$var$B && this.capture("$pageview", {
                    title: $9481eb156b453e62$var$B.title
                }, {
                    send_instantly: !0
                }), e || (new $9481eb156b453e62$var$or(this).call(), this.featureFlags.resetRequestQueue());
            }
        },
        {
            key: "_start_queue_if_opted_in",
            value: function() {
                var e;
                this.has_opted_out_capturing() || this.config.request_batching && (null === (e = this._requestQueue) || void 0 === e || e.poll());
            }
        },
        {
            key: "_dom_loaded",
            value: function() {
                var e = this;
                this.has_opted_out_capturing() || $9481eb156b453e62$var$J(this.__request_queue, function(t) {
                    e._send_request.apply(e, $9481eb156b453e62$var$p(t));
                }), this.__request_queue = [], this._start_queue_if_opted_in();
            }
        },
        {
            key: "_prepare_callback",
            value: function(e, t) {
                if ($9481eb156b453e62$var$E(e)) return null;
                if ($9481eb156b453e62$var$Pt) return function(n) {
                    e(n, t);
                };
                var n = this._jsc, r = "" + Math.floor(1e8 * Math.random()), i = this.config.callback_fn + "[" + r + "]";
                return n[r] = function(i) {
                    delete n[r], e(i, t);
                }, i;
            }
        },
        {
            key: "_handle_unload",
            value: function() {
                var e, t;
                this.config.request_batching ? (this.config.capture_pageview && this.config.capture_pageleave && this.capture("$pageleave"), null === (e = this._requestQueue) || void 0 === e || e.unload(), null === (t = this._retryQueue) || void 0 === t || t.unload()) : this.config.capture_pageview && this.config.capture_pageleave && this.capture("$pageleave", null, {
                    transport: "sendBeacon"
                });
            }
        },
        {
            key: "_handle_queued_event",
            value: function(e, t, n) {
                var r = JSON.stringify(t);
                this.__compress_and_send_json_request(e, r, n || $9481eb156b453e62$var$bi, $9481eb156b453e62$var$yi);
            }
        },
        {
            key: "__compress_and_send_json_request",
            value: function(e, n, r, i) {
                var o = function(e, n, r) {
                    return e === $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS ? [
                        $9481eb156b453e62$var$Yr($9481eb156b453e62$var$Jr(n), {
                            mtime: 0
                        }),
                        $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), {}, {
                            blob: !0,
                            urlQueryArgs: {
                                compression: $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS
                            }
                        })
                    ] : [
                        {
                            data: $9481eb156b453e62$var$se(n)
                        },
                        r
                    ];
                }(this.compression[$9481eb156b453e62$export$6a00d17b5aff0af.GZipJS] ? $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS : $9481eb156b453e62$export$6a00d17b5aff0af.Base64, n, r), s = $9481eb156b453e62$var$h(o, 2), a = s[0], u = s[1];
                this._send_request(e, a, u, i);
            }
        },
        {
            key: "_send_request",
            value: function(e, n, r, i) {
                if (this.__loaded && this._retryQueue && !this.rateLimiter.isRateLimited(r._batchKey)) {
                    if ($9481eb156b453e62$var$ki) this.__request_queue.push([
                        e,
                        n,
                        r,
                        i
                    ]);
                    else {
                        var o = {
                            method: this.config.api_method,
                            transport: this.config.api_transport,
                            verbose: this.config.verbose
                        };
                        r = $9481eb156b453e62$var$X(o, r || {}), $9481eb156b453e62$var$Pt || (r.method = "GET");
                        var s = $9481eb156b453e62$var$A && "sendBeacon" in $9481eb156b453e62$var$A.navigator && "sendBeacon" === r.transport;
                        if (e = $9481eb156b453e62$var$Kr(e, r.urlQueryArgs || {}, {
                            ip: this.config.ip
                        }), s) try {
                            null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.navigator.sendBeacon(e, $9481eb156b453e62$var$Xr(n, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), {}, {
                                sendBeacon: !0
                            })));
                        } catch (e) {}
                        else if ($9481eb156b453e62$var$Pt || !$9481eb156b453e62$var$B) try {
                            $9481eb156b453e62$var$Zr({
                                url: e,
                                data: n,
                                headers: this.config.request_headers,
                                options: r,
                                callback: i,
                                retriesPerformedSoFar: 0,
                                retryQueue: this._retryQueue,
                                onError: this.config.on_request_error,
                                onResponse: this.rateLimiter.checkForLimiting
                            });
                        } catch (e) {
                            $9481eb156b453e62$var$G.error(e);
                        }
                        else {
                            var a, u = $9481eb156b453e62$var$B.createElement("script");
                            u.type = "text/javascript", u.async = !0, u.defer = !0, u.src = e;
                            var l = $9481eb156b453e62$var$B.getElementsByTagName("script")[0];
                            null === (a = l.parentNode) || void 0 === a || a.insertBefore(u, l);
                        }
                    }
                }
            }
        },
        {
            key: "_execute_array",
            value: function(e) {
                var t, n = this, r = [], i = [], o = [];
                $9481eb156b453e62$var$J(e, function(e) {
                    e && (t = e[0], $9481eb156b453e62$var$S(t) ? o.push(e) : $9481eb156b453e62$var$R(e) ? e.call(n) : $9481eb156b453e62$var$S(e) && "alias" === t ? r.push(e) : $9481eb156b453e62$var$S(e) && -1 !== t.indexOf("capture") && $9481eb156b453e62$var$R(n[t]) ? o.push(e) : i.push(e));
                });
                var s = function(e, t) {
                    $9481eb156b453e62$var$J(e, function(e) {
                        if ($9481eb156b453e62$var$S(e[0])) {
                            var n = t;
                            $9481eb156b453e62$var$K(e, function(e) {
                                n = n[e[0]].apply(n, e.slice(1));
                            });
                        } else this[e[0]].apply(this, e.slice(1));
                    }, t);
                };
                s(r, this), s(i, this), s(o, this);
            }
        },
        {
            key: "_hasBootstrappedFeatureFlags",
            value: function() {
                var e, t;
                return (null === (e = this.config.bootstrap) || void 0 === e ? void 0 : e.featureFlags) && Object.keys(null === (t = this.config.bootstrap) || void 0 === t ? void 0 : t.featureFlags).length > 0 || !1;
            }
        },
        {
            key: "push",
            value: function(e) {
                this._execute_array([
                    e
                ]);
            }
        },
        {
            key: "capture",
            value: function(e, n) {
                var r, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $9481eb156b453e62$var$bi;
                if (!this.__loaded || !this.sessionPersistence || !this._requestQueue) return $9481eb156b453e62$var$G.uninitializedWarning("posthog.capture");
                if (!$9481eb156b453e62$var$Kn(this)) {
                    var o = (i = i || $9481eb156b453e62$var$bi).transport;
                    if (o && (i.transport = o), !$9481eb156b453e62$var$E(e) && $9481eb156b453e62$var$x(e)) {
                        if (!$9481eb156b453e62$var$V || this.config.opt_out_useragent_filter || !$9481eb156b453e62$var$mi($9481eb156b453e62$var$V, this.config.custom_blocked_useragents)) {
                            this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info();
                            var s = {
                                uuid: $9481eb156b453e62$var$lt(),
                                event: e,
                                properties: this._calculate_event_properties(e, n || {})
                            };
                            "$identify" === e && (s.$set = i.$set, s.$set_once = i.$set_once), (s = $9481eb156b453e62$var$oe(s, i._noTruncate ? null : this.config.properties_string_max_length)).timestamp = i.timestamp || new Date, $9481eb156b453e62$var$E(i.timestamp) || (s.properties.$event_time_override_provided = !0, s.properties.$event_time_override_system_time = new Date);
                            var a = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, s.properties.$set), s.$set);
                            (function(e) {
                                if ($9481eb156b453e62$var$P(e)) {
                                    for(var t in e)if ($9481eb156b453e62$var$w.call(e, t)) return !1;
                                    return !0;
                                }
                                return !1;
                            })(a) || this.setPersonPropertiesForFlags(a), $9481eb156b453e62$var$G.info("send", s);
                            var u = JSON.stringify(s), l = null !== (r = i._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), c = i !== $9481eb156b453e62$var$bi;
                            return !this.config.request_batching || c && !i._batchKey || i.send_instantly ? this.__compress_and_send_json_request(l, u, i) : this._requestQueue.enqueue(l, s, i), this._invokeCaptureHooks(e, s), s;
                        }
                    } else $9481eb156b453e62$var$G.error("No event name provided to posthog.capture");
                }
            }
        },
        {
            key: "_addCaptureHook",
            value: function(e) {
                this.__captureHooks.push(e);
            }
        },
        {
            key: "_invokeCaptureHooks",
            value: function(e, t) {
                this.config._onCapture(e, t), $9481eb156b453e62$var$K(this.__captureHooks, function(t) {
                    return t(e);
                });
            }
        },
        {
            key: "_calculate_event_properties",
            value: function(e, n) {
                if (!this.persistence || !this.sessionPersistence) return n;
                var r = this.persistence.remove_event_timer(e), i = $9481eb156b453e62$var$t({}, n);
                if (i.token = this.config.token, "$snapshot" === e) {
                    var o = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.persistence.properties()), this.sessionPersistence.properties());
                    return i.distinct_id = o.distinct_id, i;
                }
                var s = $9481eb156b453e62$var$In.properties();
                if (this.sessionManager) {
                    var a = this.sessionManager.checkAndGetSessionAndWindowId(), u = a.sessionId, l = a.windowId;
                    i.$session_id = u, i.$window_id = l;
                }
                if (this.sessionPropsManager && this.config.__preview_send_client_session_params && ("$pageview" === e || "$pageleave" === e || "$autocapture" === e)) {
                    var c = this.sessionPropsManager.getSessionProps();
                    i = $9481eb156b453e62$var$X(i, c);
                }
                if (!this.config.disable_scroll_properties) {
                    var d = {};
                    "$pageview" === e ? d = this.pageViewManager.doPageView() : "$pageleave" === e && (d = this.pageViewManager.doPageLeave()), i = $9481eb156b453e62$var$X(i, d);
                }
                if ("$pageview" === e && $9481eb156b453e62$var$B && (i.title = $9481eb156b453e62$var$B.title), "$performance_event" === e) {
                    var f = this.persistence.properties();
                    return i.distinct_id = f.distinct_id, i.$current_url = s.$current_url, i;
                }
                if (!$9481eb156b453e62$var$E(r)) {
                    var h = (new Date).getTime() - r;
                    i.$duration = parseFloat((h / 1e3).toFixed(3));
                }
                ($9481eb156b453e62$var$V && this.config.opt_out_useragent_filter && (i.$browser_type = $9481eb156b453e62$var$mi($9481eb156b453e62$var$V, this.config.custom_blocked_useragents) ? "bot" : "browser"), i = $9481eb156b453e62$var$X({}, $9481eb156b453e62$var$In.properties(), this.persistence.properties(), this.sessionPersistence.properties(), i), $9481eb156b453e62$var$S(this.config.property_denylist) && $9481eb156b453e62$var$S(this.config.property_blacklist)) ? $9481eb156b453e62$var$K([].concat($9481eb156b453e62$var$p(this.config.property_blacklist), $9481eb156b453e62$var$p(this.config.property_denylist)), function(e) {
                    delete i[e];
                }) : $9481eb156b453e62$var$G.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
                var _ = this.config.sanitize_properties;
                return _ && (i = _(i, e)), i;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n;
                null === (n = this.persistence) || void 0 === n || n.register(e, t);
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var r;
                null === (r = this.persistence) || void 0 === r || r.register_once(e, t, n);
            }
        },
        {
            key: "register_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.register(e);
            }
        },
        {
            key: "unregister",
            value: function(e) {
                var t;
                null === (t = this.persistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "unregister_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "_register_single",
            value: function(e, t) {
                this.register($9481eb156b453e62$var$s({}, e, t));
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e, t) {
                return this.featureFlags.getFeatureFlag(e, t);
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                var t = this.featureFlags.getFeatureFlagPayload(e);
                try {
                    return JSON.parse(t);
                } catch (e) {
                    return t;
                }
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e, t) {
                return this.featureFlags.isFeatureEnabled(e, t);
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.featureFlags.reloadFeatureFlags();
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, t) {
                this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t);
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.featureFlags.getEarlyAccessFeatures(e, t);
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                return this.featureFlags.onFeatureFlags(e);
            }
        },
        {
            key: "onSessionId",
            value: function(e) {
                var t, n;
                return null !== (t = null === (n = this.sessionManager) || void 0 === n ? void 0 : n.onSessionId(e)) && void 0 !== t ? t : function() {};
            }
        },
        {
            key: "getSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getSurveys(e, t);
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getActiveMatchingSurveys(e, t);
            }
        },
        {
            key: "identify",
            value: function(e, t, n) {
                if (!this.__loaded || !this.persistence) return $9481eb156b453e62$var$G.uninitializedWarning("posthog.identify");
                if ($9481eb156b453e62$var$T(e) && (e = e.toString(), $9481eb156b453e62$var$G.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), e) {
                    if ([
                        "distinct_id",
                        "distinctid"
                    ].includes(e.toLowerCase())) $9481eb156b453e62$var$G.critical('The string "'.concat(e, '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));
                    else {
                        var r = this.get_distinct_id();
                        if (this.register({
                            $user_id: e
                        }), !this.get_property("$device_id")) {
                            var i = r;
                            this.register_once({
                                $had_persisted_distinct_id: !0,
                                $device_id: i
                            }, "");
                        }
                        e !== r && e !== this.get_property($9481eb156b453e62$var$Ce) && (this.unregister($9481eb156b453e62$var$Ce), this.register({
                            distinct_id: e
                        }));
                        var o = "anonymous" === this.persistence.get_user_state();
                        e !== r && o ? (this.persistence.set_user_state("identified"), this.setPersonPropertiesForFlags(t || {}, !1), this.capture("$identify", {
                            distinct_id: e,
                            $anon_distinct_id: r
                        }, {
                            $set: t || {},
                            $set_once: n || {}
                        }), this.featureFlags.setAnonymousDistinctId(r)) : (t || n) && this.setPersonProperties(t, n), e !== r && (this.reloadFeatureFlags(), this.unregister($9481eb156b453e62$var$We));
                    }
                } else $9481eb156b453e62$var$G.error("Unique user id has not been set in posthog.identify");
            }
        },
        {
            key: "setPersonProperties",
            value: function(e, t) {
                (e || t) && (this.setPersonPropertiesForFlags(e || {}), this.capture("$set", {
                    $set: e || {},
                    $set_once: t || {}
                }));
            }
        },
        {
            key: "group",
            value: function(e, n, r) {
                if (e && n) {
                    var i = this.getGroups();
                    i[e] !== n && this.resetGroupPropertiesForFlags(e), this.register({
                        $groups: $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, i), {}, $9481eb156b453e62$var$s({}, e, n))
                    }), r && (this.capture("$groupidentify", {
                        $group_type: e,
                        $group_key: n,
                        $group_set: r
                    }), this.setGroupPropertiesForFlags($9481eb156b453e62$var$s({}, e, r))), i[e] === n || r || this.reloadFeatureFlags();
                } else $9481eb156b453e62$var$G.error("posthog.group requires a group type and group key");
            }
        },
        {
            key: "resetGroups",
            value: function() {
                this.register({
                    $groups: {}
                }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.featureFlags.setPersonPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.featureFlags.resetPersonPropertiesForFlags();
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.featureFlags.setGroupPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                this.featureFlags.resetGroupPropertiesForFlags(e);
            }
        },
        {
            key: "reset",
            value: function(e) {
                var t, n, r, i;
                if (!this.__loaded) return $9481eb156b453e62$var$G.uninitializedWarning("posthog.reset");
                var o = this.get_property("$device_id");
                null === (t = this.persistence) || void 0 === t || t.clear(), null === (n = this.sessionPersistence) || void 0 === n || n.clear(), null === (r = this.persistence) || void 0 === r || r.set_user_state("anonymous"), null === (i = this.sessionManager) || void 0 === i || i.resetSessionId();
                var s = this.config.get_device_id($9481eb156b453e62$var$lt());
                this.register_once({
                    distinct_id: s,
                    $device_id: e ? s : o
                }, "");
            }
        },
        {
            key: "get_distinct_id",
            value: function() {
                return this.get_property("distinct_id");
            }
        },
        {
            key: "getGroups",
            value: function() {
                return this.get_property("$groups") || {};
            }
        },
        {
            key: "get_session_id",
            value: function() {
                var e, t;
                return null !== (e = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== e ? e : "";
            }
        },
        {
            key: "get_session_replay_url",
            value: function(e) {
                if (!this.sessionManager) return "";
                var t = this.sessionManager.checkAndGetSessionAndWindowId(!0), n = t.sessionId, r = t.sessionStartTimestamp, i = this.requestRouter.endpointFor("ui", "/replay/" + n);
                if (null != e && e.withTimestamp && r) {
                    var o, s = null !== (o = e.timestampLookBack) && void 0 !== o ? o : 10;
                    if (!r) return i;
                    var a = Math.max(Math.floor(((new Date).getTime() - r) / 1e3) - s, 0);
                    i += "?t=".concat(a);
                }
                return i;
            }
        },
        {
            key: "alias",
            value: function(e, t) {
                return e === this.get_property($9481eb156b453e62$var$Ie) ? ($9481eb156b453e62$var$G.critical("Attempting to create alias for existing People user - aborting."), -2) : ($9481eb156b453e62$var$E(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single($9481eb156b453e62$var$Ce, e), this.capture("$create_alias", {
                    alias: e,
                    distinct_id: t
                })) : ($9481eb156b453e62$var$G.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1));
            }
        },
        {
            key: "set_config",
            value: function(e) {
                var n, r = $9481eb156b453e62$var$t({}, this.config);
                if ($9481eb156b453e62$var$P(e) && ($9481eb156b453e62$var$X(this.config, e), this.config.persistence_name || (this.config.persistence_name = this.config.cookie_name), this.config.disable_persistence || (this.config.disable_persistence = this.config.disable_cookie), null === (n = this.persistence) || void 0 === n || n.update_config(this.config, r), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $9481eb156b453e62$var$Tn($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                })), $9481eb156b453e62$var$mt.is_supported() && "true" === $9481eb156b453e62$var$mt.get("ph_debug") && (this.config.debug = !0), this.config.debug && ($9481eb156b453e62$var$m.DEBUG = !0), this.sessionRecording && !$9481eb156b453e62$var$E(e.disable_session_recording))) {
                    var i = r.disable_session_recording !== e.disable_session_recording, o = !$9481eb156b453e62$var$Kn(this) && !e.disable_session_recording && !this.sessionRecording.started;
                    (i || o) && (e.disable_session_recording ? this.sessionRecording.stopRecording() : this.sessionRecording.startRecordingIfEnabled());
                }
            }
        },
        {
            key: "startSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !1
                });
            }
        },
        {
            key: "stopSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !0
                });
            }
        },
        {
            key: "sessionRecordingStarted",
            value: function() {
                var e;
                return !(null === (e = this.sessionRecording) || void 0 === e || !e.started);
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                return this.toolbar.loadToolbar(e);
            }
        },
        {
            key: "get_property",
            value: function(e) {
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "getSessionProperty",
            value: function(e) {
                var t;
                return null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "toString",
            value: function() {
                var e, t = null !== (e = this.config.name) && void 0 !== e ? e : $9481eb156b453e62$var$wi;
                return t !== $9481eb156b453e62$var$wi && (t = $9481eb156b453e62$var$wi + "." + t), t;
            }
        },
        {
            key: "_gdpr_init",
            value: function() {
                "localStorage" === this.config.opt_out_capturing_persistence_type && $9481eb156b453e62$var$mt.is_supported() && (!this.has_opted_in_capturing() && this.has_opted_in_capturing({
                    persistence_type: "cookie"
                }) && this.opt_in_capturing({
                    enable_persistence: !1
                }), !this.has_opted_out_capturing() && this.has_opted_out_capturing({
                    persistence_type: "cookie"
                }) && this.opt_out_capturing({
                    clear_persistence: !1
                }), this.clear_opt_in_out_capturing({
                    persistence_type: "cookie",
                    enable_persistence: !1
                })), this.has_opted_out_capturing() ? this._gdpr_update_persistence({
                    clear_persistence: !0
                }) : this.has_opted_in_capturing() || !this.config.opt_out_capturing_by_default && !$9481eb156b453e62$var$gt.get("ph_optout") || ($9481eb156b453e62$var$gt.remove("ph_optout"), this.opt_out_capturing({
                    clear_persistence: this.config.opt_out_persistence_by_default
                }));
            }
        },
        {
            key: "_gdpr_update_persistence",
            value: function(e) {
                var t, n, r, i, o;
                if (e && e.clear_persistence) r = !0;
                else {
                    if (!e || !e.enable_persistence) return;
                    r = !1;
                }
                this.config.disable_persistence || (null === (t = this.persistence) || void 0 === t ? void 0 : t.disabled) === r || null === (i = this.persistence) || void 0 === i || i.set_disabled(r);
                this.config.disable_persistence || (null === (n = this.sessionPersistence) || void 0 === n ? void 0 : n.disabled) === r || null === (o = this.sessionPersistence) || void 0 === o || o.set_disabled(r);
            }
        },
        {
            key: "_gdpr_call_func",
            value: function(e, t) {
                return t = $9481eb156b453e62$var$X({
                    capture: this.capture.bind(this),
                    persistence_type: this.config.opt_out_capturing_persistence_type,
                    cookie_prefix: this.config.opt_out_capturing_cookie_prefix,
                    cookie_expiration: this.config.cookie_expiration,
                    cross_subdomain_cookie: this.config.cross_subdomain_cookie,
                    secure_cookie: this.config.secure_cookie
                }, t || {}), $9481eb156b453e62$var$mt.is_supported() || "localStorage" !== t.persistence_type || (t.persistence_type = "cookie"), e(this.config.token, {
                    capture: t.capture,
                    captureEventName: t.capture_event_name,
                    captureProperties: t.capture_properties,
                    persistenceType: t.persistence_type,
                    persistencePrefix: t.cookie_prefix,
                    cookieExpiration: t.cookie_expiration,
                    crossSubdomainCookie: t.cross_subdomain_cookie,
                    secureCookie: t.secure_cookie
                });
            }
        },
        {
            key: "opt_in_capturing",
            value: function(e) {
                e = $9481eb156b453e62$var$X({
                    enable_persistence: !0
                }, e || {}), this._gdpr_call_func($9481eb156b453e62$var$Hn, e), this._gdpr_update_persistence(e);
            }
        },
        {
            key: "opt_out_capturing",
            value: function(e) {
                var t = $9481eb156b453e62$var$X({
                    clear_persistence: !0
                }, e || {});
                this._gdpr_call_func($9481eb156b453e62$var$Un, t), this._gdpr_update_persistence(t);
            }
        },
        {
            key: "has_opted_in_capturing",
            value: function(e) {
                return this._gdpr_call_func($9481eb156b453e62$var$Vn, e);
            }
        },
        {
            key: "has_opted_out_capturing",
            value: function(e) {
                return this._gdpr_call_func($9481eb156b453e62$var$Wn, e);
            }
        },
        {
            key: "clear_opt_in_out_capturing",
            value: function(e) {
                var t = $9481eb156b453e62$var$X({
                    enable_persistence: !0
                }, null != e ? e : {});
                this._gdpr_call_func($9481eb156b453e62$var$zn, t), this._gdpr_update_persistence(t);
            }
        },
        {
            key: "debug",
            value: function(e) {
                !1 === e ? (null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
                    debug: !1
                })) : (null == $9481eb156b453e62$var$A || $9481eb156b453e62$var$A.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
                    debug: !0
                }));
            }
        }
    ]), e;
}();
!function(e, t) {
    for(var n = 0; n < t.length; n++)e.prototype[t[n]] = $9481eb156b453e62$var$re(e.prototype[t[n]]);
}($9481eb156b453e62$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $9481eb156b453e62$export$22779822dd24228f, $9481eb156b453e62$export$9c2ac61661d417f8, $9481eb156b453e62$var$Ii = {}, $9481eb156b453e62$var$Ci = function() {
    $9481eb156b453e62$var$di.init = function(e, t, n) {
        if (n) return $9481eb156b453e62$var$di[n] || ($9481eb156b453e62$var$di[n] = $9481eb156b453e62$var$Ii[n] = $9481eb156b453e62$var$Fi(e || "", t || {}, n, function(e) {
            $9481eb156b453e62$var$di[n] = $9481eb156b453e62$var$Ii[n] = e, e._loaded();
        })), $9481eb156b453e62$var$di[n];
        var r = $9481eb156b453e62$var$di;
        return $9481eb156b453e62$var$Ii[$9481eb156b453e62$var$wi] ? r = $9481eb156b453e62$var$Ii[$9481eb156b453e62$var$wi] : e && (r = $9481eb156b453e62$var$Fi(e, t || {}, $9481eb156b453e62$var$wi, function(e) {
            $9481eb156b453e62$var$Ii[$9481eb156b453e62$var$wi] = e, e._loaded();
        }), $9481eb156b453e62$var$Ii[$9481eb156b453e62$var$wi] = r), $9481eb156b453e62$var$di = r, $9481eb156b453e62$var$ci === $9481eb156b453e62$var$li.INIT_SNIPPET && ($9481eb156b453e62$var$W[$9481eb156b453e62$var$wi] = $9481eb156b453e62$var$di), $9481eb156b453e62$var$K($9481eb156b453e62$var$Ii, function(e, t) {
            t !== $9481eb156b453e62$var$wi && ($9481eb156b453e62$var$di[t] = e);
        }), r;
    };
};
!function(e) {
    e.Popover = "popover", e.API = "api", e.Widget = "widget";
}($9481eb156b453e62$export$22779822dd24228f || ($9481eb156b453e62$export$22779822dd24228f = {})), function(e) {
    e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}($9481eb156b453e62$export$9c2ac61661d417f8 || ($9481eb156b453e62$export$9c2ac61661d417f8 = {}));
var $9481eb156b453e62$export$2e2bcd8739ae039 = ($9481eb156b453e62$var$ci = $9481eb156b453e62$var$li.INIT_MODULE, $9481eb156b453e62$var$di = new $9481eb156b453e62$export$a9d6b9cbf49b8241, $9481eb156b453e62$var$Ci(), $9481eb156b453e62$var$di.init(), function() {
    function e() {
        e.done || (e.done = !0, $9481eb156b453e62$var$ki = !1, $9481eb156b453e62$var$K($9481eb156b453e62$var$Ii, function(e) {
            e._dom_loaded();
        }));
    }
    null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.addEventListener && ("complete" === $9481eb156b453e62$var$B.readyState ? e() : $9481eb156b453e62$var$B.addEventListener("DOMContentLoaded", e, !1)), $9481eb156b453e62$var$A && $9481eb156b453e62$var$ue($9481eb156b453e62$var$A, "load", e, !0);
}(), $9481eb156b453e62$var$di);


if (!window.location.host.includes("127.0.0.1") && !window.location.host.includes("localhost") && !window.location.host.includes("staging")) (0, $9481eb156b453e62$export$2e2bcd8739ae039).init("phc_U5wf8eE3C6ZnljKfBddtbge9MAbZnR5gJKXCBVeOyW0", {
    api_host: "https://eu.posthog.com",
    persistence: "memory",
    autocapture: false
});


//# sourceMappingURL=index.c8b59754.js.map
